var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTexture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 667,
    viewBox: "0 0 375 667",
    id: "svg2217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs836"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-texture-mezzoforte-mubia_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    id: "rect833"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "texture-mezzoforte-mubia_50",
    "data-name": "texture-mezzoforte-mubia \\u2013 50",
    clipPath: "url(#clip-texture-mezzoforte-mubia_50)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    fill: "#fff",
    id: "rect838",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_2042",
    "data-name": "Rettangolo 2042",
    transform: "translate(-45 -38)",
    fill: "#dbd7d0",
    stroke: "#707070",
    strokeWidth: 1,
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 459,
    height: 740,
    stroke: "none",
    id: "rect840",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 458,
    height: 739,
    fill: "none",
    id: "rect842",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3570",
    "data-name": "Raggruppa 3570",
    transform: "translate(505.698 -4548.706) rotate(90)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3224",
    "data-name": "Raggruppa 3224",
    transform: "translate(4475.706 257.886)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2965",
    "data-name": "Raggruppa 2965",
    transform: "translate(0.072 12.882)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2880",
    "data-name": "Raggruppa 2880",
    transform: "translate(31.863)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4052",
    "data-name": "Tracciato 4052",
    d: "M4797.581,803.285a54.458,54.458,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.025,54.4,54.4,0,1,1-108.791-.025h1.56a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.4,54.4,0,0,1,108.791.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.458,54.458,0,0,1,4797.581,803.285Z",
    transform: "translate(-4528.735 -694.471)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2881",
    "data-name": "Raggruppa 2881",
    transform: "translate(30.5 3.438)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4053",
    "data-name": "Tracciato 4053",
    d: "M4795.315,808.994a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025H4955.4a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,4795.315,808.994Z",
    transform: "translate(-4526.473 -700.18)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2882",
    "data-name": "Raggruppa 2882",
    transform: "translate(29.135 6.874)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4054",
    "data-name": "Tracciato 4054",
    d: "M4793.05,814.7a54.458,54.458,0,0,1-54.383-54.406A52.836,52.836,0,1,0,4633,760.269a54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,4793.05,814.7Z",
    transform: "translate(-4524.207 -705.886)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2883",
    "data-name": "Raggruppa 2883",
    transform: "translate(27.771 10.312)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4055",
    "data-name": "Tracciato 4055",
    d: "M4790.785,820.409A54.458,54.458,0,0,1,4736.4,766a52.836,52.836,0,1,0-105.671-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.025A54.395,54.395,0,1,1,4737.96,766a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4790.785,820.409Z",
    transform: "translate(-4521.941 -711.595)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2884",
    "data-name": "Raggruppa 2884",
    transform: "translate(26.408 13.75)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4056",
    "data-name": "Tracciato 4056",
    d: "M4788.52,826.118a54.455,54.455,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025H4948.6a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,4788.52,826.118Z",
    transform: "translate(-4519.678 -717.304)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2885",
    "data-name": "Raggruppa 2885",
    transform: "translate(25.043 17.188)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4057",
    "data-name": "Tracciato 4057",
    d: "M4786.254,831.827a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4786.254,831.827Z",
    transform: "translate(-4517.412 -723.013)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2886",
    "data-name": "Raggruppa 2886",
    transform: "translate(23.679 20.626)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4058",
    "data-name": "Tracciato 4058",
    d: "M4783.99,837.536a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,4783.99,837.536Z",
    transform: "translate(-4515.146 -728.722)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2887",
    "data-name": "Raggruppa 2887",
    transform: "translate(22.316 24.063)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4059",
    "data-name": "Tracciato 4059",
    d: "M4781.725,843.243a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.673.024,54.395,54.395,0,1,1,108.789.025h-1.56a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4781.725,843.243Z",
    transform: "translate(-4512.883 -734.429)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2888",
    "data-name": "Raggruppa 2888",
    transform: "translate(20.951 27.501)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4060",
    "data-name": "Tracciato 4060",
    d: "M4779.459,848.951a54.455,54.455,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4779.459,848.951Z",
    transform: "translate(-4510.617 -740.138)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2889",
    "data-name": "Raggruppa 2889",
    transform: "translate(19.587 30.939)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4061",
    "data-name": "Tracciato 4061",
    d: "M4777.194,854.661a54.457,54.457,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.67-.024A54.458,54.458,0,0,1,4777.194,854.661Z",
    transform: "translate(-4508.352 -745.847)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2890",
    "data-name": "Raggruppa 2890",
    transform: "translate(18.222 34.377)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4062",
    "data-name": "Tracciato 4062",
    d: "M4774.929,860.37a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,4774.929,860.37Z",
    transform: "translate(-4506.085 -751.556)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2891",
    "data-name": "Raggruppa 2891",
    transform: "translate(16.859 37.815)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4063",
    "data-name": "Tracciato 4063",
    d: "M4772.663,866.079a54.458,54.458,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.67-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.67.025,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4772.663,866.079Z",
    transform: "translate(-4503.821 -757.265)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2892",
    "data-name": "Raggruppa 2892",
    transform: "translate(15.494 41.251)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4064",
    "data-name": "Tracciato 4064",
    d: "M4770.4,871.785a54.455,54.455,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.559A52.836,52.836,0,1,0,4824.8,817.4,54.455,54.455,0,0,1,4770.4,871.785Z",
    transform: "translate(-4501.556 -762.971)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2893",
    "data-name": "Raggruppa 2893",
    transform: "translate(14.13 44.689)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4065",
    "data-name": "Tracciato 4065",
    d: "M4768.134,877.494a54.457,54.457,0,0,1-54.384-54.406,52.835,52.835,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.673.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.673-.024A54.454,54.454,0,0,1,4768.134,877.494Z",
    transform: "translate(-4499.29 -768.68)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2894",
    "data-name": "Raggruppa 2894",
    transform: "translate(12.767 48.127)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4066",
    "data-name": "Tracciato 4066",
    d: "M4765.868,883.2a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,4765.868,883.2Z",
    transform: "translate(-4497.025 -774.389)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2895",
    "data-name": "Raggruppa 2895",
    transform: "translate(11.402 51.565)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4067",
    "data-name": "Tracciato 4067",
    d: "M4763.6,888.912A54.458,54.458,0,0,1,4709.22,834.5a52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4763.6,888.912Z",
    transform: "translate(-4494.76 -780.098)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2896",
    "data-name": "Raggruppa 2896",
    transform: "translate(10.038 55.003)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4068",
    "data-name": "Tracciato 4068",
    d: "M4761.338,894.621a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4761.338,894.621Z",
    transform: "translate(-4492.495 -785.807)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2897",
    "data-name": "Raggruppa 2897",
    transform: "translate(8.675 58.44)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4069",
    "data-name": "Tracciato 4069",
    d: "M4759.073,900.328a54.457,54.457,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.56a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4759.073,900.328Z",
    transform: "translate(-4490.231 -791.514)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2898",
    "data-name": "Raggruppa 2898",
    transform: "translate(7.31 61.878)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4070",
    "data-name": "Tracciato 4070",
    d: "M4756.809,906.037a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,4756.809,906.037Z",
    transform: "translate(-4487.965 -797.223)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2899",
    "data-name": "Raggruppa 2899",
    transform: "translate(5.946 65.316)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4071",
    "data-name": "Tracciato 4071",
    d: "M4754.542,911.746a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.557a52.836,52.836,0,1,0,105.673.025,54.395,54.395,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4754.542,911.746Z",
    transform: "translate(-4485.699 -802.932)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2900",
    "data-name": "Raggruppa 2900",
    transform: "translate(4.583 68.754)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4072",
    "data-name": "Tracciato 4072",
    d: "M4752.278,917.455a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025A54.394,54.394,0,1,1,4483.436,863H4485a52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.458,54.458,0,0,1,4752.278,917.455Z",
    transform: "translate(-4483.436 -808.641)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2901",
    "data-name": "Raggruppa 2901",
    transform: "translate(3.218 72.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4073",
    "data-name": "Tracciato 4073",
    d: "M4750.013,923.164a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.673-.025A54.455,54.455,0,0,1,4750.013,923.164Z",
    transform: "translate(-4481.17 -814.35)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2902",
    "data-name": "Raggruppa 2902",
    transform: "translate(4.581 76.053)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4074",
    "data-name": "Tracciato 4074",
    d: "M4752.274,929.576a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.025A54.457,54.457,0,0,1,4752.274,929.576Z",
    transform: "translate(-4483.434 -820.762)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2903",
    "data-name": "Raggruppa 2903",
    transform: "translate(5.942 79.917)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4075",
    "data-name": "Tracciato 4075",
    d: "M4754.537,935.992a54.457,54.457,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4754.537,935.992Z",
    transform: "translate(-4485.694 -827.178)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2904",
    "data-name": "Raggruppa 2904",
    transform: "translate(7.305 83.78)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4076",
    "data-name": "Tracciato 4076",
    d: "M4756.8,942.407A54.458,54.458,0,0,1,4702.417,888a52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.458,54.458,0,0,1,4756.8,942.407Z",
    transform: "translate(-4487.958 -833.593)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2905",
    "data-name": "Raggruppa 2905",
    transform: "translate(8.668 87.644)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4077",
    "data-name": "Tracciato 4077",
    d: "M4759.062,948.822a54.455,54.455,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4759.062,948.822Z",
    transform: "translate(-4490.22 -840.008)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2906",
    "data-name": "Raggruppa 2906",
    transform: "translate(10.029 91.506)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4078",
    "data-name": "Tracciato 4078",
    d: "M4761.324,955.235a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,1,1,108.79.025H4921.4a52.836,52.836,0,1,0-105.673-.024A54.456,54.456,0,0,1,4761.324,955.235Z",
    transform: "translate(-4492.48 -846.421)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2907",
    "data-name": "Raggruppa 2907",
    transform: "translate(11.393 95.369)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4079",
    "data-name": "Tracciato 4079",
    d: "M4763.587,961.65a54.457,54.457,0,0,1-54.382-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4763.587,961.65Z",
    transform: "translate(-4494.744 -852.836)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2908",
    "data-name": "Raggruppa 2908",
    transform: "translate(12.755 99.232)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4080",
    "data-name": "Tracciato 4080",
    d: "M4765.849,968.065a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4765.849,968.065Z",
    transform: "translate(-4497.007 -859.251)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2909",
    "data-name": "Raggruppa 2909",
    transform: "translate(14.116 103.095)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4081",
    "data-name": "Tracciato 4081",
    d: "M4768.111,974.48a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,4768.111,974.48Z",
    transform: "translate(-4499.267 -865.666)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2910",
    "data-name": "Raggruppa 2910",
    transform: "translate(15.479 106.957)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4082",
    "data-name": "Tracciato 4082",
    d: "M4770.374,980.893a54.458,54.458,0,0,1-54.384-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,4770.374,980.893Z",
    transform: "translate(-4501.53 -872.079)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2911",
    "data-name": "Raggruppa 2911",
    transform: "translate(16.842 110.82)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4083",
    "data-name": "Tracciato 4083",
    d: "M4772.636,987.308a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,4772.636,987.308Z",
    transform: "translate(-4503.794 -878.494)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2912",
    "data-name": "Raggruppa 2912",
    transform: "translate(18.204 114.683)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4084",
    "data-name": "Tracciato 4084",
    d: "M4774.9,993.723a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.561a52.835,52.835,0,0,0-105.671-.024A54.455,54.455,0,0,1,4774.9,993.723Z",
    transform: "translate(-4506.055 -884.909)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2913",
    "data-name": "Raggruppa 2913",
    transform: "translate(19.566 118.547)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4085",
    "data-name": "Tracciato 4085",
    d: "M4777.161,1000.139a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4777.161,1000.139Z",
    transform: "translate(-4508.317 -891.325)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2914",
    "data-name": "Raggruppa 2914",
    transform: "translate(20.929 122.41)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4086",
    "data-name": "Tracciato 4086",
    d: "M4779.422,1006.554a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.67-.025A54.458,54.458,0,0,1,4779.422,1006.554Z",
    transform: "translate(-4510.58 -897.74)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2915",
    "data-name": "Raggruppa 2915",
    transform: "translate(22.293 126.272)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4087",
    "data-name": "Tracciato 4087",
    d: "M4781.686,1012.966a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4781.686,1012.966Z",
    transform: "translate(-4512.844 -904.152)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2916",
    "data-name": "Raggruppa 2916",
    transform: "translate(23.653 130.135)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4088",
    "data-name": "Tracciato 4088",
    d: "M4783.948,1019.382a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025h-1.558A52.836,52.836,0,1,0,4838.354,965,54.458,54.458,0,0,1,4783.948,1019.382Z",
    transform: "translate(-4515.104 -910.568)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2917",
    "data-name": "Raggruppa 2917",
    transform: "translate(25.016 133.999)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4089",
    "data-name": "Tracciato 4089",
    d: "M4786.209,1025.8a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.025A54.456,54.456,0,0,1,4786.209,1025.8Z",
    transform: "translate(-4517.368 -916.983)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2918",
    "data-name": "Raggruppa 2918",
    transform: "translate(26.379 137.862)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4090",
    "data-name": "Tracciato 4090",
    d: "M4788.472,1032.212a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4788.472,1032.212Z",
    transform: "translate(-4519.63 -923.398)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2919",
    "data-name": "Raggruppa 2919",
    transform: "translate(27.741 141.724)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4091",
    "data-name": "Tracciato 4091",
    d: "M4790.735,1038.625a54.457,54.457,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.56a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,4790.735,1038.625Z",
    transform: "translate(-4521.891 -929.811)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2920",
    "data-name": "Raggruppa 2920",
    transform: "translate(29.103 145.587)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4092",
    "data-name": "Tracciato 4092",
    d: "M4793,1045.04a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4793,1045.04Z",
    transform: "translate(-4524.153 -936.226)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2921",
    "data-name": "Raggruppa 2921",
    transform: "translate(30.466 149.45)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4093",
    "data-name": "Tracciato 4093",
    d: "M4795.259,1051.455a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024A54.394,54.394,0,1,1,4526.417,997h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,4795.259,1051.455Z",
    transform: "translate(-4526.417 -942.641)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2922",
    "data-name": "Raggruppa 2922",
    transform: "translate(31.828 153.313)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4094",
    "data-name": "Tracciato 4094",
    d: "M4797.521,1057.87a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025H4957.6a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4797.521,1057.87Z",
    transform: "translate(-4528.678 -949.056)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2923",
    "data-name": "Raggruppa 2923",
    transform: "translate(30.313 157.1)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4095",
    "data-name": "Tracciato 4095",
    d: "M4795.005,1064.158a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4795.005,1064.158Z",
    transform: "translate(-4526.163 -955.344)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2924",
    "data-name": "Raggruppa 2924",
    transform: "translate(28.797 160.887)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4096",
    "data-name": "Tracciato 4096",
    d: "M4792.487,1070.446a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4792.487,1070.446Z",
    transform: "translate(-4523.646 -961.632)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2925",
    "data-name": "Raggruppa 2925",
    transform: "translate(27.282 164.673)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4097",
    "data-name": "Tracciato 4097",
    d: "M4789.971,1076.734a54.458,54.458,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4789.971,1076.734Z",
    transform: "translate(-4521.129 -967.92)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2926",
    "data-name": "Raggruppa 2926",
    transform: "translate(25.766 168.459)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4098",
    "data-name": "Tracciato 4098",
    d: "M4787.455,1083.021a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.026h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4787.455,1083.021Z",
    transform: "translate(-4518.613 -974.207)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2927",
    "data-name": "Raggruppa 2927",
    transform: "translate(24.25 172.246)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4099",
    "data-name": "Tracciato 4099",
    d: "M4784.938,1089.309a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,1,0-105.671-.024A54.455,54.455,0,0,1,4784.938,1089.309Z",
    transform: "translate(-4516.095 -980.495)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2928",
    "data-name": "Raggruppa 2928",
    transform: "translate(22.735 176.033)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4100",
    "data-name": "Tracciato 4100",
    d: "M4782.421,1095.6a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025H4942.5a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4782.421,1095.6Z",
    transform: "translate(-4513.578 -986.783)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2929",
    "data-name": "Raggruppa 2929",
    transform: "translate(21.219 179.819)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4101",
    "data-name": "Tracciato 4101",
    d: "M4779.9,1101.885a54.457,54.457,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.024h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4779.9,1101.885Z",
    transform: "translate(-4511.062 -993.071)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2930",
    "data-name": "Raggruppa 2930",
    transform: "translate(19.704 183.605)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4102",
    "data-name": "Tracciato 4102",
    d: "M4777.387,1108.172a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,4777.387,1108.172Z",
    transform: "translate(-4508.545 -999.358)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2931",
    "data-name": "Raggruppa 2931",
    transform: "translate(18.187 187.392)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4103",
    "data-name": "Tracciato 4103",
    d: "M4774.87,1114.46a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.026,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4774.87,1114.46Z",
    transform: "translate(-4506.026 -1005.646)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2932",
    "data-name": "Raggruppa 2932",
    transform: "translate(16.671 191.179)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4104",
    "data-name": "Tracciato 4104",
    d: "M4772.354,1120.748a54.458,54.458,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.024h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,4772.354,1120.748Z",
    transform: "translate(-4503.51 -1011.934)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2933",
    "data-name": "Raggruppa 2933",
    transform: "translate(15.156 194.965)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4105",
    "data-name": "Tracciato 4105",
    d: "M4769.837,1127.035a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4769.837,1127.035Z",
    transform: "translate(-4500.994 -1018.222)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2934",
    "data-name": "Raggruppa 2934",
    transform: "translate(13.641 198.752)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4106",
    "data-name": "Tracciato 4106",
    d: "M4767.32,1133.323a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025H4927.4a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4767.32,1133.323Z",
    transform: "translate(-4498.479 -1024.509)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2935",
    "data-name": "Raggruppa 2935",
    transform: "translate(12.125 202.538)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4107",
    "data-name": "Tracciato 4107",
    d: "M4764.8,1139.611a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.026,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4764.8,1139.611Z",
    transform: "translate(-4495.961 -1030.797)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2936",
    "data-name": "Raggruppa 2936",
    transform: "translate(10.608 206.325)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4108",
    "data-name": "Tracciato 4108",
    d: "M4762.286,1145.9a54.456,54.456,0,0,1-54.382-54.408,52.837,52.837,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.788-.024H4495a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4762.286,1145.9Z",
    transform: "translate(-4493.442 -1037.085)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2937",
    "data-name": "Raggruppa 2937",
    transform: "translate(9.093 210.112)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4109",
    "data-name": "Tracciato 4109",
    d: "M4759.77,1152.187a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4759.77,1152.187Z",
    transform: "translate(-4490.926 -1043.373)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2938",
    "data-name": "Raggruppa 2938",
    transform: "translate(7.578 213.898)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4110",
    "data-name": "Tracciato 4110",
    d: "M4757.254,1158.474a54.458,54.458,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4757.254,1158.474Z",
    transform: "translate(-4488.41 -1049.66)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2939",
    "data-name": "Raggruppa 2939",
    transform: "translate(6.063 217.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4111",
    "data-name": "Tracciato 4111",
    d: "M4754.736,1164.762a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.456,54.456,0,0,1,4754.736,1164.762Z",
    transform: "translate(-4485.894 -1055.948)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2940",
    "data-name": "Raggruppa 2940",
    transform: "translate(4.547 221.471)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4112",
    "data-name": "Tracciato 4112",
    d: "M4752.219,1171.05a54.458,54.458,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025H4912.3a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4752.219,1171.05Z",
    transform: "translate(-4483.377 -1062.236)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2941",
    "data-name": "Raggruppa 2941",
    transform: "translate(3.031 225.257)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4113",
    "data-name": "Tracciato 4113",
    d: "M4749.7,1177.337a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4749.7,1177.337Z",
    transform: "translate(-4480.859 -1068.523)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2942",
    "data-name": "Raggruppa 2942",
    transform: "translate(1.515 229.044)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4114",
    "data-name": "Tracciato 4114",
    d: "M4747.186,1183.625a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.026,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.561a52.835,52.835,0,1,0-105.67-.024A54.457,54.457,0,0,1,4747.186,1183.625Z",
    transform: "translate(-4478.342 -1074.811)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2943",
    "data-name": "Raggruppa 2943",
    transform: "translate(0 232.831)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4115",
    "data-name": "Tracciato 4115",
    d: "M4744.67,1189.913a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4744.67,1189.913Z",
    transform: "translate(-4475.827 -1081.099)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2944",
    "data-name": "Raggruppa 2944",
    transform: "translate(1.513 236.618)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4116",
    "data-name": "Tracciato 4116",
    d: "M4747.183,1196.2a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.791.025,52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4747.183,1196.2Z",
    transform: "translate(-4478.339 -1087.388)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2945",
    "data-name": "Raggruppa 2945",
    transform: "translate(3.027 240.405)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4117",
    "data-name": "Tracciato 4117",
    d: "M4749.7,1202.491a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.025A54.458,54.458,0,0,1,4749.7,1202.491Z",
    transform: "translate(-4480.853 -1093.677)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2946",
    "data-name": "Raggruppa 2946",
    transform: "translate(4.542 244.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4118",
    "data-name": "Tracciato 4118",
    d: "M4752.211,1208.78a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,4752.211,1208.78Z",
    transform: "translate(-4483.369 -1099.966)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2947",
    "data-name": "Raggruppa 2947",
    transform: "translate(6.056 247.98)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4119",
    "data-name": "Tracciato 4119",
    d: "M4754.724,1215.069a54.458,54.458,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025H4914.8a52.837,52.837,0,0,0-105.673-.024A54.455,54.455,0,0,1,4754.724,1215.069Z",
    transform: "translate(-4485.882 -1106.255)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2948",
    "data-name": "Raggruppa 2948",
    transform: "translate(7.569 251.766)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4120",
    "data-name": "Tracciato 4120",
    d: "M4757.239,1221.357a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.024h1.559a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4757.239,1221.357Z",
    transform: "translate(-4488.395 -1112.543)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2949",
    "data-name": "Raggruppa 2949",
    transform: "translate(9.083 255.554)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4121",
    "data-name": "Tracciato 4121",
    d: "M4759.753,1227.646a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4759.753,1227.646Z",
    transform: "translate(-4490.91 -1118.832)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2950",
    "data-name": "Raggruppa 2950",
    transform: "translate(10.596 259.341)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4122",
    "data-name": "Tracciato 4122",
    d: "M4762.266,1233.935a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,4762.266,1233.935Z",
    transform: "translate(-4493.422 -1125.121)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2951",
    "data-name": "Raggruppa 2951",
    transform: "translate(12.112 263.128)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4123",
    "data-name": "Tracciato 4123",
    d: "M4764.78,1240.224a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.026h-1.558a52.836,52.836,0,0,0-105.671-.024A54.458,54.458,0,0,1,4764.78,1240.224Z",
    transform: "translate(-4495.938 -1131.41)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2952",
    "data-name": "Raggruppa 2952",
    transform: "translate(13.626 266.916)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4124",
    "data-name": "Tracciato 4124",
    d: "M4767.293,1246.513a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4767.293,1246.513Z",
    transform: "translate(-4498.452 -1137.699)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2953",
    "data-name": "Raggruppa 2953",
    transform: "translate(15.139 270.703)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4125",
    "data-name": "Tracciato 4125",
    d: "M4769.809,1252.8a54.456,54.456,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.025A54.455,54.455,0,0,1,4769.809,1252.8Z",
    transform: "translate(-4500.965 -1143.988)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2954",
    "data-name": "Raggruppa 2954",
    transform: "translate(16.652 274.49)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4126",
    "data-name": "Tracciato 4126",
    d: "M4772.322,1259.091a54.459,54.459,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025H4932.4a52.836,52.836,0,0,0-105.671-.025A54.458,54.458,0,0,1,4772.322,1259.091Z",
    transform: "translate(-4503.478 -1150.277)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2955",
    "data-name": "Raggruppa 2955",
    transform: "translate(18.166 278.277)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4127",
    "data-name": "Tracciato 4127",
    d: "M4774.836,1265.38a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.024h-1.558a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,4774.836,1265.38Z",
    transform: "translate(-4505.993 -1156.566)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2956",
    "data-name": "Raggruppa 2956",
    transform: "translate(19.681 282.065)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4128",
    "data-name": "Tracciato 4128",
    d: "M4777.35,1271.669a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4777.35,1271.669Z",
    transform: "translate(-4508.508 -1162.855)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2957",
    "data-name": "Raggruppa 2957",
    transform: "translate(21.195 285.852)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4129",
    "data-name": "Tracciato 4129",
    d: "M4779.863,1277.958a54.457,54.457,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4779.863,1277.958Z",
    transform: "translate(-4511.021 -1169.144)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2958",
    "data-name": "Raggruppa 2958",
    transform: "translate(22.708 289.639)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4130",
    "data-name": "Tracciato 4130",
    d: "M4782.377,1284.246a54.458,54.458,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.026h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.457,54.457,0,0,1,4782.377,1284.246Z",
    transform: "translate(-4513.534 -1175.432)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2959",
    "data-name": "Raggruppa 2959",
    transform: "translate(24.222 293.426)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4131",
    "data-name": "Tracciato 4131",
    d: "M4784.891,1290.535a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.791.025,52.836,52.836,0,0,0,105.671.025,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.673-.025A54.455,54.455,0,0,1,4784.891,1290.535Z",
    transform: "translate(-4516.048 -1181.721)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2960",
    "data-name": "Raggruppa 2960",
    transform: "translate(25.737 297.213)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4132",
    "data-name": "Tracciato 4132",
    d: "M4787.406,1296.824a54.455,54.455,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.025A54.457,54.457,0,0,1,4787.406,1296.824Z",
    transform: "translate(-4518.563 -1188.01)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2961",
    "data-name": "Raggruppa 2961",
    transform: "translate(27.251 301)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4133",
    "data-name": "Tracciato 4133",
    d: "M4789.919,1303.113a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.024H4950a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,4789.919,1303.113Z",
    transform: "translate(-4521.077 -1194.299)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2962",
    "data-name": "Raggruppa 2962",
    transform: "translate(28.764 304.788)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4134",
    "data-name": "Tracciato 4134",
    d: "M4792.432,1309.4A54.457,54.457,0,0,1,4738.051,1255a52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.67-.024A54.457,54.457,0,0,1,4792.432,1309.4Z",
    transform: "translate(-4523.59 -1200.588)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2963",
    "data-name": "Raggruppa 2963",
    transform: "translate(30.278 308.575)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4135",
    "data-name": "Tracciato 4135",
    d: "M4794.948,1315.691a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4794.948,1315.691Z",
    transform: "translate(-4526.104 -1206.877)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2964",
    "data-name": "Raggruppa 2964",
    transform: "translate(31.791 312.362)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4136",
    "data-name": "Tracciato 4136",
    d: "M4797.46,1321.98a54.457,54.457,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,4797.46,1321.98Z",
    transform: "translate(-4528.617 -1213.166)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3051",
    "data-name": "Raggruppa 3051",
    transform: "translate(0 328.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2966",
    "data-name": "Raggruppa 2966",
    transform: "translate(31.863)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4137",
    "data-name": "Tracciato 4137",
    d: "M4797.46,1326.557a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.026h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,4797.46,1326.557Z",
    transform: "translate(-4528.616 -1217.743)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2967",
    "data-name": "Raggruppa 2967",
    transform: "translate(30.5 3.438)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4138",
    "data-name": "Tracciato 4138",
    d: "M4795.194,1332.266a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4795.194,1332.266Z",
    transform: "translate(-4526.354 -1223.452)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2968",
    "data-name": "Raggruppa 2968",
    transform: "translate(29.135 6.875)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4139",
    "data-name": "Tracciato 4139",
    d: "M4792.928,1337.973a54.456,54.456,0,0,1-54.38-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.458,54.458,0,0,1,4792.928,1337.973Z",
    transform: "translate(-4524.087 -1229.159)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2969",
    "data-name": "Raggruppa 2969",
    transform: "translate(27.771 10.313)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4140",
    "data-name": "Tracciato 4140",
    d: "M4790.665,1343.682a54.456,54.456,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.026h1.56a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.788.025h-1.557a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4790.665,1343.682Z",
    transform: "translate(-4521.82 -1234.868)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2970",
    "data-name": "Raggruppa 2970",
    transform: "translate(26.407 13.751)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4141",
    "data-name": "Tracciato 4141",
    d: "M4788.4,1349.391a54.458,54.458,0,0,1-54.381-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.026h1.559a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.458,54.458,0,0,1,4788.4,1349.391Z",
    transform: "translate(-4519.557 -1240.577)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2971",
    "data-name": "Raggruppa 2971",
    transform: "translate(25.043 17.189)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4142",
    "data-name": "Tracciato 4142",
    d: "M4786.134,1355.1a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.791.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.457,54.457,0,0,1,4786.134,1355.1Z",
    transform: "translate(-4517.292 -1246.286)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2972",
    "data-name": "Raggruppa 2972",
    transform: "translate(23.679 20.627)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4143",
    "data-name": "Tracciato 4143",
    d: "M4783.869,1360.809a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.457,54.457,0,0,1,4783.869,1360.809Z",
    transform: "translate(-4515.026 -1251.995)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2973",
    "data-name": "Raggruppa 2973",
    transform: "translate(22.316 24.063)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4144",
    "data-name": "Tracciato 4144",
    d: "M4781.6,1366.515a54.456,54.456,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.79-.025h1.56a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025h-1.558a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4781.6,1366.515Z",
    transform: "translate(-4512.762 -1257.701)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2974",
    "data-name": "Raggruppa 2974",
    transform: "translate(20.951 27.501)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4145",
    "data-name": "Tracciato 4145",
    d: "M4779.338,1372.224a54.457,54.457,0,0,1-54.381-54.406,52.835,52.835,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,4779.338,1372.224Z",
    transform: "translate(-4510.496 -1263.41)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2975",
    "data-name": "Raggruppa 2975",
    transform: "translate(19.586 30.939)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4146",
    "data-name": "Tracciato 4146",
    d: "M4777.073,1377.933a54.456,54.456,0,0,1-54.382-54.406,52.835,52.835,0,1,0-105.671-.025,54.4,54.4,0,0,1-108.791-.025h1.56a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,4777.073,1377.933Z",
    transform: "translate(-4508.229 -1269.119)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2976",
    "data-name": "Raggruppa 2976",
    transform: "translate(18.222 34.377)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4147",
    "data-name": "Tracciato 4147",
    d: "M4774.808,1383.642a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.026h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4774.808,1383.642Z",
    transform: "translate(-4505.964 -1274.828)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2977",
    "data-name": "Raggruppa 2977",
    transform: "translate(16.859 37.815)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4148",
    "data-name": "Tracciato 4148",
    d: "M4772.543,1389.351a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4772.543,1389.351Z",
    transform: "translate(-4503.701 -1280.537)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2978",
    "data-name": "Raggruppa 2978",
    transform: "translate(15.494 41.252)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4149",
    "data-name": "Tracciato 4149",
    d: "M4770.28,1395.058a54.457,54.457,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,4770.28,1395.058Z",
    transform: "translate(-4501.436 -1286.244)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2979",
    "data-name": "Raggruppa 2979",
    transform: "translate(14.13 44.69)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4150",
    "data-name": "Tracciato 4150",
    d: "M4768.013,1400.766a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.026,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,4768.013,1400.766Z",
    transform: "translate(-4499.169 -1291.953)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2980",
    "data-name": "Raggruppa 2980",
    transform: "translate(12.767 48.128)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4151",
    "data-name": "Tracciato 4151",
    d: "M4765.749,1406.475a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4765.749,1406.475Z",
    transform: "translate(-4496.906 -1297.662)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2981",
    "data-name": "Raggruppa 2981",
    transform: "translate(11.402 51.566)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4152",
    "data-name": "Tracciato 4152",
    d: "M4763.484,1412.185a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4763.484,1412.185Z",
    transform: "translate(-4494.64 -1303.371)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2982",
    "data-name": "Raggruppa 2982",
    transform: "translate(10.038 55.004)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4153",
    "data-name": "Tracciato 4153",
    d: "M4761.218,1417.894a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025H4921.3a52.836,52.836,0,0,0-105.673-.024A54.456,54.456,0,0,1,4761.218,1417.894Z",
    transform: "translate(-4492.374 -1309.08)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2983",
    "data-name": "Raggruppa 2983",
    transform: "translate(8.675 58.44)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4154",
    "data-name": "Tracciato 4154",
    d: "M4758.954,1423.6a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025,52.835,52.835,0,0,0,105.671.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4758.954,1423.6Z",
    transform: "translate(-4490.111 -1314.786)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2984",
    "data-name": "Raggruppa 2984",
    transform: "translate(7.31 61.878)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4155",
    "data-name": "Tracciato 4155",
    d: "M4756.688,1429.308a54.455,54.455,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.79-.025h1.56a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.024h-1.559a52.836,52.836,0,1,0-105.671-.024A54.456,54.456,0,0,1,4756.688,1429.308Z",
    transform: "translate(-4487.845 -1320.495)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2985",
    "data-name": "Raggruppa 2985",
    transform: "translate(5.946 65.316)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4156",
    "data-name": "Tracciato 4156",
    d: "M4754.422,1435.018a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.026h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025H4914.5a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4754.422,1435.018Z",
    transform: "translate(-4485.579 -1326.204)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2986",
    "data-name": "Raggruppa 2986",
    transform: "translate(4.582 68.754)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4157",
    "data-name": "Tracciato 4157",
    d: "M4752.158,1440.727a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.026h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.026,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,4752.158,1440.727Z",
    transform: "translate(-4483.316 -1331.913)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2987",
    "data-name": "Raggruppa 2987",
    transform: "translate(3.217 72.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4158",
    "data-name": "Tracciato 4158",
    d: "M4749.892,1446.436a54.457,54.457,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.024,54.4,54.4,0,0,1-108.791-.026h1.56a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.458,54.458,0,0,1,4749.892,1446.436Z",
    transform: "translate(-4481.049 -1337.622)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2988",
    "data-name": "Raggruppa 2988",
    transform: "translate(4.581 76.054)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4159",
    "data-name": "Tracciato 4159",
    d: "M4752.154,1452.849a54.456,54.456,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4752.154,1452.849Z",
    transform: "translate(-4483.313 -1344.035)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2989",
    "data-name": "Raggruppa 2989",
    transform: "translate(5.942 79.917)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4160",
    "data-name": "Tracciato 4160",
    d: "M4754.417,1459.264a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.79-.025h1.559a52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025H4914.5a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,4754.417,1459.264Z",
    transform: "translate(-4485.573 -1350.45)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2990",
    "data-name": "Raggruppa 2990",
    transform: "translate(7.305 83.78)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4161",
    "data-name": "Tracciato 4161",
    d: "M4756.68,1465.679a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.026h1.558a52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.789.026,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,1,0-105.67-.024A54.457,54.457,0,0,1,4756.68,1465.679Z",
    transform: "translate(-4487.836 -1356.865)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2991",
    "data-name": "Raggruppa 2991",
    transform: "translate(8.668 87.644)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4162",
    "data-name": "Tracciato 4162",
    d: "M4758.942,1472.094a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.026,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4758.942,1472.094Z",
    transform: "translate(-4490.1 -1363.28)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2992",
    "data-name": "Raggruppa 2992",
    transform: "translate(10.029 91.506)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4163",
    "data-name": "Tracciato 4163",
    d: "M4761.2,1478.507a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,4761.2,1478.507Z",
    transform: "translate(-4492.359 -1369.693)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2993",
    "data-name": "Raggruppa 2993",
    transform: "translate(11.392 95.369)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4164",
    "data-name": "Tracciato 4164",
    d: "M4763.467,1484.922a54.458,54.458,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.671-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.025A54.456,54.456,0,0,1,4763.467,1484.922Z",
    transform: "translate(-4494.624 -1376.108)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2994",
    "data-name": "Raggruppa 2994",
    transform: "translate(12.755 99.232)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4165",
    "data-name": "Tracciato 4165",
    d: "M4765.728,1491.338a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.458,54.458,0,0,1,4765.728,1491.338Z",
    transform: "translate(-4496.886 -1382.524)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2995",
    "data-name": "Raggruppa 2995",
    transform: "translate(14.116 103.096)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4166",
    "data-name": "Tracciato 4166",
    d: "M4767.991,1497.753a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4767.991,1497.753Z",
    transform: "translate(-4499.147 -1388.939)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2996",
    "data-name": "Raggruppa 2996",
    transform: "translate(15.479 106.957)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4167",
    "data-name": "Tracciato 4167",
    d: "M4770.253,1504.165a54.457,54.457,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,4770.253,1504.165Z",
    transform: "translate(-4501.41 -1395.351)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2997",
    "data-name": "Raggruppa 2997",
    transform: "translate(16.842 110.821)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4168",
    "data-name": "Tracciato 4168",
    d: "M4772.515,1510.581a54.457,54.457,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.026h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.026h-1.559a52.836,52.836,0,1,0-105.673-.024A54.455,54.455,0,0,1,4772.515,1510.581Z",
    transform: "translate(-4503.673 -1401.767)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2998",
    "data-name": "Raggruppa 2998",
    transform: "translate(18.204 114.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4169",
    "data-name": "Tracciato 4169",
    d: "M4774.777,1517a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.024h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4774.777,1517Z",
    transform: "translate(-4505.934 -1408.182)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2999",
    "data-name": "Raggruppa 2999",
    transform: "translate(19.566 118.547)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4170",
    "data-name": "Tracciato 4170",
    d: "M4777.041,1523.411A54.457,54.457,0,0,1,4722.657,1469a52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4777.041,1523.411Z",
    transform: "translate(-4508.197 -1414.597)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3000",
    "data-name": "Raggruppa 3000",
    transform: "translate(20.929 122.41)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4171",
    "data-name": "Tracciato 4171",
    d: "M4779.3,1529.826a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4779.3,1529.826Z",
    transform: "translate(-4510.46 -1421.012)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3001",
    "data-name": "Raggruppa 3001",
    transform: "translate(22.292 126.272)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4172",
    "data-name": "Tracciato 4172",
    d: "M4781.564,1536.238a54.456,54.456,0,0,1-54.38-54.406,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.673-.024A54.456,54.456,0,0,1,4781.564,1536.238Z",
    transform: "translate(-4512.723 -1427.425)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3002",
    "data-name": "Raggruppa 3002",
    transform: "translate(23.653 130.135)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4173",
    "data-name": "Tracciato 4173",
    d: "M4783.828,1542.653a54.456,54.456,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025,52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.025A54.457,54.457,0,0,1,4783.828,1542.653Z",
    transform: "translate(-4514.984 -1433.84)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3003",
    "data-name": "Raggruppa 3003",
    transform: "translate(25.016 133.999)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4174",
    "data-name": "Tracciato 4174",
    d: "M4786.089,1549.069a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.557a52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4786.089,1549.069Z",
    transform: "translate(-4517.247 -1440.255)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3004",
    "data-name": "Raggruppa 3004",
    transform: "translate(26.379 137.862)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4175",
    "data-name": "Tracciato 4175",
    d: "M4788.353,1555.485a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4788.353,1555.485Z",
    transform: "translate(-4519.51 -1446.671)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3005",
    "data-name": "Raggruppa 3005",
    transform: "translate(27.741 141.724)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4176",
    "data-name": "Tracciato 4176",
    d: "M4790.614,1561.9a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.559a52.835,52.835,0,1,0-105.671-.025A54.457,54.457,0,0,1,4790.614,1561.9Z",
    transform: "translate(-4521.771 -1453.083)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3006",
    "data-name": "Raggruppa 3006",
    transform: "translate(29.104 145.587)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4177",
    "data-name": "Tracciato 4177",
    d: "M4792.876,1568.313a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.673-.024,54.394,54.394,0,0,1-108.788-.026h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.787.025h-1.557a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,4792.876,1568.313Z",
    transform: "translate(-4524.034 -1459.499)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3007",
    "data-name": "Raggruppa 3007",
    transform: "translate(30.466 149.451)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4178",
    "data-name": "Tracciato 4178",
    d: "M4795.14,1574.728a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.025A54.456,54.456,0,0,1,4795.14,1574.728Z",
    transform: "translate(-4526.297 -1465.914)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3008",
    "data-name": "Raggruppa 3008",
    transform: "translate(31.827 153.314)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4179",
    "data-name": "Tracciato 4179",
    d: "M4797.4,1581.143a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4797.4,1581.143Z",
    transform: "translate(-4528.558 -1472.329)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3009",
    "data-name": "Raggruppa 3009",
    transform: "translate(30.312 157.1)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4180",
    "data-name": "Tracciato 4180",
    d: "M4794.885,1587.431a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4794.885,1587.431Z",
    transform: "translate(-4526.041 -1478.617)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3010",
    "data-name": "Raggruppa 3010",
    transform: "translate(28.797 160.887)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4181",
    "data-name": "Tracciato 4181",
    d: "M4792.367,1593.718a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.671-.024A54.458,54.458,0,0,1,4792.367,1593.718Z",
    transform: "translate(-4523.524 -1484.904)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3011",
    "data-name": "Raggruppa 3011",
    transform: "translate(27.282 164.673)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4182",
    "data-name": "Tracciato 4182",
    d: "M4789.852,1600.005a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4789.852,1600.005Z",
    transform: "translate(-4521.009 -1491.192)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3012",
    "data-name": "Raggruppa 3012",
    transform: "translate(25.766 168.46)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4183",
    "data-name": "Tracciato 4183",
    d: "M4787.334,1606.294a54.458,54.458,0,0,1-54.381-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.458,54.458,0,0,1,4787.334,1606.294Z",
    transform: "translate(-4518.492 -1497.48)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3013",
    "data-name": "Raggruppa 3013",
    transform: "translate(24.25 172.247)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4184",
    "data-name": "Tracciato 4184",
    d: "M4784.818,1612.582a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025H4944.9a52.836,52.836,0,0,0-105.672-.025A54.459,54.459,0,0,1,4784.818,1612.582Z",
    transform: "translate(-4515.974 -1503.768)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3014",
    "data-name": "Raggruppa 3014",
    transform: "translate(22.734 176.033)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4185",
    "data-name": "Tracciato 4185",
    d: "M4782.3,1618.869a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.561a52.835,52.835,0,0,0-105.671-.024A54.456,54.456,0,0,1,4782.3,1618.869Z",
    transform: "translate(-4513.457 -1510.055)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3015",
    "data-name": "Raggruppa 3015",
    transform: "translate(21.219 179.819)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4186",
    "data-name": "Tracciato 4186",
    d: "M4779.783,1625.157a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4779.783,1625.157Z",
    transform: "translate(-4510.941 -1516.343)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3016",
    "data-name": "Raggruppa 3016",
    transform: "translate(19.704 183.606)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4187",
    "data-name": "Tracciato 4187",
    d: "M4777.267,1631.445a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,4777.267,1631.445Z",
    transform: "translate(-4508.425 -1522.631)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3017",
    "data-name": "Raggruppa 3017",
    transform: "translate(18.187 187.393)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4188",
    "data-name": "Tracciato 4188",
    d: "M4774.75,1637.733a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.024,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4774.75,1637.733Z",
    transform: "translate(-4505.906 -1528.919)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3018",
    "data-name": "Raggruppa 3018",
    transform: "translate(16.672 191.179)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4189",
    "data-name": "Tracciato 4189",
    d: "M4772.233,1644.019a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4772.233,1644.019Z",
    transform: "translate(-4503.391 -1535.206)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3019",
    "data-name": "Raggruppa 3019",
    transform: "translate(15.156 194.966)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4190",
    "data-name": "Tracciato 4190",
    d: "M4769.717,1650.308a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4769.717,1650.308Z",
    transform: "translate(-4500.874 -1541.494)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3020",
    "data-name": "Raggruppa 3020",
    transform: "translate(13.641 198.752)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4191",
    "data-name": "Tracciato 4191",
    d: "M4767.2,1656.6a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.024,52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.025A54.458,54.458,0,0,1,4767.2,1656.6Z",
    transform: "translate(-4498.357 -1547.782)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3021",
    "data-name": "Raggruppa 3021",
    transform: "translate(12.125 202.539)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4192",
    "data-name": "Tracciato 4192",
    d: "M4764.683,1662.883a54.457,54.457,0,0,1-54.382-54.407,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4764.683,1662.883Z",
    transform: "translate(-4495.841 -1554.07)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3022",
    "data-name": "Raggruppa 3022",
    transform: "translate(10.608 206.325)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4193",
    "data-name": "Tracciato 4193",
    d: "M4762.165,1669.171a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.671-.024A54.458,54.458,0,0,1,4762.165,1669.171Z",
    transform: "translate(-4493.321 -1560.357)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3023",
    "data-name": "Raggruppa 3023",
    transform: "translate(9.093 210.112)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4194",
    "data-name": "Tracciato 4194",
    d: "M4759.649,1675.459a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,4759.649,1675.459Z",
    transform: "translate(-4490.806 -1566.645)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3024",
    "data-name": "Raggruppa 3024",
    transform: "translate(7.578 213.898)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4195",
    "data-name": "Tracciato 4195",
    d: "M4757.133,1681.747a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.837,52.837,0,0,0-105.673-.025A54.456,54.456,0,0,1,4757.133,1681.747Z",
    transform: "translate(-4488.29 -1572.933)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3025",
    "data-name": "Raggruppa 3025",
    transform: "translate(6.062 217.685)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4196",
    "data-name": "Tracciato 4196",
    d: "M4754.616,1688.035a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.558A52.836,52.836,0,1,0,4593,1633.6a54.395,54.395,0,0,1,108.789.024,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025H4914.7a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,4754.616,1688.035Z",
    transform: "translate(-4485.773 -1579.221)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3026",
    "data-name": "Raggruppa 3026",
    transform: "translate(4.547 221.471)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4197",
    "data-name": "Tracciato 4197",
    d: "M4752.1,1694.322a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.026,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,4752.1,1694.322Z",
    transform: "translate(-4483.257 -1585.508)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3027",
    "data-name": "Raggruppa 3027",
    transform: "translate(3.03 225.258)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4198",
    "data-name": "Tracciato 4198",
    d: "M4749.582,1700.61A54.457,54.457,0,0,1,4695.2,1646.2a52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.024h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4749.582,1700.61Z",
    transform: "translate(-4480.738 -1591.796)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3028",
    "data-name": "Raggruppa 3028",
    transform: "translate(1.515 229.044)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4199",
    "data-name": "Tracciato 4199",
    d: "M4747.066,1706.9a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4747.066,1706.9Z",
    transform: "translate(-4478.223 -1598.084)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3029",
    "data-name": "Raggruppa 3029",
    transform: "translate(0 232.831)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4200",
    "data-name": "Tracciato 4200",
    d: "M4744.549,1713.185a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4744.549,1713.185Z",
    transform: "translate(-4475.706 -1604.371)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3030",
    "data-name": "Raggruppa 3030",
    transform: "translate(1.513 236.618)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4201",
    "data-name": "Tracciato 4201",
    d: "M4747.063,1719.474a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4747.063,1719.474Z",
    transform: "translate(-4478.219 -1610.66)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3031",
    "data-name": "Raggruppa 3031",
    transform: "translate(3.027 240.405)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4202",
    "data-name": "Tracciato 4202",
    d: "M4749.576,1725.763a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4749.576,1725.763Z",
    transform: "translate(-4480.732 -1616.949)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3032",
    "data-name": "Raggruppa 3032",
    transform: "translate(4.542 244.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4203",
    "data-name": "Tracciato 4203",
    d: "M4752.09,1732.051a54.458,54.458,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.026,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,4752.09,1732.051Z",
    transform: "translate(-4483.248 -1623.238)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3033",
    "data-name": "Raggruppa 3033",
    transform: "translate(6.056 247.98)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4204",
    "data-name": "Tracciato 4204",
    d: "M4754.6,1738.341a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.026h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4754.6,1738.341Z",
    transform: "translate(-4485.762 -1629.527)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3034",
    "data-name": "Raggruppa 3034",
    transform: "translate(7.569 251.767)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4205",
    "data-name": "Tracciato 4205",
    d: "M4757.119,1744.63a54.456,54.456,0,0,1-54.383-54.407,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025H4917.2a52.836,52.836,0,0,0-105.671-.025A54.456,54.456,0,0,1,4757.119,1744.63Z",
    transform: "translate(-4488.275 -1635.816)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3035",
    "data-name": "Raggruppa 3035",
    transform: "translate(9.083 255.554)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4206",
    "data-name": "Tracciato 4206",
    d: "M4759.632,1750.919a54.457,54.457,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4759.632,1750.919Z",
    transform: "translate(-4490.789 -1642.105)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3036",
    "data-name": "Raggruppa 3036",
    transform: "translate(10.596 259.342)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4207",
    "data-name": "Tracciato 4207",
    d: "M4762.145,1757.208a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4762.145,1757.208Z",
    transform: "translate(-4493.302 -1648.394)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3037",
    "data-name": "Raggruppa 3037",
    transform: "translate(12.112 263.129)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4208",
    "data-name": "Tracciato 4208",
    d: "M4764.661,1763.5a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.024h-1.557a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,4764.661,1763.5Z",
    transform: "translate(-4495.818 -1654.683)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3038",
    "data-name": "Raggruppa 3038",
    transform: "translate(13.625 266.916)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4209",
    "data-name": "Tracciato 4209",
    d: "M4767.173,1769.786a54.458,54.458,0,0,1-54.382-54.407,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,1,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4767.173,1769.786Z",
    transform: "translate(-4498.331 -1660.972)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3039",
    "data-name": "Raggruppa 3039",
    transform: "translate(15.139 270.703)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4210",
    "data-name": "Tracciato 4210",
    d: "M4769.688,1776.074a54.457,54.457,0,0,1-54.382-54.409,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.026h-1.559a52.836,52.836,0,0,0-105.671-.024A54.458,54.458,0,0,1,4769.688,1776.074Z",
    transform: "translate(-4500.845 -1667.26)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3040",
    "data-name": "Raggruppa 3040",
    transform: "translate(16.652 274.49)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4211",
    "data-name": "Tracciato 4211",
    d: "M4772.2,1782.363a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.026h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4772.2,1782.363Z",
    transform: "translate(-4503.358 -1673.549)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3041",
    "data-name": "Raggruppa 3041",
    transform: "translate(18.166 278.277)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4212",
    "data-name": "Tracciato 4212",
    d: "M4774.714,1788.652a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4774.714,1788.652Z",
    transform: "translate(-4505.871 -1679.838)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3042",
    "data-name": "Raggruppa 3042",
    transform: "translate(19.681 282.065)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4213",
    "data-name": "Tracciato 4213",
    d: "M4777.229,1794.94a54.456,54.456,0,0,1-54.38-54.407,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.026h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4777.229,1794.94Z",
    transform: "translate(-4508.387 -1686.127)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3043",
    "data-name": "Raggruppa 3043",
    transform: "translate(21.195 285.852)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4214",
    "data-name": "Tracciato 4214",
    d: "M4779.744,1801.23a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.026h-1.557a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,4779.744,1801.23Z",
    transform: "translate(-4510.901 -1692.416)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3044",
    "data-name": "Raggruppa 3044",
    transform: "translate(22.708 289.639)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4215",
    "data-name": "Tracciato 4215",
    d: "M4782.258,1807.519a54.458,54.458,0,0,1-54.384-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.673-.024A54.455,54.455,0,0,1,4782.258,1807.519Z",
    transform: "translate(-4513.414 -1698.705)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3045",
    "data-name": "Raggruppa 3045",
    transform: "translate(24.221 293.427)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4216",
    "data-name": "Tracciato 4216",
    d: "M4784.771,1813.807a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.67-.024A54.457,54.457,0,0,1,4784.771,1813.807Z",
    transform: "translate(-4515.927 -1704.994)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3046",
    "data-name": "Raggruppa 3046",
    transform: "translate(25.736 297.214)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4217",
    "data-name": "Tracciato 4217",
    d: "M4787.284,1820.1a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025H4520a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4787.284,1820.1Z",
    transform: "translate(-4518.443 -1711.283)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3047",
    "data-name": "Raggruppa 3047",
    transform: "translate(27.251 301.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4218",
    "data-name": "Tracciato 4218",
    d: "M4789.8,1826.386a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.026h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4789.8,1826.386Z",
    transform: "translate(-4520.958 -1717.572)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3048",
    "data-name": "Raggruppa 3048",
    transform: "translate(28.764 304.788)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4219",
    "data-name": "Tracciato 4219",
    d: "M4792.312,1832.674a54.457,54.457,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.026,52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.558a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4792.312,1832.674Z",
    transform: "translate(-4523.47 -1723.86)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3049",
    "data-name": "Raggruppa 3049",
    transform: "translate(30.277 308.575)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4220",
    "data-name": "Tracciato 4220",
    d: "M4794.827,1838.963a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025,52.835,52.835,0,0,0,105.67.024,54.4,54.4,0,1,1,108.79.025H4954.9a52.836,52.836,0,1,0-105.671-.025A54.456,54.456,0,0,1,4794.827,1838.963Z",
    transform: "translate(-4525.983 -1730.149)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3050",
    "data-name": "Raggruppa 3050",
    transform: "translate(31.791 312.362)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4221",
    "data-name": "Tracciato 4221",
    d: "M4797.34,1845.252a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.789-.024h1.558a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.673-.025A54.455,54.455,0,0,1,4797.34,1845.252Z",
    transform: "translate(-4528.497 -1736.438)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3137",
    "data-name": "Raggruppa 3137",
    transform: "translate(427.559)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3052",
    "data-name": "Raggruppa 3052",
    transform: "translate(31.863)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4222",
    "data-name": "Tracciato 4222",
    d: "M5507.447,781.893a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5507.447,781.893Z",
    transform: "translate(-5238.602 -673.079)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3053",
    "data-name": "Raggruppa 3053",
    transform: "translate(30.5 3.438)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4223",
    "data-name": "Tracciato 4223",
    d: "M5505.181,787.6a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5505.181,787.6Z",
    transform: "translate(-5236.339 -678.788)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3054",
    "data-name": "Raggruppa 3054",
    transform: "translate(29.136 6.875)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4224",
    "data-name": "Tracciato 4224",
    d: "M5502.915,793.309a54.456,54.456,0,0,1-54.38-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5502.915,793.309Z",
    transform: "translate(-5234.073 -684.495)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3055",
    "data-name": "Raggruppa 3055",
    transform: "translate(27.771 10.313)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4225",
    "data-name": "Tracciato 4225",
    d: "M5500.652,799.018a54.457,54.457,0,0,1-54.384-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5500.652,799.018Z",
    transform: "translate(-5231.808 -690.204)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3056",
    "data-name": "Raggruppa 3056",
    transform: "translate(26.408 13.751)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4226",
    "data-name": "Tracciato 4226",
    d: "M5498.385,804.727A54.455,54.455,0,0,1,5444,750.32a52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025h-1.56a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5498.385,804.727Z",
    transform: "translate(-5229.544 -695.913)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3057",
    "data-name": "Raggruppa 3057",
    transform: "translate(25.043 17.189)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4227",
    "data-name": "Tracciato 4227",
    d: "M5496.121,810.436a54.457,54.457,0,0,1-54.382-54.408A52.835,52.835,0,0,0,5336.068,756a54.395,54.395,0,1,1-108.79-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025H5656.2a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5496.121,810.436Z",
    transform: "translate(-5227.278 -701.622)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3058",
    "data-name": "Raggruppa 3058",
    transform: "translate(23.679 20.627)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4228",
    "data-name": "Tracciato 4228",
    d: "M5493.855,816.145a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5493.855,816.145Z",
    transform: "translate(-5225.013 -707.331)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3059",
    "data-name": "Raggruppa 3059",
    transform: "translate(22.316 24.063)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4229",
    "data-name": "Tracciato 4229",
    d: "M5491.591,821.851a54.455,54.455,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.673-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.4,54.4,0,1,1,108.79.025,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,1,1,108.79.025h-1.559A52.836,52.836,0,1,0,5546,767.469,54.456,54.456,0,0,1,5491.591,821.851Z",
    transform: "translate(-5222.748 -713.037)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3060",
    "data-name": "Raggruppa 3060",
    transform: "translate(20.951 27.501)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4230",
    "data-name": "Tracciato 4230",
    d: "M5489.327,827.56a54.456,54.456,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.789-.025h1.558a52.837,52.837,0,0,0,105.674.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5489.327,827.56Z",
    transform: "translate(-5220.483 -718.746)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3061",
    "data-name": "Raggruppa 3061",
    transform: "translate(19.587 30.939)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4231",
    "data-name": "Tracciato 4231",
    d: "M5487.061,833.269a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.67.025,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.455,54.455,0,0,1,5487.061,833.269Z",
    transform: "translate(-5218.217 -724.455)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3062",
    "data-name": "Raggruppa 3062",
    transform: "translate(18.222 34.377)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4232",
    "data-name": "Tracciato 4232",
    d: "M5484.8,838.978a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558A52.836,52.836,0,0,0,5539.2,784.6,54.457,54.457,0,0,1,5484.8,838.978Z",
    transform: "translate(-5215.952 -730.164)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3063",
    "data-name": "Raggruppa 3063",
    transform: "translate(16.859 37.815)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4233",
    "data-name": "Tracciato 4233",
    d: "M5482.528,844.687a54.455,54.455,0,0,1-54.379-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,5482.528,844.687Z",
    transform: "translate(-5213.688 -735.873)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3064",
    "data-name": "Raggruppa 3064",
    transform: "translate(15.494 41.252)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4234",
    "data-name": "Tracciato 4234",
    d: "M5480.265,850.393a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,0,1,108.791.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.561a52.835,52.835,0,1,0-105.67-.024A54.456,54.456,0,0,1,5480.265,850.393Z",
    transform: "translate(-5211.421 -741.58)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3065",
    "data-name": "Raggruppa 3065",
    transform: "translate(14.13 44.69)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4235",
    "data-name": "Tracciato 4235",
    d: "M5478,856.1a54.457,54.457,0,0,1-54.382-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.4,54.4,0,1,1,108.79.025h-1.561a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,5478,856.1Z",
    transform: "translate(-5209.156 -747.289)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3066",
    "data-name": "Raggruppa 3066",
    transform: "translate(12.767 48.128)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4236",
    "data-name": "Tracciato 4236",
    d: "M5475.734,861.812a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5475.734,861.812Z",
    transform: "translate(-5206.892 -752.998)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3067",
    "data-name": "Raggruppa 3067",
    transform: "translate(11.402 51.566)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4237",
    "data-name": "Tracciato 4237",
    d: "M5473.47,867.521a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5473.47,867.521Z",
    transform: "translate(-5204.626 -758.707)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3068",
    "data-name": "Raggruppa 3068",
    transform: "translate(10.038 55.004)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4238",
    "data-name": "Tracciato 4238",
    d: "M5471.2,873.23a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.024,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,5471.2,873.23Z",
    transform: "translate(-5202.361 -764.416)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3069",
    "data-name": "Raggruppa 3069",
    transform: "translate(8.675 58.44)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4239",
    "data-name": "Tracciato 4239",
    d: "M5468.939,878.936a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.56a52.836,52.836,0,0,0,105.671.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.4,54.4,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5468.939,878.936Z",
    transform: "translate(-5200.097 -770.122)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3070",
    "data-name": "Raggruppa 3070",
    transform: "translate(7.31 61.878)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4240",
    "data-name": "Tracciato 4240",
    d: "M5466.675,884.644a54.455,54.455,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5466.675,884.644Z",
    transform: "translate(-5197.831 -775.831)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3071",
    "data-name": "Raggruppa 3071",
    transform: "translate(5.946 65.316)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4241",
    "data-name": "Tracciato 4241",
    d: "M5464.409,890.354a54.459,54.459,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5464.409,890.354Z",
    transform: "translate(-5195.565 -781.54)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3072",
    "data-name": "Raggruppa 3072",
    transform: "translate(4.583 68.754)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4242",
    "data-name": "Tracciato 4242",
    d: "M5462.144,896.063a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5462.144,896.063Z",
    transform: "translate(-5193.302 -787.249)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3073",
    "data-name": "Raggruppa 3073",
    transform: "translate(3.218 72.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4243",
    "data-name": "Tracciato 4243",
    d: "M5459.878,901.772a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.557a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5459.878,901.772Z",
    transform: "translate(-5191.037 -792.958)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3074",
    "data-name": "Raggruppa 3074",
    transform: "translate(4.581 76.054)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4244",
    "data-name": "Tracciato 4244",
    d: "M5462.141,908.185a54.456,54.456,0,0,1-54.381-54.407,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.788.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5462.141,908.185Z",
    transform: "translate(-5193.299 -799.371)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3075",
    "data-name": "Raggruppa 3075",
    transform: "translate(5.942 79.917)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4245",
    "data-name": "Tracciato 4245",
    d: "M5464.4,914.6a54.457,54.457,0,0,1-54.384-54.406,52.835,52.835,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.79-.025h1.558a52.837,52.837,0,0,0,105.673.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5464.4,914.6Z",
    transform: "translate(-5195.559 -805.786)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3076",
    "data-name": "Raggruppa 3076",
    transform: "translate(7.306 83.78)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4246",
    "data-name": "Tracciato 4246",
    d: "M5466.667,921.015a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.557a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5466.667,921.015Z",
    transform: "translate(-5197.824 -812.201)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3077",
    "data-name": "Raggruppa 3077",
    transform: "translate(8.668 87.644)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4247",
    "data-name": "Tracciato 4247",
    d: "M5468.928,927.43a54.456,54.456,0,0,1-54.381-54.408A52.836,52.836,0,0,0,5308.875,873a54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5468.928,927.43Z",
    transform: "translate(-5200.086 -818.616)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3078",
    "data-name": "Raggruppa 3078",
    transform: "translate(10.029 91.506)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4248",
    "data-name": "Tracciato 4248",
    d: "M5471.189,933.843a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.56a52.836,52.836,0,0,0,105.671.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.79.025h-1.558a52.836,52.836,0,1,0-105.672-.025A54.455,54.455,0,0,1,5471.189,933.843Z",
    transform: "translate(-5202.346 -825.029)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3079",
    "data-name": "Raggruppa 3079",
    transform: "translate(11.392 95.369)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4249",
    "data-name": "Tracciato 4249",
    d: "M5473.453,940.258a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.671-.025,54.4,54.4,0,0,1-108.79-.025h1.56a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.025A54.456,54.456,0,0,1,5473.453,940.258Z",
    transform: "translate(-5204.608 -831.444)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3080",
    "data-name": "Raggruppa 3080",
    transform: "translate(12.755 99.232)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4250",
    "data-name": "Tracciato 4250",
    d: "M5475.715,946.674a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5475.715,946.674Z",
    transform: "translate(-5206.873 -837.86)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3081",
    "data-name": "Raggruppa 3081",
    transform: "translate(14.116 103.096)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4251",
    "data-name": "Tracciato 4251",
    d: "M5477.976,953.089a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.558a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.671-.025A54.456,54.456,0,0,1,5477.976,953.089Z",
    transform: "translate(-5209.132 -844.275)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3082",
    "data-name": "Raggruppa 3082",
    transform: "translate(15.479 106.957)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4252",
    "data-name": "Tracciato 4252",
    d: "M5480.241,959.5a54.458,54.458,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.457,54.457,0,0,1,5480.241,959.5Z",
    transform: "translate(-5211.397 -850.687)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3083",
    "data-name": "Raggruppa 3083",
    transform: "translate(16.842 110.821)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4253",
    "data-name": "Tracciato 4253",
    d: "M5482.5,965.917a54.457,54.457,0,0,1-54.38-54.406,52.835,52.835,0,1,0-105.671-.024,54.4,54.4,0,0,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5482.5,965.917Z",
    transform: "translate(-5213.659 -857.103)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3084",
    "data-name": "Raggruppa 3084",
    transform: "translate(18.204 114.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4254",
    "data-name": "Tracciato 4254",
    d: "M5484.763,972.332a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.025,54.394,54.394,0,1,1-108.789-.025h1.557a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5484.763,972.332Z",
    transform: "translate(-5215.92 -863.518)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3085",
    "data-name": "Raggruppa 3085",
    transform: "translate(19.566 118.547)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4255",
    "data-name": "Tracciato 4255",
    d: "M5487.027,978.747a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5487.027,978.747Z",
    transform: "translate(-5218.183 -869.933)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3086",
    "data-name": "Raggruppa 3086",
    transform: "translate(20.929 122.41)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4256",
    "data-name": "Tracciato 4256",
    d: "M5489.289,985.162a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025H5222a52.836,52.836,0,0,0,105.673.024,54.395,54.395,0,0,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5489.289,985.162Z",
    transform: "translate(-5220.446 -876.348)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3087",
    "data-name": "Raggruppa 3087",
    transform: "translate(22.292 126.272)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4257",
    "data-name": "Tracciato 4257",
    d: "M5491.551,991.575a54.457,54.457,0,0,1-54.381-54.407,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.835,52.835,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5491.551,991.575Z",
    transform: "translate(-5222.709 -882.761)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3088",
    "data-name": "Raggruppa 3088",
    transform: "translate(23.654 130.135)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4258",
    "data-name": "Tracciato 4258",
    d: "M5493.814,997.99a54.456,54.456,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,5493.814,997.99Z",
    transform: "translate(-5224.97 -889.176)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3089",
    "data-name": "Raggruppa 3089",
    transform: "translate(25.016 133.999)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4259",
    "data-name": "Tracciato 4259",
    d: "M5496.075,1004.4A54.457,54.457,0,0,1,5441.693,950a52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5496.075,1004.4Z",
    transform: "translate(-5227.232 -895.591)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3090",
    "data-name": "Raggruppa 3090",
    transform: "translate(26.379 137.862)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4260",
    "data-name": "Tracciato 4260",
    d: "M5498.338,1010.82a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,1,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5498.338,1010.82Z",
    transform: "translate(-5229.496 -902.007)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3091",
    "data-name": "Raggruppa 3091",
    transform: "translate(27.741 141.724)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4261",
    "data-name": "Tracciato 4261",
    d: "M5500.6,1017.233a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.67.025,54.4,54.4,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.672-.025A54.455,54.455,0,0,1,5500.6,1017.233Z",
    transform: "translate(-5231.757 -908.419)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3092",
    "data-name": "Raggruppa 3092",
    transform: "translate(29.104 145.587)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4262",
    "data-name": "Tracciato 4262",
    d: "M5502.861,1023.648a54.455,54.455,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,5502.861,1023.648Z",
    transform: "translate(-5234.02 -914.834)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3093",
    "data-name": "Raggruppa 3093",
    transform: "translate(30.467 149.451)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4263",
    "data-name": "Tracciato 4263",
    d: "M5505.125,1030.064a54.457,54.457,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025H5665.2a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5505.125,1030.064Z",
    transform: "translate(-5236.283 -921.25)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3094",
    "data-name": "Raggruppa 3094",
    transform: "translate(31.828 153.314)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4264",
    "data-name": "Tracciato 4264",
    d: "M5507.387,1036.479A54.456,54.456,0,0,1,5453,982.071a52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5507.387,1036.479Z",
    transform: "translate(-5238.543 -927.665)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3095",
    "data-name": "Raggruppa 3095",
    transform: "translate(30.312 157.1)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4265",
    "data-name": "Tracciato 4265",
    d: "M5504.87,1042.767a54.459,54.459,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.67-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5504.87,1042.767Z",
    transform: "translate(-5236.027 -933.953)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3096",
    "data-name": "Raggruppa 3096",
    transform: "translate(28.797 160.887)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4266",
    "data-name": "Tracciato 4266",
    d: "M5502.354,1049.054a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5502.354,1049.054Z",
    transform: "translate(-5233.511 -940.24)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3097",
    "data-name": "Raggruppa 3097",
    transform: "translate(27.282 164.673)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4267",
    "data-name": "Tracciato 4267",
    d: "M5499.837,1055.342a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5499.837,1055.342Z",
    transform: "translate(-5230.995 -946.528)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3098",
    "data-name": "Raggruppa 3098",
    transform: "translate(25.767 168.46)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4268",
    "data-name": "Tracciato 4268",
    d: "M5497.322,1061.63a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025H5657.4a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5497.322,1061.63Z",
    transform: "translate(-5228.479 -952.816)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3099",
    "data-name": "Raggruppa 3099",
    transform: "translate(24.25 172.247)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4269",
    "data-name": "Tracciato 4269",
    d: "M5494.8,1067.918a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.4,54.4,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.025A54.455,54.455,0,0,1,5494.8,1067.918Z",
    transform: "translate(-5225.96 -959.104)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3100",
    "data-name": "Raggruppa 3100",
    transform: "translate(22.735 176.033)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4270",
    "data-name": "Tracciato 4270",
    d: "M5492.287,1074.2A54.456,54.456,0,0,1,5437.9,1019.8a52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025H5225a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5492.287,1074.2Z",
    transform: "translate(-5223.444 -965.391)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3101",
    "data-name": "Raggruppa 3101",
    transform: "translate(21.219 179.819)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4271",
    "data-name": "Tracciato 4271",
    d: "M5489.769,1080.493a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.4,54.4,0,0,1-108.791-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.673-.024A54.454,54.454,0,0,1,5489.769,1080.493Z",
    transform: "translate(-5220.926 -971.679)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3102",
    "data-name": "Raggruppa 3102",
    transform: "translate(19.704 183.606)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4272",
    "data-name": "Tracciato 4272",
    d: "M5487.253,1086.781a54.457,54.457,0,0,1-54.381-54.407,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5487.253,1086.781Z",
    transform: "translate(-5218.411 -977.967)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3103",
    "data-name": "Raggruppa 3103",
    transform: "translate(18.187 187.393)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4273",
    "data-name": "Tracciato 4273",
    d: "M5484.736,1093.068a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,5484.736,1093.068Z",
    transform: "translate(-5215.892 -984.255)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3104",
    "data-name": "Raggruppa 3104",
    transform: "translate(16.672 191.179)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4274",
    "data-name": "Tracciato 4274",
    d: "M5482.22,1099.356a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.026,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025H5642.3a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5482.22,1099.356Z",
    transform: "translate(-5213.375 -990.542)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3105",
    "data-name": "Raggruppa 3105",
    transform: "translate(15.156 194.966)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4275",
    "data-name": "Tracciato 4275",
    d: "M5479.7,1105.644a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.837,52.837,0,0,0,105.674.024,54.394,54.394,0,0,1,108.788.025,52.835,52.835,0,1,0,105.67.024,54.4,54.4,0,0,1,108.791.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5479.7,1105.644Z",
    transform: "translate(-5210.859 -996.83)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3106",
    "data-name": "Raggruppa 3106",
    transform: "translate(13.641 198.752)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4276",
    "data-name": "Tracciato 4276",
    d: "M5477.186,1111.931a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,0,0-105.672-.024,54.4,54.4,0,1,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.67.025,54.4,54.4,0,0,1,108.791.024,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.671-.025A54.458,54.458,0,0,1,5477.186,1111.931Z",
    transform: "translate(-5208.342 -1003.118)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3107",
    "data-name": "Raggruppa 3107",
    transform: "translate(12.126 202.539)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4277",
    "data-name": "Tracciato 4277",
    d: "M5474.669,1118.22a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5474.669,1118.22Z",
    transform: "translate(-5205.828 -1009.406)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3108",
    "data-name": "Raggruppa 3108",
    transform: "translate(10.609 206.325)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4278",
    "data-name": "Tracciato 4278",
    d: "M5472.152,1124.507a54.457,54.457,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.026h1.558a52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.026h-1.56a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,5472.152,1124.507Z",
    transform: "translate(-5203.309 -1015.693)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3109",
    "data-name": "Raggruppa 3109",
    transform: "translate(9.093 210.112)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4279",
    "data-name": "Tracciato 4279",
    d: "M5469.636,1130.795a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5469.636,1130.795Z",
    transform: "translate(-5200.792 -1021.981)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3110",
    "data-name": "Raggruppa 3110",
    transform: "translate(7.578 213.898)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4280",
    "data-name": "Tracciato 4280",
    d: "M5467.12,1137.083a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025H5627.2a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,5467.12,1137.083Z",
    transform: "translate(-5198.276 -1028.269)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3111",
    "data-name": "Raggruppa 3111",
    transform: "translate(6.063 217.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4281",
    "data-name": "Tracciato 4281",
    d: "M5464.6,1143.37a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.673-.024,54.395,54.395,0,1,1-108.79-.025h1.561a52.835,52.835,0,1,0,105.67.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.458,54.458,0,0,1,5464.6,1143.37Z",
    transform: "translate(-5195.759 -1034.556)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3112",
    "data-name": "Raggruppa 3112",
    transform: "translate(4.547 221.471)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4282",
    "data-name": "Tracciato 4282",
    d: "M5462.085,1149.658a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5462.085,1149.658Z",
    transform: "translate(-5193.244 -1040.844)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3113",
    "data-name": "Raggruppa 3113",
    transform: "translate(3.031 225.258)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4283",
    "data-name": "Tracciato 4283",
    d: "M5459.568,1155.946a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,5459.568,1155.946Z",
    transform: "translate(-5190.726 -1047.132)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3114",
    "data-name": "Raggruppa 3114",
    transform: "translate(1.515 229.045)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4284",
    "data-name": "Tracciato 4284",
    d: "M5457.051,1162.234a54.457,54.457,0,0,1-54.382-54.408A52.836,52.836,0,0,0,5297,1107.8a54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5457.051,1162.234Z",
    transform: "translate(-5188.208 -1053.42)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3115",
    "data-name": "Raggruppa 3115",
    transform: "translate(0 232.831)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4285",
    "data-name": "Tracciato 4285",
    d: "M5454.537,1168.521a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,1,1,108.788.025,52.837,52.837,0,0,0,105.673.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5454.537,1168.521Z",
    transform: "translate(-5185.692 -1059.707)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3116",
    "data-name": "Raggruppa 3116",
    transform: "translate(1.513 236.618)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4286",
    "data-name": "Tracciato 4286",
    d: "M5457.048,1174.81a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.458,54.458,0,0,1,5457.048,1174.81Z",
    transform: "translate(-5188.206 -1065.996)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3117",
    "data-name": "Raggruppa 3117",
    transform: "translate(3.028 240.405)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4287",
    "data-name": "Tracciato 4287",
    d: "M5459.563,1181.1a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.789-.026h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,5459.563,1181.1Z",
    transform: "translate(-5190.719 -1072.285)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3118",
    "data-name": "Raggruppa 3118",
    transform: "translate(4.542 244.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4288",
    "data-name": "Tracciato 4288",
    d: "M5462.077,1187.388a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5462.077,1187.388Z",
    transform: "translate(-5193.234 -1078.574)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3119",
    "data-name": "Raggruppa 3119",
    transform: "translate(6.056 247.98)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4289",
    "data-name": "Tracciato 4289",
    d: "M5464.589,1193.676a54.456,54.456,0,0,1-54.38-54.407,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.026,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5464.589,1193.676Z",
    transform: "translate(-5195.748 -1084.863)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3120",
    "data-name": "Raggruppa 3120",
    transform: "translate(7.569 251.767)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4290",
    "data-name": "Tracciato 4290",
    d: "M5467.106,1199.966a54.457,54.457,0,0,1-54.384-54.408,52.835,52.835,0,1,0-105.671-.024,54.4,54.4,0,0,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.456,54.456,0,0,1,5467.106,1199.966Z",
    transform: "translate(-5198.261 -1091.152)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3121",
    "data-name": "Raggruppa 3121",
    transform: "translate(9.083 255.554)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4291",
    "data-name": "Tracciato 4291",
    d: "M5469.619,1206.255a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.788.025H5629.7a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5469.619,1206.255Z",
    transform: "translate(-5200.776 -1097.441)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3122",
    "data-name": "Raggruppa 3122",
    transform: "translate(10.597 259.342)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4292",
    "data-name": "Tracciato 4292",
    d: "M5472.131,1212.544a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5472.131,1212.544Z",
    transform: "translate(-5203.288 -1103.73)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3123",
    "data-name": "Raggruppa 3123",
    transform: "translate(12.112 263.129)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4293",
    "data-name": "Tracciato 4293",
    d: "M5474.646,1218.833a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025,52.837,52.837,0,1,0,105.673.025,54.394,54.394,0,0,1,108.788.025h-1.559a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,5474.646,1218.833Z",
    transform: "translate(-5205.804 -1110.019)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3124",
    "data-name": "Raggruppa 3124",
    transform: "translate(13.625 266.916)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4294",
    "data-name": "Tracciato 4294",
    d: "M5477.159,1225.122a54.458,54.458,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,5477.159,1225.122Z",
    transform: "translate(-5208.317 -1116.308)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3125",
    "data-name": "Raggruppa 3125",
    transform: "translate(15.139 270.703)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4295",
    "data-name": "Tracciato 4295",
    d: "M5479.675,1231.41A54.456,54.456,0,0,1,5425.292,1177a52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5479.675,1231.41Z",
    transform: "translate(-5210.832 -1122.596)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3126",
    "data-name": "Raggruppa 3126",
    transform: "translate(16.652 274.49)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4296",
    "data-name": "Tracciato 4296",
    d: "M5482.189,1237.7a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.026h-1.56a52.836,52.836,0,0,0-105.671-.024A54.455,54.455,0,0,1,5482.189,1237.7Z",
    transform: "translate(-5213.345 -1128.885)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3127",
    "data-name": "Raggruppa 3127",
    transform: "translate(18.166 278.277)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4297",
    "data-name": "Tracciato 4297",
    d: "M5484.7,1243.988a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.026h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.026h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5484.7,1243.988Z",
    transform: "translate(-5215.859 -1135.174)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3128",
    "data-name": "Raggruppa 3128",
    transform: "translate(19.681 282.065)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4298",
    "data-name": "Tracciato 4298",
    d: "M5487.215,1250.277a54.457,54.457,0,0,1-54.381-54.407,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,5487.215,1250.277Z",
    transform: "translate(-5218.373 -1141.463)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3129",
    "data-name": "Raggruppa 3129",
    transform: "translate(21.195 285.852)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4299",
    "data-name": "Tracciato 4299",
    d: "M5489.729,1256.566a54.455,54.455,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025h-1.56a52.835,52.835,0,1,0-105.671-.024A54.456,54.456,0,0,1,5489.729,1256.566Z",
    transform: "translate(-5220.888 -1147.752)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3130",
    "data-name": "Raggruppa 3130",
    transform: "translate(22.708 289.639)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4300",
    "data-name": "Tracciato 4300",
    d: "M5492.244,1262.855a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5492.244,1262.855Z",
    transform: "translate(-5223.4 -1154.041)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3131",
    "data-name": "Raggruppa 3131",
    transform: "translate(24.222 293.427)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4301",
    "data-name": "Tracciato 4301",
    d: "M5494.757,1269.144a54.455,54.455,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,5494.757,1269.144Z",
    transform: "translate(-5225.915 -1160.33)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3132",
    "data-name": "Raggruppa 3132",
    transform: "translate(25.737 297.214)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4302",
    "data-name": "Tracciato 4302",
    d: "M5497.271,1275.433a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5497.271,1275.433Z",
    transform: "translate(-5228.43 -1166.619)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3133",
    "data-name": "Raggruppa 3133",
    transform: "translate(27.251 301.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4303",
    "data-name": "Tracciato 4303",
    d: "M5499.786,1281.722a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025h-1.56a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5499.786,1281.722Z",
    transform: "translate(-5230.943 -1172.908)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3134",
    "data-name": "Raggruppa 3134",
    transform: "translate(28.764 304.788)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4304",
    "data-name": "Tracciato 4304",
    d: "M5502.3,1288.01a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.673-.024,54.394,54.394,0,0,1-108.788-.025h1.557a52.836,52.836,0,0,0,105.673.024,54.395,54.395,0,1,1,108.789.026,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.788.025h-1.56a52.836,52.836,0,1,0-105.671-.024A54.455,54.455,0,0,1,5502.3,1288.01Z",
    transform: "translate(-5233.456 -1179.196)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3135",
    "data-name": "Raggruppa 3135",
    transform: "translate(30.278 308.575)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4305",
    "data-name": "Tracciato 4305",
    d: "M5504.813,1294.3a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,5504.813,1294.3Z",
    transform: "translate(-5235.971 -1185.485)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3136",
    "data-name": "Raggruppa 3136",
    transform: "translate(31.791 312.362)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4306",
    "data-name": "Tracciato 4306",
    d: "M5507.327,1300.588a54.456,54.456,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.79.025H5667.4a52.836,52.836,0,1,0-105.672-.025A54.455,54.455,0,0,1,5507.327,1300.588Z",
    transform: "translate(-5238.483 -1191.774)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3223",
    "data-name": "Raggruppa 3223",
    transform: "translate(424.705 315.292)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3138",
    "data-name": "Raggruppa 3138",
    transform: "translate(31.863)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4307",
    "data-name": "Tracciato 4307",
    d: "M5502.706,1305.452a54.457,54.457,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.671-.025A54.458,54.458,0,0,1,5502.706,1305.452Z",
    transform: "translate(-5233.862 -1196.638)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3139",
    "data-name": "Raggruppa 3139",
    transform: "translate(30.499 3.438)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4308",
    "data-name": "Tracciato 4308",
    d: "M5500.441,1311.161a54.457,54.457,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5500.441,1311.161Z",
    transform: "translate(-5231.599 -1202.347)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3140",
    "data-name": "Raggruppa 3140",
    transform: "translate(29.135 6.874)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4309",
    "data-name": "Tracciato 4309",
    d: "M5498.174,1316.866a54.457,54.457,0,0,1-54.381-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.024h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.024,52.836,52.836,0,0,0,105.672.025,54.4,54.4,0,1,1,108.79.025h-1.56a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,5498.174,1316.866Z",
    transform: "translate(-5229.333 -1208.053)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3141",
    "data-name": "Raggruppa 3141",
    transform: "translate(27.771 10.312)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4310",
    "data-name": "Tracciato 4310",
    d: "M5495.911,1322.575a54.456,54.456,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,5495.911,1322.575Z",
    transform: "translate(-5227.067 -1213.762)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3142",
    "data-name": "Raggruppa 3142",
    transform: "translate(26.407 13.75)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4311",
    "data-name": "Tracciato 4311",
    d: "M5493.645,1328.285a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.671-.025,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.673.025,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,5493.645,1328.285Z",
    transform: "translate(-5224.803 -1219.471)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3143",
    "data-name": "Raggruppa 3143",
    transform: "translate(25.043 17.188)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4312",
    "data-name": "Tracciato 4312",
    d: "M5491.379,1333.994a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5491.379,1333.994Z",
    transform: "translate(-5222.538 -1225.18)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3144",
    "data-name": "Raggruppa 3144",
    transform: "translate(23.678 20.626)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4313",
    "data-name": "Tracciato 4313",
    d: "M5489.116,1339.7a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,5489.116,1339.7Z",
    transform: "translate(-5220.271 -1230.889)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3145",
    "data-name": "Raggruppa 3145",
    transform: "translate(22.315 24.063)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4314",
    "data-name": "Tracciato 4314",
    d: "M5486.85,1345.41A54.457,54.457,0,0,1,5432.469,1291a52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,5486.85,1345.41Z",
    transform: "translate(-5218.007 -1236.596)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3146",
    "data-name": "Raggruppa 3146",
    transform: "translate(20.951 27.501)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4315",
    "data-name": "Tracciato 4315",
    d: "M5484.583,1351.119a54.455,54.455,0,0,1-54.379-54.407,52.837,52.837,0,0,0-105.673-.024,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,5484.583,1351.119Z",
    transform: "translate(-5215.742 -1242.305)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3147",
    "data-name": "Raggruppa 3147",
    transform: "translate(19.586 30.939)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4316",
    "data-name": "Tracciato 4316",
    d: "M5482.32,1356.828a54.456,54.456,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.673-.024,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,5482.32,1356.828Z",
    transform: "translate(-5213.477 -1248.014)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3148",
    "data-name": "Raggruppa 3148",
    transform: "translate(18.222 34.377)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4317",
    "data-name": "Tracciato 4317",
    d: "M5480.054,1362.536a54.458,54.458,0,0,1-54.383-54.407A52.836,52.836,0,0,0,5320,1308.1a54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.791.025,52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.788.024h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5480.054,1362.536Z",
    transform: "translate(-5211.21 -1253.723)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3149",
    "data-name": "Raggruppa 3149",
    transform: "translate(16.859 37.815)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4318",
    "data-name": "Tracciato 4318",
    d: "M5477.789,1368.245a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.024,52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,5477.789,1368.245Z",
    transform: "translate(-5208.946 -1259.432)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3150",
    "data-name": "Raggruppa 3150",
    transform: "translate(15.494 41.251)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4319",
    "data-name": "Tracciato 4319",
    d: "M5475.525,1373.952a54.457,54.457,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.788-.024h1.558a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.025A54.456,54.456,0,0,1,5475.525,1373.952Z",
    transform: "translate(-5206.682 -1265.138)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3151",
    "data-name": "Raggruppa 3151",
    transform: "translate(14.13 44.689)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4320",
    "data-name": "Tracciato 4320",
    d: "M5473.259,1379.661a54.457,54.457,0,0,1-54.383-54.406,52.835,52.835,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.79-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,5473.259,1379.661Z",
    transform: "translate(-5204.416 -1270.847)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3152",
    "data-name": "Raggruppa 3152",
    transform: "translate(12.767 48.127)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4321",
    "data-name": "Tracciato 4321",
    d: "M5470.995,1385.37a54.457,54.457,0,0,1-54.382-54.407,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5470.995,1385.37Z",
    transform: "translate(-5202.152 -1276.556)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3153",
    "data-name": "Raggruppa 3153",
    transform: "translate(11.402 51.565)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4322",
    "data-name": "Tracciato 4322",
    d: "M5468.729,1391.078a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.456,54.456,0,0,1,5468.729,1391.078Z",
    transform: "translate(-5199.886 -1282.265)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3154",
    "data-name": "Raggruppa 3154",
    transform: "translate(10.038 55.003)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4323",
    "data-name": "Tracciato 4323",
    d: "M5466.464,1396.788a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5466.464,1396.788Z",
    transform: "translate(-5197.62 -1287.974)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3155",
    "data-name": "Raggruppa 3155",
    transform: "translate(8.674 58.44)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4324",
    "data-name": "Tracciato 4324",
    d: "M5464.2,1402.495a54.457,54.457,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.026h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.026,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,5464.2,1402.495Z",
    transform: "translate(-5195.356 -1293.681)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3156",
    "data-name": "Raggruppa 3156",
    transform: "translate(7.309 61.878)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4325",
    "data-name": "Tracciato 4325",
    d: "M5461.934,1408.2a54.457,54.457,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.4,54.4,0,0,1-108.79-.025h1.56a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.026,52.836,52.836,0,0,0,105.672.024,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,5461.934,1408.2Z",
    transform: "translate(-5193.09 -1299.39)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3157",
    "data-name": "Raggruppa 3157",
    transform: "translate(5.946 65.316)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4326",
    "data-name": "Tracciato 4326",
    d: "M5459.668,1413.913a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5459.668,1413.913Z",
    transform: "translate(-5190.826 -1305.099)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3158",
    "data-name": "Raggruppa 3158",
    transform: "translate(4.582 68.754)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4327",
    "data-name": "Tracciato 4327",
    d: "M5457.4,1419.622a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,5457.4,1419.622Z",
    transform: "translate(-5188.561 -1310.808)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3159",
    "data-name": "Raggruppa 3159",
    transform: "translate(3.217 72.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4328",
    "data-name": "Tracciato 4328",
    d: "M5455.137,1425.331a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5455.137,1425.331Z",
    transform: "translate(-5186.295 -1316.517)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3160",
    "data-name": "Raggruppa 3160",
    transform: "translate(4.58 76.054)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4329",
    "data-name": "Tracciato 4329",
    d: "M5457.4,1431.744a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,0,1,108.79.026,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,1,1,108.79.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5457.4,1431.744Z",
    transform: "translate(-5188.559 -1322.93)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3161",
    "data-name": "Raggruppa 3161",
    transform: "translate(5.942 79.917)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4330",
    "data-name": "Tracciato 4330",
    d: "M5459.662,1438.159a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.673-.024,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,5459.662,1438.159Z",
    transform: "translate(-5190.819 -1329.345)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3162",
    "data-name": "Raggruppa 3162",
    transform: "translate(7.305 83.78)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4331",
    "data-name": "Tracciato 4331",
    d: "M5461.926,1444.574a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.4,54.4,0,1,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025H5622a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5461.926,1444.574Z",
    transform: "translate(-5193.081 -1335.76)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3163",
    "data-name": "Raggruppa 3163",
    transform: "translate(8.668 87.644)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4332",
    "data-name": "Tracciato 4332",
    d: "M5464.187,1450.989a54.455,54.455,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,1,0-105.67-.024A54.457,54.457,0,0,1,5464.187,1450.989Z",
    transform: "translate(-5195.344 -1342.175)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3164",
    "data-name": "Raggruppa 3164",
    transform: "translate(10.029 91.506)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4333",
    "data-name": "Tracciato 4333",
    d: "M5466.451,1457.4A54.457,54.457,0,0,1,5412.067,1403a52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.026,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,5466.451,1457.4Z",
    transform: "translate(-5197.607 -1348.588)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3165",
    "data-name": "Raggruppa 3165",
    transform: "translate(11.392 95.369)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4334",
    "data-name": "Tracciato 4334",
    d: "M5468.712,1463.817a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.788-.025h1.559a52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5468.712,1463.817Z",
    transform: "translate(-5199.87 -1355.003)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3166",
    "data-name": "Raggruppa 3166",
    transform: "translate(12.755 99.232)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4335",
    "data-name": "Tracciato 4335",
    d: "M5470.974,1470.232a54.457,54.457,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.026,52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.454,54.454,0,0,1,5470.974,1470.232Z",
    transform: "translate(-5202.132 -1361.418)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3167",
    "data-name": "Raggruppa 3167",
    transform: "translate(14.116 103.095)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4336",
    "data-name": "Tracciato 4336",
    d: "M5473.237,1476.647a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5473.237,1476.647Z",
    transform: "translate(-5204.394 -1367.833)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3168",
    "data-name": "Raggruppa 3168",
    transform: "translate(15.479 106.957)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4337",
    "data-name": "Tracciato 4337",
    d: "M5475.5,1483.06a54.456,54.456,0,0,1-54.383-54.406,52.835,52.835,0,1,0-105.67-.025,54.4,54.4,0,0,1-108.79-.025h1.558a52.836,52.836,0,0,0,105.673.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.457,54.457,0,0,1,5475.5,1483.06Z",
    transform: "translate(-5206.656 -1374.246)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3169",
    "data-name": "Raggruppa 3169",
    transform: "translate(16.842 110.82)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4338",
    "data-name": "Tracciato 4338",
    d: "M5477.761,1489.474a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.026h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.454,54.454,0,0,1,5477.761,1489.474Z",
    transform: "translate(-5208.919 -1380.661)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3170",
    "data-name": "Raggruppa 3170",
    transform: "translate(18.204 114.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4339",
    "data-name": "Tracciato 4339",
    d: "M5480.024,1495.891a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025H5640.1a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,5480.024,1495.891Z",
    transform: "translate(-5211.181 -1387.077)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3171",
    "data-name": "Raggruppa 3171",
    transform: "translate(19.566 118.547)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4340",
    "data-name": "Tracciato 4340",
    d: "M5482.286,1502.306A54.456,54.456,0,0,1,5427.9,1447.9a52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025H5215a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,5482.286,1502.306Z",
    transform: "translate(-5213.443 -1393.492)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3172",
    "data-name": "Raggruppa 3172",
    transform: "translate(20.929 122.41)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4341",
    "data-name": "Tracciato 4341",
    d: "M5484.548,1508.721a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.026h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.026h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5484.548,1508.721Z",
    transform: "translate(-5215.706 -1399.907)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3173",
    "data-name": "Raggruppa 3173",
    transform: "translate(22.292 126.272)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4342",
    "data-name": "Tracciato 4342",
    d: "M5486.812,1515.134a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,5486.812,1515.134Z",
    transform: "translate(-5217.97 -1406.32)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3174",
    "data-name": "Raggruppa 3174",
    transform: "translate(23.653 130.135)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4343",
    "data-name": "Tracciato 4343",
    d: "M5489.073,1521.549a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.026,52.835,52.835,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5489.073,1521.549Z",
    transform: "translate(-5220.229 -1412.735)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3175",
    "data-name": "Raggruppa 3175",
    transform: "translate(25.016 133.999)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4344",
    "data-name": "Tracciato 4344",
    d: "M5491.335,1527.964a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.026h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5491.335,1527.964Z",
    transform: "translate(-5222.494 -1419.15)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3176",
    "data-name": "Raggruppa 3176",
    transform: "translate(26.379 137.862)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4345",
    "data-name": "Tracciato 4345",
    d: "M5493.6,1534.379a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5493.6,1534.379Z",
    transform: "translate(-5224.756 -1425.565)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3177",
    "data-name": "Raggruppa 3177",
    transform: "translate(27.74 141.724)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4346",
    "data-name": "Tracciato 4346",
    d: "M5495.861,1540.792a54.457,54.457,0,0,1-54.384-54.406,52.835,52.835,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5495.861,1540.792Z",
    transform: "translate(-5227.017 -1431.978)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3178",
    "data-name": "Raggruppa 3178",
    transform: "translate(29.103 145.587)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4347",
    "data-name": "Tracciato 4347",
    d: "M5498.122,1547.207a54.455,54.455,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.56a52.835,52.835,0,1,0-105.671-.025A54.456,54.456,0,0,1,5498.122,1547.207Z",
    transform: "translate(-5229.28 -1438.393)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3179",
    "data-name": "Raggruppa 3179",
    transform: "translate(30.466 149.45)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4348",
    "data-name": "Tracciato 4348",
    d: "M5500.384,1553.622A54.455,54.455,0,0,1,5446,1499.214a52.836,52.836,0,0,0-105.673-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.026h-1.56a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5500.384,1553.622Z",
    transform: "translate(-5231.543 -1444.808)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3180",
    "data-name": "Raggruppa 3180",
    transform: "translate(31.827 153.314)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4349",
    "data-name": "Tracciato 4349",
    d: "M5502.647,1560.037a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,5502.647,1560.037Z",
    transform: "translate(-5233.803 -1451.224)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3181",
    "data-name": "Raggruppa 3181",
    transform: "translate(30.312 157.1)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4350",
    "data-name": "Tracciato 4350",
    d: "M5500.13,1566.325a54.458,54.458,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,5500.13,1566.325Z",
    transform: "translate(-5231.288 -1457.511)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3182",
    "data-name": "Raggruppa 3182",
    transform: "translate(28.797 160.887)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4351",
    "data-name": "Tracciato 4351",
    d: "M5497.613,1572.613a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.026,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.026h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5497.613,1572.613Z",
    transform: "translate(-5228.771 -1463.799)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3183",
    "data-name": "Raggruppa 3183",
    transform: "translate(27.281 164.673)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4352",
    "data-name": "Tracciato 4352",
    d: "M5495.1,1578.9a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025,52.837,52.837,0,0,0,105.673.025,54.395,54.395,0,0,1,108.789.024h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5495.1,1578.9Z",
    transform: "translate(-5226.254 -1470.087)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3184",
    "data-name": "Raggruppa 3184",
    transform: "translate(25.766 168.46)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4353",
    "data-name": "Tracciato 4353",
    d: "M5492.581,1585.189a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.458,54.458,0,0,1,5492.581,1585.189Z",
    transform: "translate(-5223.738 -1476.375)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3185",
    "data-name": "Raggruppa 3185",
    transform: "translate(24.249 172.246)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4354",
    "data-name": "Tracciato 4354",
    d: "M5490.063,1591.476a54.457,54.457,0,0,1-54.384-54.407,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.791.025,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,0,1,108.789.026h-1.559a52.835,52.835,0,1,0-105.671-.024A54.456,54.456,0,0,1,5490.063,1591.476Z",
    transform: "translate(-5221.219 -1482.662)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3186",
    "data-name": "Raggruppa 3186",
    transform: "translate(22.734 176.033)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4355",
    "data-name": "Tracciato 4355",
    d: "M5487.547,1597.764a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5487.547,1597.764Z",
    transform: "translate(-5218.703 -1488.95)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3187",
    "data-name": "Raggruppa 3187",
    transform: "translate(21.219 179.819)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4356",
    "data-name": "Tracciato 4356",
    d: "M5485.029,1604.052a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.024,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,5485.029,1604.052Z",
    transform: "translate(-5216.187 -1495.238)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3188",
    "data-name": "Raggruppa 3188",
    transform: "translate(19.704 183.606)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4357",
    "data-name": "Tracciato 4357",
    d: "M5482.512,1610.34a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.557a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5482.512,1610.34Z",
    transform: "translate(-5213.671 -1501.526)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3189",
    "data-name": "Raggruppa 3189",
    transform: "translate(18.187 187.392)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4358",
    "data-name": "Tracciato 4358",
    d: "M5479.995,1616.627a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,5479.995,1616.627Z",
    transform: "translate(-5211.152 -1507.813)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3190",
    "data-name": "Raggruppa 3190",
    transform: "translate(16.672 191.179)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4359",
    "data-name": "Tracciato 4359",
    d: "M5477.48,1622.915a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.837,52.837,0,0,0,105.674.024,54.394,54.394,0,1,1,108.787.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.791.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5477.48,1622.915Z",
    transform: "translate(-5208.636 -1514.101)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3191",
    "data-name": "Raggruppa 3191",
    transform: "translate(15.156 194.966)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4360",
    "data-name": "Tracciato 4360",
    d: "M5474.963,1629.2a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.457,54.457,0,0,1,5474.963,1629.2Z",
    transform: "translate(-5206.119 -1520.389)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3192",
    "data-name": "Raggruppa 3192",
    transform: "translate(13.641 198.752)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4361",
    "data-name": "Tracciato 4361",
    d: "M5472.445,1635.491a54.457,54.457,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.459,54.459,0,0,1,5472.445,1635.491Z",
    transform: "translate(-5203.604 -1526.677)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3193",
    "data-name": "Raggruppa 3193",
    transform: "translate(12.125 202.538)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4362",
    "data-name": "Tracciato 4362",
    d: "M5469.929,1641.778a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.557a52.837,52.837,0,0,0,105.673.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5469.929,1641.778Z",
    transform: "translate(-5201.087 -1532.964)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3194",
    "data-name": "Raggruppa 3194",
    transform: "translate(10.608 206.325)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4363",
    "data-name": "Tracciato 4363",
    d: "M5467.411,1648.066a54.455,54.455,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.673-.024,54.395,54.395,0,1,1-108.789-.025h1.56a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.456,54.456,0,0,1,5467.411,1648.066Z",
    transform: "translate(-5198.567 -1539.252)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3195",
    "data-name": "Raggruppa 3195",
    transform: "translate(9.093 210.112)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4364",
    "data-name": "Tracciato 4364",
    d: "M5464.9,1654.353a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.457,54.457,0,0,1,5464.9,1654.353Z",
    transform: "translate(-5196.051 -1545.54)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3196",
    "data-name": "Raggruppa 3196",
    transform: "translate(7.578 213.898)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4365",
    "data-name": "Tracciato 4365",
    d: "M5462.378,1660.641A54.456,54.456,0,0,1,5408,1606.233a52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.559a52.835,52.835,0,0,0-105.67-.024A54.457,54.457,0,0,1,5462.378,1660.641Z",
    transform: "translate(-5193.536 -1551.828)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3197",
    "data-name": "Raggruppa 3197",
    transform: "translate(6.062 217.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4366",
    "data-name": "Tracciato 4366",
    d: "M5459.861,1666.929a54.458,54.458,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5459.861,1666.929Z",
    transform: "translate(-5191.019 -1558.115)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3198",
    "data-name": "Raggruppa 3198",
    transform: "translate(4.547 221.471)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4367",
    "data-name": "Tracciato 4367",
    d: "M5457.345,1673.217a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.024h-1.558a52.836,52.836,0,0,0-105.673-.024A54.454,54.454,0,0,1,5457.345,1673.217Z",
    transform: "translate(-5188.503 -1564.403)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3199",
    "data-name": "Raggruppa 3199",
    transform: "translate(3.03 225.258)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4368",
    "data-name": "Tracciato 4368",
    d: "M5454.829,1679.5a54.458,54.458,0,0,1-54.384-54.407,52.836,52.836,0,0,0-105.671-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025A54.394,54.394,0,0,1,5402,1625.1a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.557a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,5454.829,1679.5Z",
    transform: "translate(-5185.985 -1570.691)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3200",
    "data-name": "Raggruppa 3200",
    transform: "translate(1.515 229.044)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4369",
    "data-name": "Tracciato 4369",
    d: "M5452.311,1685.792a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,5452.311,1685.792Z",
    transform: "translate(-5183.468 -1576.978)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3201",
    "data-name": "Raggruppa 3201",
    transform: "translate(0 232.831)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4370",
    "data-name": "Tracciato 4370",
    d: "M5449.8,1692.08a54.455,54.455,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,5449.8,1692.08Z",
    transform: "translate(-5180.953 -1583.266)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3202",
    "data-name": "Raggruppa 3202",
    transform: "translate(1.513 236.618)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4371",
    "data-name": "Tracciato 4371",
    d: "M5452.309,1698.369a54.457,54.457,0,0,1-54.384-54.407,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,1,1-108.789-.026h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5452.309,1698.369Z",
    transform: "translate(-5183.465 -1589.555)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3203",
    "data-name": "Raggruppa 3203",
    transform: "translate(3.027 240.405)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4372",
    "data-name": "Tracciato 4372",
    d: "M5454.822,1704.658a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025H5614.9a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5454.822,1704.658Z",
    transform: "translate(-5185.979 -1595.844)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3204",
    "data-name": "Raggruppa 3204",
    transform: "translate(4.542 244.193)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4373",
    "data-name": "Tracciato 4373",
    d: "M5457.336,1710.947a54.457,54.457,0,0,1-54.381-54.407,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.024h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5457.336,1710.947Z",
    transform: "translate(-5188.494 -1602.133)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3205",
    "data-name": "Raggruppa 3205",
    transform: "translate(6.056 247.98)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4374",
    "data-name": "Tracciato 4374",
    d: "M5459.85,1717.236a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025,52.837,52.837,0,1,0,105.673.025,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.457,54.457,0,0,1,5459.85,1717.236Z",
    transform: "translate(-5191.008 -1608.422)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3206",
    "data-name": "Raggruppa 3206",
    transform: "translate(7.569 251.767)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4375",
    "data-name": "Tracciato 4375",
    d: "M5462.365,1723.525a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5462.365,1723.525Z",
    transform: "translate(-5193.521 -1614.711)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3207",
    "data-name": "Raggruppa 3207",
    transform: "translate(9.083 255.554)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4376",
    "data-name": "Tracciato 4376",
    d: "M5464.877,1729.814a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.673-.024A54.456,54.456,0,0,1,5464.877,1729.814Z",
    transform: "translate(-5196.035 -1621)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3208",
    "data-name": "Raggruppa 3208",
    transform: "translate(10.596 259.341)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4377",
    "data-name": "Tracciato 4377",
    d: "M5467.391,1736.1a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5467.391,1736.1Z",
    transform: "translate(-5198.548 -1627.288)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3209",
    "data-name": "Raggruppa 3209",
    transform: "translate(12.112 263.128)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4378",
    "data-name": "Tracciato 4378",
    d: "M5469.906,1742.391a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,5469.906,1742.391Z",
    transform: "translate(-5201.064 -1633.577)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3210",
    "data-name": "Raggruppa 3210",
    transform: "translate(13.625 266.916)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4379",
    "data-name": "Tracciato 4379",
    d: "M5472.419,1748.68a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.79.026,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025H5632.5a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,5472.419,1748.68Z",
    transform: "translate(-5203.577 -1639.866)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3211",
    "data-name": "Raggruppa 3211",
    transform: "translate(15.138 270.703)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4380",
    "data-name": "Tracciato 4380",
    d: "M5474.934,1754.969a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.026,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,5474.934,1754.969Z",
    transform: "translate(-5206.09 -1646.155)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3212",
    "data-name": "Raggruppa 3212",
    transform: "translate(16.652 274.49)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4381",
    "data-name": "Tracciato 4381",
    d: "M5477.448,1761.258a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.557a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5477.448,1761.258Z",
    transform: "translate(-5208.605 -1652.444)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3213",
    "data-name": "Raggruppa 3213",
    transform: "translate(18.166 278.277)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4382",
    "data-name": "Tracciato 4382",
    d: "M5479.96,1767.547a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.787.025h-1.557a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,5479.96,1767.547Z",
    transform: "translate(-5211.118 -1658.733)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3214",
    "data-name": "Raggruppa 3214",
    transform: "translate(19.681 282.065)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4383",
    "data-name": "Tracciato 4383",
    d: "M5482.475,1773.836a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5482.475,1773.836Z",
    transform: "translate(-5213.633 -1665.022)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3215",
    "data-name": "Raggruppa 3215",
    transform: "translate(21.194 285.852)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4384",
    "data-name": "Tracciato 4384",
    d: "M5484.988,1780.125a54.457,54.457,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5484.988,1780.125Z",
    transform: "translate(-5216.146 -1671.311)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3216",
    "data-name": "Raggruppa 3216",
    transform: "translate(22.708 289.639)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4385",
    "data-name": "Tracciato 4385",
    d: "M5487.5,1786.414a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.671-.024,54.4,54.4,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.026,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5487.5,1786.414Z",
    transform: "translate(-5218.66 -1677.6)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3217",
    "data-name": "Raggruppa 3217",
    transform: "translate(24.221 293.427)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4386",
    "data-name": "Tracciato 4386",
    d: "M5490.017,1792.7a54.458,54.458,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.67.024,54.4,54.4,0,0,1,108.791.026,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5490.017,1792.7Z",
    transform: "translate(-5221.173 -1683.889)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3218",
    "data-name": "Raggruppa 3218",
    transform: "translate(25.736 297.213)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4387",
    "data-name": "Tracciato 4387",
    d: "M5492.532,1798.991a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,5492.532,1798.991Z",
    transform: "translate(-5223.688 -1690.177)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3219",
    "data-name": "Raggruppa 3219",
    transform: "translate(27.25 301.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4388",
    "data-name": "Tracciato 4388",
    d: "M5495.044,1805.28a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.026h1.559a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025h-1.56a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,5495.044,1805.28Z",
    transform: "translate(-5226.202 -1696.466)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3220",
    "data-name": "Raggruppa 3220",
    transform: "translate(28.764 304.788)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4389",
    "data-name": "Tracciato 4389",
    d: "M5497.558,1811.569a54.455,54.455,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.673.025,54.394,54.394,0,1,1,108.787.024h-1.558a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5497.558,1811.569Z",
    transform: "translate(-5228.716 -1702.755)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3221",
    "data-name": "Raggruppa 3221",
    transform: "translate(30.277 308.575)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4390",
    "data-name": "Tracciato 4390",
    d: "M5500.072,1817.857a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,5500.072,1817.857Z",
    transform: "translate(-5231.228 -1709.044)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3222",
    "data-name": "Raggruppa 3222",
    transform: "translate(31.791 312.362)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4391",
    "data-name": "Tracciato 4391",
    d: "M5502.586,1824.147a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.79-.024h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5502.586,1824.147Z",
    transform: "translate(-5233.743 -1715.333)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3569",
    "data-name": "Raggruppa 3569",
    transform: "translate(4475.706 -370.666)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3310",
    "data-name": "Raggruppa 3310",
    transform: "translate(0.072 12.882)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3225",
    "data-name": "Raggruppa 3225",
    transform: "translate(31.863)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4392",
    "data-name": "Tracciato 4392",
    d: "M4797.581-240.46a54.458,54.458,0,0,1-54.384-54.408,52.894,52.894,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823,54.457,54.457,0,0,1-54.407,54.383,54.458,54.458,0,0,1-54.384-54.408h1.56a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.824,54.457,54.457,0,0,1,54.409-54.381,54.457,54.457,0,0,1,54.381,54.406,52.9,52.9,0,0,0,52.824,52.849,52.894,52.894,0,0,0,52.846-52.824,54.458,54.458,0,0,1,54.41-54.381,54.456,54.456,0,0,1,54.381,54.406h-1.559a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823A54.458,54.458,0,0,1,4797.581-240.46Z",
    transform: "translate(-4528.735 349.274)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3226",
    "data-name": "Raggruppa 3226",
    transform: "translate(30.5 3.438)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4393",
    "data-name": "Tracciato 4393",
    d: "M4795.315-234.751a54.457,54.457,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823,54.456,54.456,0,0,1-54.407,54.383,54.456,54.456,0,0,1-54.381-54.408h1.559a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.824,54.456,54.456,0,0,1,54.406-54.381,54.455,54.455,0,0,1,54.382,54.406,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.383,54.406H4955.4a52.9,52.9,0,0,0-52.826-52.847,52.894,52.894,0,0,0-52.847,52.823A54.458,54.458,0,0,1,4795.315-234.751Z",
    transform: "translate(-4526.473 343.565)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3227",
    "data-name": "Raggruppa 3227",
    transform: "translate(29.135 6.874)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4394",
    "data-name": "Tracciato 4394",
    d: "M4793.05-229.045a54.458,54.458,0,0,1-54.383-54.406,52.9,52.9,0,0,0-52.824-52.849A52.9,52.9,0,0,0,4633-283.476a54.456,54.456,0,0,1-54.407,54.382,54.457,54.457,0,0,1-54.381-54.406h1.559a52.894,52.894,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.849-52.823,54.457,54.457,0,0,1,54.405-54.383,54.457,54.457,0,0,1,54.384,54.408A52.894,52.894,0,0,0,4793.05-230.6a52.9,52.9,0,0,0,52.849-52.823A54.457,54.457,0,0,1,4900.3-337.81a54.456,54.456,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.848,52.824A54.455,54.455,0,0,1,4793.05-229.045Z",
    transform: "translate(-4524.207 337.859)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3228",
    "data-name": "Raggruppa 3228",
    transform: "translate(27.771 10.312)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4395",
    "data-name": "Tracciato 4395",
    d: "M4790.785-223.336a54.458,54.458,0,0,1-54.384-54.406,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.85,52.824,54.456,54.456,0,0,1-54.406,54.382,54.457,54.457,0,0,1-54.382-54.407h1.559a52.9,52.9,0,0,0,52.824,52.847,52.894,52.894,0,0,0,52.848-52.823,54.458,54.458,0,0,1,54.408-54.383,54.456,54.456,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.825,52.847,52.893,52.893,0,0,0,52.847-52.823A54.458,54.458,0,0,1,4898.04-332.1a54.457,54.457,0,0,1,54.381,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.824A54.457,54.457,0,0,1,4790.785-223.336Z",
    transform: "translate(-4521.941 332.15)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3229",
    "data-name": "Raggruppa 3229",
    transform: "translate(26.408 13.75)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4396",
    "data-name": "Tracciato 4396",
    d: "M4788.52-217.627a54.455,54.455,0,0,1-54.381-54.406,52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.825,54.457,54.457,0,0,1-54.408,54.381,54.457,54.457,0,0,1-54.381-54.407h1.559a52.894,52.894,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.85-52.823,54.456,54.456,0,0,1,54.405-54.383,54.458,54.458,0,0,1,54.383,54.408,52.894,52.894,0,0,0,52.823,52.847,52.894,52.894,0,0,0,52.848-52.823,54.458,54.458,0,0,1,54.406-54.383,54.457,54.457,0,0,1,54.384,54.408H4948.6a52.9,52.9,0,0,0-52.825-52.849,52.894,52.894,0,0,0-52.846,52.824A54.457,54.457,0,0,1,4788.52-217.627Z",
    transform: "translate(-4519.678 326.441)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3230",
    "data-name": "Raggruppa 3230",
    transform: "translate(25.043 17.188)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4397",
    "data-name": "Tracciato 4397",
    d: "M4786.254-211.918a54.456,54.456,0,0,1-54.382-54.408,52.9,52.9,0,0,0-52.824-52.847A52.9,52.9,0,0,0,4626.2-266.35a54.457,54.457,0,0,1-54.408,54.383,54.456,54.456,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.824,54.456,54.456,0,0,1,54.406-54.381,54.458,54.458,0,0,1,54.383,54.407,52.9,52.9,0,0,0,52.823,52.849A52.9,52.9,0,0,0,4839.1-266.3a54.456,54.456,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.382,54.407h-1.558a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823A54.457,54.457,0,0,1,4786.254-211.918Z",
    transform: "translate(-4517.412 320.732)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3231",
    "data-name": "Raggruppa 3231",
    transform: "translate(23.679 20.626)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4398",
    "data-name": "Tracciato 4398",
    d: "M4783.99-206.209a54.457,54.457,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823,54.456,54.456,0,0,1-54.406,54.383,54.457,54.457,0,0,1-54.382-54.408h1.559a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.381,54.407,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.847-52.825,54.458,54.458,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.407h-1.559a52.894,52.894,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823A54.457,54.457,0,0,1,4783.99-206.209Z",
    transform: "translate(-4515.146 315.023)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3232",
    "data-name": "Raggruppa 3232",
    transform: "translate(22.316 24.063)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4399",
    "data-name": "Tracciato 4399",
    d: "M4781.725-200.5a54.457,54.457,0,0,1-54.381-54.407,52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.848,52.824,54.456,54.456,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.382-54.406h1.559a52.9,52.9,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.849-52.823,54.455,54.455,0,0,1,54.406-54.382,54.456,54.456,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.85-52.823,54.455,54.455,0,0,1,54.406-54.382,54.458,54.458,0,0,1,54.383,54.408h-1.56a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.848,52.824A54.458,54.458,0,0,1,4781.725-200.5Z",
    transform: "translate(-4512.883 309.316)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3233",
    "data-name": "Raggruppa 3233",
    transform: "translate(20.951 27.501)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4400",
    "data-name": "Tracciato 4400",
    d: "M4779.459-194.793a54.455,54.455,0,0,1-54.38-54.407,52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.825A54.457,54.457,0,0,1,4565-194.843a54.455,54.455,0,0,1-54.381-54.406h1.559A52.9,52.9,0,0,0,4565-196.4a52.9,52.9,0,0,0,52.85-52.823,54.456,54.456,0,0,1,54.406-54.382,54.458,54.458,0,0,1,54.383,54.408,52.9,52.9,0,0,0,52.822,52.847,52.9,52.9,0,0,0,52.849-52.823,54.457,54.457,0,0,1,54.406-54.382A54.457,54.457,0,0,1,4941.1-249.15h-1.559A52.9,52.9,0,0,0,4886.714-302a52.9,52.9,0,0,0-52.848,52.825A54.457,54.457,0,0,1,4779.459-194.793Z",
    transform: "translate(-4510.617 303.607)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3234",
    "data-name": "Raggruppa 3234",
    transform: "translate(19.587 30.939)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4401",
    "data-name": "Tracciato 4401",
    d: "M4777.194-189.084a54.456,54.456,0,0,1-54.382-54.407,52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.848,52.824,54.456,54.456,0,0,1-54.406,54.381,54.455,54.455,0,0,1-54.382-54.406h1.558a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823A54.456,54.456,0,0,1,4669.99-297.9a54.457,54.457,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.825,52.847,52.9,52.9,0,0,0,52.847-52.823,54.456,54.456,0,0,1,54.407-54.382,54.458,54.458,0,0,1,54.382,54.408h-1.56a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.848,52.825A54.457,54.457,0,0,1,4777.194-189.084Z",
    transform: "translate(-4508.352 297.898)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3235",
    "data-name": "Raggruppa 3235",
    transform: "translate(18.222 34.377)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4402",
    "data-name": "Tracciato 4402",
    d: "M4774.929-183.375a54.457,54.457,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823,54.457,54.457,0,0,1-54.407,54.382,54.456,54.456,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.848-52.825,54.455,54.455,0,0,1,54.407-54.381,54.455,54.455,0,0,1,54.381,54.406,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.848-52.824,54.456,54.456,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.381,54.406h-1.558a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.85,52.823A54.454,54.454,0,0,1,4774.929-183.375Z",
    transform: "translate(-4506.085 292.189)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3236",
    "data-name": "Raggruppa 3236",
    transform: "translate(16.859 37.815)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4403",
    "data-name": "Tracciato 4403",
    d: "M4772.663-177.666a54.458,54.458,0,0,1-54.382-54.408,52.894,52.894,0,0,0-52.823-52.847A52.894,52.894,0,0,0,4612.61-232.1a54.457,54.457,0,0,1-54.409,54.382,54.457,54.457,0,0,1-54.381-54.408h1.559a52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.85-52.824,54.455,54.455,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.406,52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.848-52.824,54.457,54.457,0,0,1,54.407-54.381,54.457,54.457,0,0,1,54.383,54.406h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823A54.457,54.457,0,0,1,4772.663-177.666Z",
    transform: "translate(-4503.821 286.48)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3237",
    "data-name": "Raggruppa 3237",
    transform: "translate(15.494 41.251)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4404",
    "data-name": "Tracciato 4404",
    d: "M4770.4-171.96a54.455,54.455,0,0,1-54.383-54.406,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825,54.457,54.457,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.382-54.407h1.559a52.894,52.894,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.407-54.383,54.457,54.457,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.407-54.383,54.457,54.457,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.849,52.824A54.455,54.455,0,0,1,4770.4-171.96Z",
    transform: "translate(-4501.556 280.774)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3238",
    "data-name": "Raggruppa 3238",
    transform: "translate(14.13 44.689)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4405",
    "data-name": "Tracciato 4405",
    d: "M4768.134-166.251a54.457,54.457,0,0,1-54.384-54.406,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.825,54.457,54.457,0,0,1-54.406,54.381,54.457,54.457,0,0,1-54.383-54.406h1.559a52.9,52.9,0,0,0,52.825,52.847,52.9,52.9,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.407-54.383,54.456,54.456,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.407-54.383,54.457,54.457,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.85,52.825A54.454,54.454,0,0,1,4768.134-166.251Z",
    transform: "translate(-4499.29 275.065)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3239",
    "data-name": "Raggruppa 3239",
    transform: "translate(12.767 48.127)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4406",
    "data-name": "Tracciato 4406",
    d: "M4765.868-160.542a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.824-52.847,52.894,52.894,0,0,0-52.848,52.823,54.457,54.457,0,0,1-54.408,54.383A54.458,54.458,0,0,1,4497.025-215h1.559a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.824,54.457,54.457,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.848-52.825,54.458,54.458,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.382,54.406h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.847,52.823A54.457,54.457,0,0,1,4765.868-160.542Z",
    transform: "translate(-4497.025 269.356)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3240",
    "data-name": "Raggruppa 3240",
    transform: "translate(11.402 51.565)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4407",
    "data-name": "Tracciato 4407",
    d: "M4763.6-154.833a54.458,54.458,0,0,1-54.384-54.408,52.892,52.892,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823,54.458,54.458,0,0,1-54.407,54.383,54.457,54.457,0,0,1-54.382-54.408h1.559a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.407,52.9,52.9,0,0,0,52.825,52.849,52.894,52.894,0,0,0,52.847-52.824,54.458,54.458,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.382,54.406h-1.56a52.894,52.894,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,4763.6-154.833Z",
    transform: "translate(-4494.76 263.647)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3241",
    "data-name": "Raggruppa 3241",
    transform: "translate(10.038 55.003)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4408",
    "data-name": "Tracciato 4408",
    d: "M4761.338-149.124a54.458,54.458,0,0,1-54.383-54.408,52.893,52.893,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823,54.457,54.457,0,0,1-54.406,54.383,54.457,54.457,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.825,52.849,52.893,52.893,0,0,0,52.847-52.825,54.458,54.458,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.406,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.824,54.458,54.458,0,0,1,54.408-54.381,54.459,54.459,0,0,1,54.382,54.407h-1.56a52.9,52.9,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823A54.457,54.457,0,0,1,4761.338-149.124Z",
    transform: "translate(-4492.495 257.938)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3242",
    "data-name": "Raggruppa 3242",
    transform: "translate(8.675 58.44)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4409",
    "data-name": "Tracciato 4409",
    d: "M4759.073-143.417a54.456,54.456,0,0,1-54.382-54.406,52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.825,54.456,54.456,0,0,1-54.408,54.381,54.455,54.455,0,0,1-54.381-54.406h1.559a52.894,52.894,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.849-52.823,54.456,54.456,0,0,1,54.406-54.382,54.456,54.456,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.849-52.823,54.456,54.456,0,0,1,54.407-54.382,54.457,54.457,0,0,1,54.382,54.408h-1.56a52.9,52.9,0,0,0-52.825-52.849A52.9,52.9,0,0,0,4813.48-197.8,54.457,54.457,0,0,1,4759.073-143.417Z",
    transform: "translate(-4490.231 252.231)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3243",
    "data-name": "Raggruppa 3243",
    transform: "translate(7.31 61.878)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4410",
    "data-name": "Tracciato 4410",
    d: "M4756.809-137.708a54.457,54.457,0,0,1-54.383-54.407,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.85,52.825,54.456,54.456,0,0,1-54.406,54.381,54.457,54.457,0,0,1-54.383-54.406h1.559a52.9,52.9,0,0,0,52.825,52.847A52.9,52.9,0,0,0,4595.2-192.14a54.456,54.456,0,0,1,54.408-54.382,54.456,54.456,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.408-54.382,54.456,54.456,0,0,1,54.381,54.408h-1.559a52.894,52.894,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.85,52.825A54.454,54.454,0,0,1,4756.809-137.708Z",
    transform: "translate(-4487.965 246.522)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3244",
    "data-name": "Raggruppa 3244",
    transform: "translate(5.946 65.316)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4411",
    "data-name": "Tracciato 4411",
    d: "M4754.542-132a54.458,54.458,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823,54.455,54.455,0,0,1-54.406,54.382,54.456,54.456,0,0,1-54.382-54.408h1.557a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.848-52.824,54.456,54.456,0,0,1,54.407-54.381,54.457,54.457,0,0,1,54.382,54.406,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.406h-1.559a52.894,52.894,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.85,52.823A54.456,54.456,0,0,1,4754.542-132Z",
    transform: "translate(-4485.699 240.813)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3245",
    "data-name": "Raggruppa 3245",
    transform: "translate(4.583 68.754)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4412",
    "data-name": "Tracciato 4412",
    d: "M4752.278-126.29A54.456,54.456,0,0,1,4697.9-180.7a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.848,52.823,54.456,54.456,0,0,1-54.408,54.382,54.456,54.456,0,0,1-54.381-54.408H4485a52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.85-52.825,54.455,54.455,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.407,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.457,54.457,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.384,54.406h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.893,52.893,0,0,0-52.846,52.823A54.458,54.458,0,0,1,4752.278-126.29Z",
    transform: "translate(-4483.436 235.104)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3246",
    "data-name": "Raggruppa 3246",
    transform: "translate(3.218 72.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4413",
    "data-name": "Tracciato 4413",
    d: "M4750.013-120.581a54.457,54.457,0,0,1-54.382-54.408,52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.847,52.823,54.457,54.457,0,0,1-54.408,54.382,54.456,54.456,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.85-52.824,54.455,54.455,0,0,1,54.405-54.381,54.456,54.456,0,0,1,54.383,54.406,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.382,54.406h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.849,52.823A54.455,54.455,0,0,1,4750.013-120.581Z",
    transform: "translate(-4481.17 229.395)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3247",
    "data-name": "Raggruppa 3247",
    transform: "translate(4.581 76.054)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4414",
    "data-name": "Tracciato 4414",
    d: "M4752.274-114.168a54.457,54.457,0,0,1-54.381-54.407,52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.825,54.456,54.456,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.381-54.407h1.559a52.893,52.893,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.849-52.823,54.455,54.455,0,0,1,54.405-54.382,54.457,54.457,0,0,1,54.384,54.408,52.9,52.9,0,0,0,52.822,52.847,52.9,52.9,0,0,0,52.849-52.823,54.456,54.456,0,0,1,54.406-54.382,54.457,54.457,0,0,1,54.384,54.408h-1.56a52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.847,52.825A54.458,54.458,0,0,1,4752.274-114.168Z",
    transform: "translate(-4483.434 222.982)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3248",
    "data-name": "Raggruppa 3248",
    transform: "translate(5.942 79.917)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4415",
    "data-name": "Tracciato 4415",
    d: "M4754.537-107.753a54.457,54.457,0,0,1-54.382-54.407,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.85,52.825,54.456,54.456,0,0,1-54.406,54.381,54.456,54.456,0,0,1-54.382-54.407h1.559a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.408-54.382,54.457,54.457,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.825,52.847,52.9,52.9,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.407-54.382,54.457,54.457,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.848,52.825A54.457,54.457,0,0,1,4754.537-107.753Z",
    transform: "translate(-4485.694 216.567)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3249",
    "data-name": "Raggruppa 3249",
    transform: "translate(7.305 83.78)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4416",
    "data-name": "Tracciato 4416",
    d: "M4756.8-101.338a54.457,54.457,0,0,1-54.383-54.408,52.894,52.894,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823,54.457,54.457,0,0,1-54.407,54.382,54.456,54.456,0,0,1-54.382-54.408h1.559a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.406A52.9,52.9,0,0,0,4756.8-102.9a52.9,52.9,0,0,0,52.847-52.825,54.455,54.455,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.407h-1.559a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823A54.457,54.457,0,0,1,4756.8-101.338Z",
    transform: "translate(-4487.958 210.152)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3250",
    "data-name": "Raggruppa 3250",
    transform: "translate(8.668 87.644)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4417",
    "data-name": "Tracciato 4417",
    d: "M4759.062-94.923a54.456,54.456,0,0,1-54.38-54.408,52.9,52.9,0,0,0-52.824-52.847,52.894,52.894,0,0,0-52.848,52.823A54.457,54.457,0,0,1,4544.6-94.973a54.456,54.456,0,0,1-54.381-54.408h1.559A52.894,52.894,0,0,0,4544.6-96.531a52.9,52.9,0,0,0,52.85-52.825,54.456,54.456,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.85-52.825,54.456,54.456,0,0,1,54.405-54.381,54.457,54.457,0,0,1,54.384,54.407h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823A54.456,54.456,0,0,1,4759.062-94.923Z",
    transform: "translate(-4490.22 203.737)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3251",
    "data-name": "Raggruppa 3251",
    transform: "translate(10.029 91.506)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4418",
    "data-name": "Tracciato 4418",
    d: "M4761.324-88.51a54.457,54.457,0,0,1-54.383-54.407,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.824,54.455,54.455,0,0,1-54.406,54.381,54.457,54.457,0,0,1-54.384-54.406h1.559a52.9,52.9,0,0,0,52.825,52.847,52.894,52.894,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.408-54.382,54.458,54.458,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.825,52.847,52.894,52.894,0,0,0,52.846-52.823,54.458,54.458,0,0,1,54.409-54.382,54.456,54.456,0,0,1,54.38,54.408H4921.4a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.85,52.825A54.455,54.455,0,0,1,4761.324-88.51Z",
    transform: "translate(-4492.48 197.324)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3252",
    "data-name": "Raggruppa 3252",
    transform: "translate(11.393 95.369)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4419",
    "data-name": "Tracciato 4419",
    d: "M4763.587-82.1A54.457,54.457,0,0,1,4709.2-136.5a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.848,52.825,54.458,54.458,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.382-54.406h1.559A52.9,52.9,0,0,0,4549.127-83.7a52.9,52.9,0,0,0,52.847-52.823,54.458,54.458,0,0,1,54.407-54.383,54.457,54.457,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.407-54.383,54.458,54.458,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.85,52.825A54.456,54.456,0,0,1,4763.587-82.1Z",
    transform: "translate(-4494.744 190.909)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3253",
    "data-name": "Raggruppa 3253",
    transform: "translate(12.755 99.232)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4420",
    "data-name": "Tracciato 4420",
    d: "M4765.849-75.68a54.455,54.455,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823,54.458,54.458,0,0,1-54.408,54.383,54.456,54.456,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.406,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.457,54.457,0,0,1,54.407-54.381,54.458,54.458,0,0,1,54.383,54.407h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,4765.849-75.68Z",
    transform: "translate(-4497.007 184.494)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3254",
    "data-name": "Raggruppa 3254",
    transform: "translate(14.116 103.096)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4421",
    "data-name": "Tracciato 4421",
    d: "M4768.111-69.264a54.457,54.457,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823,54.457,54.457,0,0,1-54.406,54.383,54.458,54.458,0,0,1-54.383-54.408h1.56a52.9,52.9,0,0,0,52.824,52.849A52.9,52.9,0,0,0,4606.5-123.7a54.455,54.455,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.381,54.406,52.9,52.9,0,0,0,52.825,52.849,52.894,52.894,0,0,0,52.846-52.824,54.459,54.459,0,0,1,54.408-54.382,54.456,54.456,0,0,1,54.381,54.407h-1.559a52.893,52.893,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823A54.457,54.457,0,0,1,4768.111-69.264Z",
    transform: "translate(-4499.267 178.078)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3255",
    "data-name": "Raggruppa 3255",
    transform: "translate(15.479 106.957)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4422",
    "data-name": "Tracciato 4422",
    d: "M4770.374-62.852a54.458,54.458,0,0,1-54.384-54.406,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.824A54.456,54.456,0,0,1,4555.913-62.9a54.457,54.457,0,0,1-54.383-54.406h1.559a52.894,52.894,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.847-52.823,54.458,54.458,0,0,1,54.408-54.383,54.458,54.458,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.824,52.847,52.893,52.893,0,0,0,52.846-52.823,54.458,54.458,0,0,1,54.409-54.383,54.457,54.457,0,0,1,54.381,54.408h-1.559a52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.824A54.456,54.456,0,0,1,4770.374-62.852Z",
    transform: "translate(-4501.53 171.666)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3256",
    "data-name": "Raggruppa 3256",
    transform: "translate(16.842 110.82)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4423",
    "data-name": "Tracciato 4423",
    d: "M4772.636-56.437a54.456,54.456,0,0,1-54.381-54.407,52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.848,52.825,54.457,54.457,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.382-54.407h1.559a52.894,52.894,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.406-54.383,54.458,54.458,0,0,1,54.383,54.408A52.894,52.894,0,0,0,4772.636-58a52.9,52.9,0,0,0,52.85-52.823,54.457,54.457,0,0,1,54.406-54.383,54.457,54.457,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.849,52.825A54.456,54.456,0,0,1,4772.636-56.437Z",
    transform: "translate(-4503.794 165.251)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3257",
    "data-name": "Raggruppa 3257",
    transform: "translate(18.204 114.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4424",
    "data-name": "Tracciato 4424",
    d: "M4774.9-50.021a54.456,54.456,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.85,52.823,54.456,54.456,0,0,1-54.406,54.383,54.457,54.457,0,0,1-54.382-54.408h1.559a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.455,54.455,0,0,1,54.407-54.381,54.457,54.457,0,0,1,54.382,54.406A52.9,52.9,0,0,0,4774.9-51.58a52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.383,54.406h-1.561a52.892,52.892,0,0,0-52.822-52.847A52.9,52.9,0,0,0,4829.3-104.4,54.456,54.456,0,0,1,4774.9-50.021Z",
    transform: "translate(-4506.055 158.835)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3258",
    "data-name": "Raggruppa 3258",
    transform: "translate(19.566 118.547)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4425",
    "data-name": "Tracciato 4425",
    d: "M4777.161-43.606a54.457,54.457,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.822-52.847A52.9,52.9,0,0,0,4617.1-98.038a54.455,54.455,0,0,1-54.4,54.382,54.458,54.458,0,0,1-54.383-54.408h1.559A52.9,52.9,0,0,0,4562.7-45.214a52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.409-54.381,54.455,54.455,0,0,1,54.38,54.406,52.9,52.9,0,0,0,52.825,52.849,52.894,52.894,0,0,0,52.847-52.824,54.457,54.457,0,0,1,54.408-54.381A54.456,54.456,0,0,1,4938.8-97.965h-1.559a52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,4777.161-43.606Z",
    transform: "translate(-4508.317 152.42)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3259",
    "data-name": "Raggruppa 3259",
    transform: "translate(20.929 122.41)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4426",
    "data-name": "Tracciato 4426",
    d: "M4779.422-37.191A54.457,54.457,0,0,1,4725.041-91.6a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823,54.456,54.456,0,0,1-54.408,54.382,54.456,54.456,0,0,1-54.381-54.408h1.559A52.9,52.9,0,0,0,4564.962-38.8a52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.406-54.381A54.457,54.457,0,0,1,4726.6-91.6a52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.85-52.825,54.456,54.456,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.407h-1.56a52.9,52.9,0,0,0-52.825-52.847,52.893,52.893,0,0,0-52.846,52.823A54.457,54.457,0,0,1,4779.422-37.191Z",
    transform: "translate(-4510.58 146.005)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3260",
    "data-name": "Raggruppa 3260",
    transform: "translate(22.293 126.272)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4427",
    "data-name": "Tracciato 4427",
    d: "M4781.686-30.778a54.456,54.456,0,0,1-54.381-54.406,52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.824,54.456,54.456,0,0,1-54.408,54.381,54.455,54.455,0,0,1-54.381-54.407h1.559a52.894,52.894,0,0,0,52.822,52.847,52.9,52.9,0,0,0,52.849-52.823,54.455,54.455,0,0,1,54.405-54.382,54.456,54.456,0,0,1,54.383,54.408,52.9,52.9,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.849-52.823,54.457,54.457,0,0,1,54.407-54.382,54.457,54.457,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.847,52.825A54.458,54.458,0,0,1,4781.686-30.778Z",
    transform: "translate(-4512.844 139.592)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3261",
    "data-name": "Raggruppa 3261",
    transform: "translate(23.653 130.135)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4428",
    "data-name": "Tracciato 4428",
    d: "M4783.948-24.363a54.456,54.456,0,0,1-54.383-54.406,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.85,52.824,54.455,54.455,0,0,1-54.406,54.381A54.457,54.457,0,0,1,4515.1-78.819h1.559a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.408-54.383,54.456,54.456,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.825,52.847,52.894,52.894,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.409-54.382,54.455,54.455,0,0,1,54.38,54.408h-1.558a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825A54.457,54.457,0,0,1,4783.948-24.363Z",
    transform: "translate(-4515.104 133.177)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3262",
    "data-name": "Raggruppa 3262",
    transform: "translate(25.016 133.999)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4429",
    "data-name": "Tracciato 4429",
    d: "M4786.209-17.948a54.457,54.457,0,0,1-54.381-54.408A52.9,52.9,0,0,0,4679-125.2a52.9,52.9,0,0,0-52.848,52.823A54.455,54.455,0,0,1,4571.748-18a54.457,54.457,0,0,1-54.38-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.85-52.825A54.455,54.455,0,0,1,4679-126.762a54.456,54.456,0,0,1,54.382,54.406,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.382,54.406h-1.558a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.848,52.823A54.455,54.455,0,0,1,4786.209-17.948Z",
    transform: "translate(-4517.368 126.762)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3263",
    "data-name": "Raggruppa 3263",
    transform: "translate(26.379 137.862)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4430",
    "data-name": "Tracciato 4430",
    d: "M4788.472-11.533a54.458,54.458,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823,54.457,54.457,0,0,1-54.407,54.383A54.457,54.457,0,0,1,4519.63-65.99h1.559a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.848-52.825,54.458,54.458,0,0,1,54.407-54.381A54.457,54.457,0,0,1,4735.65-65.94a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.406-54.381,54.458,54.458,0,0,1,54.383,54.407h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,4788.472-11.533Z",
    transform: "translate(-4519.63 120.347)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3264",
    "data-name": "Raggruppa 3264",
    transform: "translate(27.741 141.724)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4431",
    "data-name": "Tracciato 4431",
    d: "M4790.735-5.12a54.457,54.457,0,0,1-54.384-54.406,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.85,52.825A54.456,54.456,0,0,1,4576.274-5.17a54.458,54.458,0,0,1-54.383-54.406h1.56a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.408-54.383,54.456,54.456,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.825,52.847A52.894,52.894,0,0,0,4843.583-59.5a54.456,54.456,0,0,1,54.407-54.383,54.456,54.456,0,0,1,54.382,54.408h-1.558a52.9,52.9,0,0,0-52.824-52.849A52.9,52.9,0,0,0,4845.142-59.5,54.457,54.457,0,0,1,4790.735-5.12Z",
    transform: "translate(-4521.891 113.934)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3265",
    "data-name": "Raggruppa 3265",
    transform: "translate(29.103 145.587)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4432",
    "data-name": "Tracciato 4432",
    d: "M4793,1.295a54.456,54.456,0,0,1-54.381-54.406,52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.848,52.825,54.456,54.456,0,0,1-54.408,54.382,54.457,54.457,0,0,1-54.381-54.407h1.559A52.894,52.894,0,0,0,4578.536-.313a52.9,52.9,0,0,0,52.849-52.823,54.457,54.457,0,0,1,54.406-54.383,54.456,54.456,0,0,1,54.382,54.408A52.9,52.9,0,0,0,4793-.264a52.9,52.9,0,0,0,52.849-52.823,54.457,54.457,0,0,1,54.407-54.383,54.457,54.457,0,0,1,54.382,54.408h-1.558a52.9,52.9,0,0,0-52.826-52.849A52.9,52.9,0,0,0,4847.4-53.087,54.457,54.457,0,0,1,4793,1.295Z",
    transform: "translate(-4524.153 107.519)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3266",
    "data-name": "Raggruppa 3266",
    transform: "translate(30.466 149.451)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4433",
    "data-name": "Tracciato 4433",
    d: "M4795.259,7.711A54.458,54.458,0,0,1,4740.877-46.7a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.847,52.823A54.456,54.456,0,0,1,4580.8,7.661a54.457,54.457,0,0,1-54.381-54.408h1.558A52.9,52.9,0,0,0,4580.8,6.1a52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.407-54.381A54.457,54.457,0,0,1,4742.437-46.7a52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.85-52.825,54.456,54.456,0,0,1,54.406-54.381A54.457,54.457,0,0,1,4956.9-46.648h-1.559A52.9,52.9,0,0,0,4902.514-99.5a52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,4795.259,7.711Z",
    transform: "translate(-4526.417 101.103)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3267",
    "data-name": "Raggruppa 3267",
    transform: "translate(31.828 153.314)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4434",
    "data-name": "Tracciato 4434",
    d: "M4797.521,14.126a54.457,54.457,0,0,1-54.382-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823,54.456,54.456,0,0,1-54.406,54.383,54.457,54.457,0,0,1-54.383-54.408h1.559a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825,54.456,54.456,0,0,1,54.408-54.381A54.456,54.456,0,0,1,4744.7-40.282a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.382,54.406H4957.6a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823A54.457,54.457,0,0,1,4797.521,14.126Z",
    transform: "translate(-4528.678 94.688)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3268",
    "data-name": "Raggruppa 3268",
    transform: "translate(30.313 157.1)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4435",
    "data-name": "Tracciato 4435",
    d: "M4795.005,20.413A54.458,54.458,0,0,1,4740.623-34,52.894,52.894,0,0,0,4687.8-86.842a52.9,52.9,0,0,0-52.848,52.823,54.458,54.458,0,0,1-54.407,54.383,54.456,54.456,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825A54.458,54.458,0,0,1,4687.8-88.4a54.458,54.458,0,0,1,54.383,54.407,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.456,54.456,0,0,1,54.407-54.381,54.457,54.457,0,0,1,54.381,54.407h-1.559a52.894,52.894,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.85,52.823A54.456,54.456,0,0,1,4795.005,20.413Z",
    transform: "translate(-4526.163 88.401)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3269",
    "data-name": "Raggruppa 3269",
    transform: "translate(28.797 160.887)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4436",
    "data-name": "Tracciato 4436",
    d: "M4792.487,26.7a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.848,52.823,54.456,54.456,0,0,1-54.408,54.382,54.456,54.456,0,0,1-54.38-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.824,54.457,54.457,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.383,54.407h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,4792.487,26.7Z",
    transform: "translate(-4523.646 82.113)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3270",
    "data-name": "Raggruppa 3270",
    transform: "translate(27.282 164.673)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4437",
    "data-name": "Tracciato 4437",
    d: "M4789.971,32.989a54.457,54.457,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823,54.456,54.456,0,0,1-54.408,54.382,54.456,54.456,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.407-54.381,54.455,54.455,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.382,54.406h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,4789.971,32.989Z",
    transform: "translate(-4521.129 75.825)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3271",
    "data-name": "Raggruppa 3271",
    transform: "translate(25.766 168.46)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4438",
    "data-name": "Tracciato 4438",
    d: "M4787.455,39.277a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.824-52.847A52.9,52.9,0,0,0,4627.4-15.156a54.457,54.457,0,0,1-54.408,54.383,54.456,54.456,0,0,1-54.381-54.408h1.559a52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.85-52.825,54.455,54.455,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.382,54.406,52.9,52.9,0,0,0,52.823,52.849A52.9,52.9,0,0,0,4840.3-15.106a54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.384,54.406h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.893,52.893,0,0,0-52.846,52.823A54.459,54.459,0,0,1,4787.455,39.277Z",
    transform: "translate(-4518.613 69.537)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3272",
    "data-name": "Raggruppa 3272",
    transform: "translate(24.25 172.246)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4439",
    "data-name": "Tracciato 4439",
    d: "M4784.938,45.564a54.457,54.457,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823,54.457,54.457,0,0,1-54.406,54.383,54.456,54.456,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.824A54.457,54.457,0,0,1,4892.192-63.2a54.456,54.456,0,0,1,54.382,54.407h-1.56a52.893,52.893,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,4784.938,45.564Z",
    transform: "translate(-4516.095 63.25)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3273",
    "data-name": "Raggruppa 3273",
    transform: "translate(22.735 176.033)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4440",
    "data-name": "Tracciato 4440",
    d: "M4782.421,51.852a54.457,54.457,0,0,1-54.383-54.408A52.9,52.9,0,0,0,4675.216-55.4,52.9,52.9,0,0,0,4622.367-2.58,54.457,54.457,0,0,1,4567.96,51.8a54.456,54.456,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.408-54.381A54.458,54.458,0,0,1,4729.6-2.555a52.9,52.9,0,0,0,52.823,52.849A52.9,52.9,0,0,0,4835.27-2.531a54.457,54.457,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.381,54.407H4942.5a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,4782.421,51.852Z",
    transform: "translate(-4513.578 56.962)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3274",
    "data-name": "Raggruppa 3274",
    transform: "translate(21.219 179.819)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4441",
    "data-name": "Tracciato 4441",
    d: "M4779.9,58.14a54.457,54.457,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4779.9,58.14Z",
    transform: "translate(-4511.062 50.674)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3275",
    "data-name": "Raggruppa 3275",
    transform: "translate(19.704 183.606)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4442",
    "data-name": "Tracciato 4442",
    d: "M4777.387,64.428a54.458,54.458,0,0,1-54.382-54.408A52.836,52.836,0,0,0,4617.333,10a54.394,54.394,0,1,1-108.789-.025h1.558A52.836,52.836,0,1,0,4615.775,10a54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.025A54.455,54.455,0,0,1,4777.387,64.428Z",
    transform: "translate(-4508.545 44.386)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3276",
    "data-name": "Raggruppa 3276",
    transform: "translate(18.187 187.392)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4443",
    "data-name": "Tracciato 4443",
    d: "M4774.87,70.715a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4774.87,70.715Z",
    transform: "translate(-4506.026 38.099)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3277",
    "data-name": "Raggruppa 3277",
    transform: "translate(16.671 191.179)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4444",
    "data-name": "Tracciato 4444",
    d: "M4772.354,77a54.458,54.458,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.456,54.456,0,0,1,4772.354,77Z",
    transform: "translate(-4503.51 31.811)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3278",
    "data-name": "Raggruppa 3278",
    transform: "translate(15.156 194.966)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4445",
    "data-name": "Tracciato 4445",
    d: "M4769.837,83.291a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.671-.025A54.456,54.456,0,0,1,4769.837,83.291Z",
    transform: "translate(-4500.994 25.523)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3279",
    "data-name": "Raggruppa 3279",
    transform: "translate(13.641 198.752)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4446",
    "data-name": "Tracciato 4446",
    d: "M4767.32,89.579a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025H4927.4a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,4767.32,89.579Z",
    transform: "translate(-4498.479 19.235)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3280",
    "data-name": "Raggruppa 3280",
    transform: "translate(12.125 202.538)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4447",
    "data-name": "Tracciato 4447",
    d: "M4764.8,95.866a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4764.8,95.866Z",
    transform: "translate(-4495.961 12.948)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3281",
    "data-name": "Raggruppa 3281",
    transform: "translate(10.608 206.325)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4448",
    "data-name": "Tracciato 4448",
    d: "M4762.286,102.154A54.455,54.455,0,0,1,4707.9,47.746a52.837,52.837,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025H4495a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4762.286,102.154Z",
    transform: "translate(-4493.442 6.66)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3282",
    "data-name": "Raggruppa 3282",
    transform: "translate(9.093 210.112)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4449",
    "data-name": "Tracciato 4449",
    d: "M4759.77,108.442a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4759.77,108.442Z",
    transform: "translate(-4490.926 0.372)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3283",
    "data-name": "Raggruppa 3283",
    transform: "translate(7.578 213.898)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4450",
    "data-name": "Tracciato 4450",
    d: "M4757.254,114.73a54.458,54.458,0,0,1-54.384-54.408A52.835,52.835,0,0,0,4597.2,60.3a54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4757.254,114.73Z",
    transform: "translate(-4488.41 -5.916)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3284",
    "data-name": "Raggruppa 3284",
    transform: "translate(6.063 217.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4451",
    "data-name": "Tracciato 4451",
    d: "M4754.736,121.017a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.456,54.456,0,0,1,4754.736,121.017Z",
    transform: "translate(-4485.894 -12.203)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3285",
    "data-name": "Raggruppa 3285",
    transform: "translate(4.547 221.471)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4452",
    "data-name": "Tracciato 4452",
    d: "M4752.219,127.3A54.457,54.457,0,0,1,4697.838,72.9a52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025H4912.3a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4752.219,127.3Z",
    transform: "translate(-4483.377 -18.491)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3286",
    "data-name": "Raggruppa 3286",
    transform: "translate(3.031 225.258)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4453",
    "data-name": "Tracciato 4453",
    d: "M4749.7,133.593a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4749.7,133.593Z",
    transform: "translate(-4480.859 -24.779)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3287",
    "data-name": "Raggruppa 3287",
    transform: "translate(1.515 229.044)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4454",
    "data-name": "Tracciato 4454",
    d: "M4747.186,139.881A54.458,54.458,0,0,1,4692.8,85.473a52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.561a52.835,52.835,0,0,0-105.67-.024A54.458,54.458,0,0,1,4747.186,139.881Z",
    transform: "translate(-4478.342 -31.067)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3288",
    "data-name": "Raggruppa 3288",
    transform: "translate(0 232.831)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4455",
    "data-name": "Tracciato 4455",
    d: "M4744.67,146.168a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,4744.67,146.168Z",
    transform: "translate(-4475.827 -37.354)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3289",
    "data-name": "Raggruppa 3289",
    transform: "translate(1.513 236.618)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4456",
    "data-name": "Tracciato 4456",
    d: "M4747.183,152.457A54.456,54.456,0,0,1,4692.8,98.049a52.836,52.836,0,0,0-105.672-.024A54.395,54.395,0,1,1,4478.339,98h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.791.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4747.183,152.457Z",
    transform: "translate(-4478.339 -43.643)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3290",
    "data-name": "Raggruppa 3290",
    transform: "translate(3.027 240.405)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4457",
    "data-name": "Tracciato 4457",
    d: "M4749.7,158.746a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,4749.7,158.746Z",
    transform: "translate(-4480.853 -49.932)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3291",
    "data-name": "Raggruppa 3291",
    transform: "translate(4.542 244.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4458",
    "data-name": "Tracciato 4458",
    d: "M4752.211,165.035a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4752.211,165.035Z",
    transform: "translate(-4483.369 -56.221)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3292",
    "data-name": "Raggruppa 3292",
    transform: "translate(6.056 247.98)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4459",
    "data-name": "Tracciato 4459",
    d: "M4754.724,171.324a54.458,54.458,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025H4914.8a52.837,52.837,0,0,0-105.673-.025A54.455,54.455,0,0,1,4754.724,171.324Z",
    transform: "translate(-4485.882 -62.51)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3293",
    "data-name": "Raggruppa 3293",
    transform: "translate(7.569 251.767)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4460",
    "data-name": "Tracciato 4460",
    d: "M4757.239,177.613a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4757.239,177.613Z",
    transform: "translate(-4488.395 -68.799)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3294",
    "data-name": "Raggruppa 3294",
    transform: "translate(9.083 255.554)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4461",
    "data-name": "Tracciato 4461",
    d: "M4759.753,183.9a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.457,54.457,0,0,1,4759.753,183.9Z",
    transform: "translate(-4490.91 -75.088)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3295",
    "data-name": "Raggruppa 3295",
    transform: "translate(10.596 259.342)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4462",
    "data-name": "Tracciato 4462",
    d: "M4762.266,190.191a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4762.266,190.191Z",
    transform: "translate(-4493.422 -81.377)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3296",
    "data-name": "Raggruppa 3296",
    transform: "translate(12.112 263.128)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4463",
    "data-name": "Tracciato 4463",
    d: "M4764.78,196.479a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.671-.024A54.458,54.458,0,0,1,4764.78,196.479Z",
    transform: "translate(-4495.938 -87.665)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3297",
    "data-name": "Raggruppa 3297",
    transform: "translate(13.626 266.916)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4464",
    "data-name": "Tracciato 4464",
    d: "M4767.293,202.768a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4767.293,202.768Z",
    transform: "translate(-4498.452 -93.954)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3298",
    "data-name": "Raggruppa 3298",
    transform: "translate(15.139 270.703)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4465",
    "data-name": "Tracciato 4465",
    d: "M4769.809,209.057a54.457,54.457,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,4769.809,209.057Z",
    transform: "translate(-4500.965 -100.243)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3299",
    "data-name": "Raggruppa 3299",
    transform: "translate(16.652 274.49)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4466",
    "data-name": "Tracciato 4466",
    d: "M4772.322,215.346a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025H4932.4a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4772.322,215.346Z",
    transform: "translate(-4503.478 -106.532)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3300",
    "data-name": "Raggruppa 3300",
    transform: "translate(18.166 278.277)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4467",
    "data-name": "Tracciato 4467",
    d: "M4774.836,221.635a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.454,54.454,0,0,1,4774.836,221.635Z",
    transform: "translate(-4505.993 -112.821)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3301",
    "data-name": "Raggruppa 3301",
    transform: "translate(19.681 282.065)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4468",
    "data-name": "Tracciato 4468",
    d: "M4777.35,227.924a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4777.35,227.924Z",
    transform: "translate(-4508.508 -119.11)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3302",
    "data-name": "Raggruppa 3302",
    transform: "translate(21.195 285.852)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4469",
    "data-name": "Tracciato 4469",
    d: "M4779.863,234.213a54.457,54.457,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4779.863,234.213Z",
    transform: "translate(-4511.021 -125.399)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3303",
    "data-name": "Raggruppa 3303",
    transform: "translate(22.708 289.639)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4470",
    "data-name": "Tracciato 4470",
    d: "M4782.377,240.5a54.458,54.458,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4782.377,240.5Z",
    transform: "translate(-4513.534 -131.688)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3304",
    "data-name": "Raggruppa 3304",
    transform: "translate(24.222 293.427)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4471",
    "data-name": "Tracciato 4471",
    d: "M4784.891,246.791a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,0,1,108.791.025,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.673-.024A54.456,54.456,0,0,1,4784.891,246.791Z",
    transform: "translate(-4516.048 -137.977)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3305",
    "data-name": "Raggruppa 3305",
    transform: "translate(25.737 297.214)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4472",
    "data-name": "Tracciato 4472",
    d: "M4787.406,253.08a54.455,54.455,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4787.406,253.08Z",
    transform: "translate(-4518.563 -144.266)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3306",
    "data-name": "Raggruppa 3306",
    transform: "translate(27.251 301.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4473",
    "data-name": "Tracciato 4473",
    d: "M4789.919,259.368a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025H4950a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,4789.919,259.368Z",
    transform: "translate(-4521.077 -150.554)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3307",
    "data-name": "Raggruppa 3307",
    transform: "translate(28.764 304.788)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4474",
    "data-name": "Tracciato 4474",
    d: "M4792.432,265.657a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.67-.025A54.457,54.457,0,0,1,4792.432,265.657Z",
    transform: "translate(-4523.59 -156.843)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3308",
    "data-name": "Raggruppa 3308",
    transform: "translate(30.278 308.575)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4475",
    "data-name": "Tracciato 4475",
    d: "M4794.948,271.946a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.025A54.456,54.456,0,0,1,4794.948,271.946Z",
    transform: "translate(-4526.104 -163.132)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3309",
    "data-name": "Raggruppa 3309",
    transform: "translate(31.791 312.362)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4476",
    "data-name": "Tracciato 4476",
    d: "M4797.46,278.235a54.457,54.457,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.455,54.455,0,0,1,4797.46,278.235Z",
    transform: "translate(-4528.617 -169.421)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3396",
    "data-name": "Raggruppa 3396",
    transform: "translate(0 328.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3311",
    "data-name": "Raggruppa 3311",
    transform: "translate(31.863 0)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4477",
    "data-name": "Tracciato 4477",
    d: "M4797.46,282.812a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,4797.46,282.812Z",
    transform: "translate(-4528.616 -173.998)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3312",
    "data-name": "Raggruppa 3312",
    transform: "translate(30.5 3.438)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4478",
    "data-name": "Tracciato 4478",
    d: "M4795.194,288.521a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4795.194,288.521Z",
    transform: "translate(-4526.354 -179.707)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3313",
    "data-name": "Raggruppa 3313",
    transform: "translate(29.135 6.875)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4479",
    "data-name": "Tracciato 4479",
    d: "M4792.928,294.228a54.455,54.455,0,0,1-54.38-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4792.928,294.228Z",
    transform: "translate(-4524.087 -185.414)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3314",
    "data-name": "Raggruppa 3314",
    transform: "translate(27.771 10.313)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4480",
    "data-name": "Tracciato 4480",
    d: "M4790.665,299.937a54.456,54.456,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.56a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.788.025h-1.557a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4790.665,299.937Z",
    transform: "translate(-4521.82 -191.123)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3315",
    "data-name": "Raggruppa 3315",
    transform: "translate(26.407 13.751)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4481",
    "data-name": "Tracciato 4481",
    d: "M4788.4,305.646a54.458,54.458,0,0,1-54.381-54.407,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4788.4,305.646Z",
    transform: "translate(-4519.557 -196.832)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3316",
    "data-name": "Raggruppa 3316",
    transform: "translate(25.043 17.189)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4482",
    "data-name": "Tracciato 4482",
    d: "M4786.134,311.355a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.791.025,52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.025A54.456,54.456,0,0,1,4786.134,311.355Z",
    transform: "translate(-4517.292 -202.541)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3317",
    "data-name": "Raggruppa 3317",
    transform: "translate(23.679 20.627)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4483",
    "data-name": "Tracciato 4483",
    d: "M4783.869,317.064a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.673-.025A54.457,54.457,0,0,1,4783.869,317.064Z",
    transform: "translate(-4515.026 -208.25)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3318",
    "data-name": "Raggruppa 3318",
    transform: "translate(22.316 24.063)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4484",
    "data-name": "Tracciato 4484",
    d: "M4781.6,322.77a54.456,54.456,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.79-.025h1.56a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025h-1.558a52.835,52.835,0,1,0-105.671-.025A54.458,54.458,0,0,1,4781.6,322.77Z",
    transform: "translate(-4512.762 -213.956)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3319",
    "data-name": "Raggruppa 3319",
    transform: "translate(20.951 27.501)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4485",
    "data-name": "Tracciato 4485",
    d: "M4779.338,328.479a54.457,54.457,0,0,1-54.381-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,4779.338,328.479Z",
    transform: "translate(-4510.496 -219.665)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3320",
    "data-name": "Raggruppa 3320",
    transform: "translate(19.586 30.939)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4486",
    "data-name": "Tracciato 4486",
    d: "M4777.073,334.188a54.457,54.457,0,0,1-54.382-54.406,52.835,52.835,0,1,0-105.671-.024,54.4,54.4,0,0,1-108.791-.025h1.56a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.835,52.835,0,1,0-105.671-.025A54.457,54.457,0,0,1,4777.073,334.188Z",
    transform: "translate(-4508.229 -225.374)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3321",
    "data-name": "Raggruppa 3321",
    transform: "translate(18.222 34.377)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4487",
    "data-name": "Tracciato 4487",
    d: "M4774.808,339.9a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4774.808,339.9Z",
    transform: "translate(-4505.964 -231.083)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3322",
    "data-name": "Raggruppa 3322",
    transform: "translate(16.859 37.815)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4488",
    "data-name": "Tracciato 4488",
    d: "M4772.543,345.606a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4772.543,345.606Z",
    transform: "translate(-4503.701 -236.792)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3323",
    "data-name": "Raggruppa 3323",
    transform: "translate(15.494 41.252)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4489",
    "data-name": "Tracciato 4489",
    d: "M4770.28,351.313a54.456,54.456,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,4770.28,351.313Z",
    transform: "translate(-4501.436 -242.499)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3324",
    "data-name": "Raggruppa 3324",
    transform: "translate(14.13 44.69)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4490",
    "data-name": "Tracciato 4490",
    d: "M4768.013,357.022a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,4768.013,357.022Z",
    transform: "translate(-4499.169 -248.208)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3325",
    "data-name": "Raggruppa 3325",
    transform: "translate(12.767 48.128)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4491",
    "data-name": "Tracciato 4491",
    d: "M4765.749,362.731a54.456,54.456,0,0,1-54.382-54.408A52.836,52.836,0,0,0,4605.7,308.3a54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4765.749,362.731Z",
    transform: "translate(-4496.906 -253.917)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3326",
    "data-name": "Raggruppa 3326",
    transform: "translate(11.402 51.566)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4492",
    "data-name": "Tracciato 4492",
    d: "M4763.484,368.44a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4763.484,368.44Z",
    transform: "translate(-4494.64 -259.626)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3327",
    "data-name": "Raggruppa 3327",
    transform: "translate(10.038 55.004)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4493",
    "data-name": "Tracciato 4493",
    d: "M4761.218,374.149a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025H4921.3a52.836,52.836,0,0,0-105.673-.025A54.455,54.455,0,0,1,4761.218,374.149Z",
    transform: "translate(-4492.374 -265.335)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3328",
    "data-name": "Raggruppa 3328",
    transform: "translate(8.675 58.44)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4494",
    "data-name": "Tracciato 4494",
    d: "M4758.954,379.855a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025,52.835,52.835,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,4758.954,379.855Z",
    transform: "translate(-4490.111 -271.041)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3329",
    "data-name": "Raggruppa 3329",
    transform: "translate(7.31 61.878)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4495",
    "data-name": "Tracciato 4495",
    d: "M4756.688,385.564a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.79-.025h1.56a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,4756.688,385.564Z",
    transform: "translate(-4487.845 -276.75)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3330",
    "data-name": "Raggruppa 3330",
    transform: "translate(5.946 65.316)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4496",
    "data-name": "Tracciato 4496",
    d: "M4754.422,391.273a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025H4914.5a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4754.422,391.273Z",
    transform: "translate(-4485.579 -282.459)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3331",
    "data-name": "Raggruppa 3331",
    transform: "translate(4.582 68.754)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4497",
    "data-name": "Tracciato 4497",
    d: "M4752.158,396.982a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.458,54.458,0,0,1,4752.158,396.982Z",
    transform: "translate(-4483.316 -288.168)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3332",
    "data-name": "Raggruppa 3332",
    transform: "translate(3.217 72.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4498",
    "data-name": "Tracciato 4498",
    d: "M4749.892,402.691a54.457,54.457,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.024,54.4,54.4,0,1,1-108.791-.025h1.56a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.459,54.459,0,0,1,4749.892,402.691Z",
    transform: "translate(-4481.049 -293.877)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3333",
    "data-name": "Raggruppa 3333",
    transform: "translate(4.581 76.054)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4499",
    "data-name": "Tracciato 4499",
    d: "M4752.154,409.1a54.455,54.455,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.56a52.835,52.835,0,0,0,105.671.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,4752.154,409.1Z",
    transform: "translate(-4483.313 -300.29)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3334",
    "data-name": "Raggruppa 3334",
    transform: "translate(5.942 79.917)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4500",
    "data-name": "Tracciato 4500",
    d: "M4754.417,415.519a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.79-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025H4914.5a52.836,52.836,0,1,0-105.672-.025A54.455,54.455,0,0,1,4754.417,415.519Z",
    transform: "translate(-4485.573 -306.705)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3335",
    "data-name": "Raggruppa 3335",
    transform: "translate(7.305 83.781)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4501",
    "data-name": "Tracciato 4501",
    d: "M4756.68,421.935a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.67-.024A54.457,54.457,0,0,1,4756.68,421.935Z",
    transform: "translate(-4487.836 -313.121)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3336",
    "data-name": "Raggruppa 3336",
    transform: "translate(8.668 87.644)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4502",
    "data-name": "Tracciato 4502",
    d: "M4758.942,428.35a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,4758.942,428.35Z",
    transform: "translate(-4490.1 -319.536)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3337",
    "data-name": "Raggruppa 3337",
    transform: "translate(10.029 91.506)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4503",
    "data-name": "Tracciato 4503",
    d: "M4761.2,434.762a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,4761.2,434.762Z",
    transform: "translate(-4492.359 -325.948)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3338",
    "data-name": "Raggruppa 3338",
    transform: "translate(11.392 95.369)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4504",
    "data-name": "Tracciato 4504",
    d: "M4763.467,441.178a54.458,54.458,0,0,1-54.384-54.407,52.836,52.836,0,1,0-105.671-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.456,54.456,0,0,1,4763.467,441.178Z",
    transform: "translate(-4494.624 -332.364)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3339",
    "data-name": "Raggruppa 3339",
    transform: "translate(12.755 99.232)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4505",
    "data-name": "Tracciato 4505",
    d: "M4765.728,447.593a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,4765.728,447.593Z",
    transform: "translate(-4496.886 -338.779)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3340",
    "data-name": "Raggruppa 3340",
    transform: "translate(14.116 103.096)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4506",
    "data-name": "Tracciato 4506",
    d: "M4767.991,454.008a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4767.991,454.008Z",
    transform: "translate(-4499.147 -345.194)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3341",
    "data-name": "Raggruppa 3341",
    transform: "translate(15.479 106.958)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4507",
    "data-name": "Tracciato 4507",
    d: "M4770.253,460.421a54.457,54.457,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,4770.253,460.421Z",
    transform: "translate(-4501.41 -351.607)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3342",
    "data-name": "Raggruppa 3342",
    transform: "translate(16.842 110.821)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4508",
    "data-name": "Tracciato 4508",
    d: "M4772.515,466.836a54.457,54.457,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.673-.024A54.454,54.454,0,0,1,4772.515,466.836Z",
    transform: "translate(-4503.673 -358.022)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3343",
    "data-name": "Raggruppa 3343",
    transform: "translate(18.204 114.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4509",
    "data-name": "Tracciato 4509",
    d: "M4774.777,473.251a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4774.777,473.251Z",
    transform: "translate(-4505.934 -364.437)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3344",
    "data-name": "Raggruppa 3344",
    transform: "translate(19.566 118.547)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4510",
    "data-name": "Tracciato 4510",
    d: "M4777.041,479.666a54.457,54.457,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4777.041,479.666Z",
    transform: "translate(-4508.197 -370.852)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3345",
    "data-name": "Raggruppa 3345",
    transform: "translate(20.929 122.411)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4511",
    "data-name": "Tracciato 4511",
    d: "M4779.3,486.082a54.458,54.458,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4779.3,486.082Z",
    transform: "translate(-4510.46 -377.268)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3346",
    "data-name": "Raggruppa 3346",
    transform: "translate(22.292 126.272)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4512",
    "data-name": "Tracciato 4512",
    d: "M4781.564,492.494a54.456,54.456,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.673-.025,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.673-.025A54.456,54.456,0,0,1,4781.564,492.494Z",
    transform: "translate(-4512.723 -383.68)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3347",
    "data-name": "Raggruppa 3347",
    transform: "translate(23.653 130.136)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4513",
    "data-name": "Tracciato 4513",
    d: "M4783.828,498.91a54.456,54.456,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.671.024A54.395,54.395,0,1,1,4731,444.5a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4783.828,498.91Z",
    transform: "translate(-4514.984 -390.096)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3348",
    "data-name": "Raggruppa 3348",
    transform: "translate(25.016 133.999)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4514",
    "data-name": "Tracciato 4514",
    d: "M4786.089,505.325a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.557a52.836,52.836,0,1,0,105.673.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4786.089,505.325Z",
    transform: "translate(-4517.247 -396.511)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3349",
    "data-name": "Raggruppa 3349",
    transform: "translate(26.379 137.862)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4515",
    "data-name": "Tracciato 4515",
    d: "M4788.353,511.74a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.025A54.455,54.455,0,0,1,4788.353,511.74Z",
    transform: "translate(-4519.51 -402.926)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3350",
    "data-name": "Raggruppa 3350",
    transform: "translate(27.741 141.724)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4516",
    "data-name": "Tracciato 4516",
    d: "M4790.614,518.153a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4790.614,518.153Z",
    transform: "translate(-4521.771 -409.339)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3351",
    "data-name": "Raggruppa 3351",
    transform: "translate(29.104 145.587)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4517",
    "data-name": "Tracciato 4517",
    d: "M4792.876,524.568a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.673-.024,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.787.025h-1.557a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,4792.876,524.568Z",
    transform: "translate(-4524.034 -415.754)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3352",
    "data-name": "Raggruppa 3352",
    transform: "translate(30.466 149.451)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4518",
    "data-name": "Tracciato 4518",
    d: "M4795.14,530.983a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,4795.14,530.983Z",
    transform: "translate(-4526.297 -422.169)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3353",
    "data-name": "Raggruppa 3353",
    transform: "translate(31.827 153.314)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4519",
    "data-name": "Tracciato 4519",
    d: "M4797.4,537.4a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4797.4,537.4Z",
    transform: "translate(-4528.558 -428.584)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3354",
    "data-name": "Raggruppa 3354",
    transform: "translate(30.312 157.1)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4520",
    "data-name": "Tracciato 4520",
    d: "M4794.885,543.686a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,4794.885,543.686Z",
    transform: "translate(-4526.041 -434.872)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3355",
    "data-name": "Raggruppa 3355",
    transform: "translate(28.797 160.887)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4521",
    "data-name": "Tracciato 4521",
    d: "M4792.367,549.974a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.671-.025A54.459,54.459,0,0,1,4792.367,549.974Z",
    transform: "translate(-4523.524 -441.16)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3356",
    "data-name": "Raggruppa 3356",
    transform: "translate(27.282 164.673)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4522",
    "data-name": "Tracciato 4522",
    d: "M4789.852,556.261a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4789.852,556.261Z",
    transform: "translate(-4521.009 -447.447)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3357",
    "data-name": "Raggruppa 3357",
    transform: "translate(25.766 168.46)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4523",
    "data-name": "Tracciato 4523",
    d: "M4787.334,562.549a54.457,54.457,0,0,1-54.381-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,4787.334,562.549Z",
    transform: "translate(-4518.492 -453.735)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3358",
    "data-name": "Raggruppa 3358",
    transform: "translate(24.25 172.247)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4524",
    "data-name": "Tracciato 4524",
    d: "M4784.818,568.837a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025H4944.9a52.836,52.836,0,0,0-105.672-.025A54.459,54.459,0,0,1,4784.818,568.837Z",
    transform: "translate(-4515.974 -460.023)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3359",
    "data-name": "Raggruppa 3359",
    transform: "translate(22.734 176.033)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4525",
    "data-name": "Tracciato 4525",
    d: "M4782.3,575.125a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.025h-1.561a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,4782.3,575.125Z",
    transform: "translate(-4513.457 -466.311)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3360",
    "data-name": "Raggruppa 3360",
    transform: "translate(21.219 179.819)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4526",
    "data-name": "Tracciato 4526",
    d: "M4779.783,581.412A54.456,54.456,0,0,1,4725.4,527a52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4779.783,581.412Z",
    transform: "translate(-4510.941 -472.598)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3361",
    "data-name": "Raggruppa 3361",
    transform: "translate(19.704 183.606)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4527",
    "data-name": "Tracciato 4527",
    d: "M4777.267,587.7a54.455,54.455,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4777.267,587.7Z",
    transform: "translate(-4508.425 -478.886)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3362",
    "data-name": "Raggruppa 3362",
    transform: "translate(18.187 187.393)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4528",
    "data-name": "Tracciato 4528",
    d: "M4774.75,593.988a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.457,54.457,0,0,1,4774.75,593.988Z",
    transform: "translate(-4505.906 -485.174)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3363",
    "data-name": "Raggruppa 3363",
    transform: "translate(16.672 191.179)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4529",
    "data-name": "Tracciato 4529",
    d: "M4772.233,600.276a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4772.233,600.276Z",
    transform: "translate(-4503.391 -491.462)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3364",
    "data-name": "Raggruppa 3364",
    transform: "translate(15.156 194.966)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4530",
    "data-name": "Tracciato 4530",
    d: "M4769.717,606.563a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4769.717,606.563Z",
    transform: "translate(-4500.874 -497.749)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3365",
    "data-name": "Raggruppa 3365",
    transform: "translate(13.641 198.752)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4531",
    "data-name": "Tracciato 4531",
    d: "M4767.2,612.851a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,4767.2,612.851Z",
    transform: "translate(-4498.357 -504.037)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3366",
    "data-name": "Raggruppa 3366",
    transform: "translate(12.125 202.539)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4532",
    "data-name": "Tracciato 4532",
    d: "M4764.683,619.139a54.457,54.457,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,4764.683,619.139Z",
    transform: "translate(-4495.841 -510.325)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3367",
    "data-name": "Raggruppa 3367",
    transform: "translate(10.608 206.326)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4533",
    "data-name": "Tracciato 4533",
    d: "M4762.165,625.427a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.671-.024A54.459,54.459,0,0,1,4762.165,625.427Z",
    transform: "translate(-4493.321 -516.613)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3368",
    "data-name": "Raggruppa 3368",
    transform: "translate(9.093 210.112)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4534",
    "data-name": "Tracciato 4534",
    d: "M4759.649,631.714a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.024A54.457,54.457,0,0,1,4759.649,631.714Z",
    transform: "translate(-4490.806 -522.9)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3369",
    "data-name": "Raggruppa 3369",
    transform: "translate(7.578 213.898)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4535",
    "data-name": "Tracciato 4535",
    d: "M4757.133,638a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.837,52.837,0,0,0-105.673-.024A54.455,54.455,0,0,1,4757.133,638Z",
    transform: "translate(-4488.29 -529.188)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3370",
    "data-name": "Raggruppa 3370",
    transform: "translate(6.062 217.685)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4536",
    "data-name": "Tracciato 4536",
    d: "M4754.616,644.29a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025H4914.7a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,4754.616,644.29Z",
    transform: "translate(-4485.773 -535.476)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3371",
    "data-name": "Raggruppa 3371",
    transform: "translate(4.547 221.472)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4537",
    "data-name": "Tracciato 4537",
    d: "M4752.1,650.578a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4752.1,650.578Z",
    transform: "translate(-4483.257 -541.764)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3372",
    "data-name": "Raggruppa 3372",
    transform: "translate(3.03 225.258)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4538",
    "data-name": "Tracciato 4538",
    d: "M4749.582,656.865a54.457,54.457,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4749.582,656.865Z",
    transform: "translate(-4480.738 -548.051)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3373",
    "data-name": "Raggruppa 3373",
    transform: "translate(1.515 229.044)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4539",
    "data-name": "Tracciato 4539",
    d: "M4747.066,663.153a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4747.066,663.153Z",
    transform: "translate(-4478.223 -554.339)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3374",
    "data-name": "Raggruppa 3374",
    transform: "translate(0 232.831)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4540",
    "data-name": "Tracciato 4540",
    d: "M4744.549,669.441a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.457,54.457,0,0,1,4744.549,669.441Z",
    transform: "translate(-4475.706 -560.627)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3375",
    "data-name": "Raggruppa 3375",
    transform: "translate(1.513 236.618)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4541",
    "data-name": "Tracciato 4541",
    d: "M4747.063,675.73a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4747.063,675.73Z",
    transform: "translate(-4478.219 -566.916)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3376",
    "data-name": "Raggruppa 3376",
    transform: "translate(3.027 240.406)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4542",
    "data-name": "Tracciato 4542",
    d: "M4749.576,682.019a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,4749.576,682.019Z",
    transform: "translate(-4480.732 -573.205)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3377",
    "data-name": "Raggruppa 3377",
    transform: "translate(4.542 244.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4543",
    "data-name": "Tracciato 4543",
    d: "M4752.09,688.307a54.459,54.459,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4752.09,688.307Z",
    transform: "translate(-4483.248 -579.493)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3378",
    "data-name": "Raggruppa 3378",
    transform: "translate(6.056 247.98)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4544",
    "data-name": "Tracciato 4544",
    d: "M4754.6,694.6a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4754.6,694.6Z",
    transform: "translate(-4485.762 -585.782)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3379",
    "data-name": "Raggruppa 3379",
    transform: "translate(7.569 251.767)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4545",
    "data-name": "Tracciato 4545",
    d: "M4757.119,700.885a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025H4917.2a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,4757.119,700.885Z",
    transform: "translate(-4488.275 -592.071)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3380",
    "data-name": "Raggruppa 3380",
    transform: "translate(9.083 255.554)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4546",
    "data-name": "Tracciato 4546",
    d: "M4759.632,707.174a54.457,54.457,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,4759.632,707.174Z",
    transform: "translate(-4490.789 -598.36)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3381",
    "data-name": "Raggruppa 3381",
    transform: "translate(10.596 259.342)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4547",
    "data-name": "Tracciato 4547",
    d: "M4762.145,713.463a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,4762.145,713.463Z",
    transform: "translate(-4493.302 -604.649)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3382",
    "data-name": "Raggruppa 3382",
    transform: "translate(12.112 263.129)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4548",
    "data-name": "Tracciato 4548",
    d: "M4764.661,719.752a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025h-1.557a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,4764.661,719.752Z",
    transform: "translate(-4495.818 -610.938)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3383",
    "data-name": "Raggruppa 3383",
    transform: "translate(13.625 266.916)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4549",
    "data-name": "Tracciato 4549",
    d: "M4767.173,726.041a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,4767.173,726.041Z",
    transform: "translate(-4498.331 -617.227)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3384",
    "data-name": "Raggruppa 3384",
    transform: "translate(15.139 270.703)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4550",
    "data-name": "Tracciato 4550",
    d: "M4769.688,732.33a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.458,54.458,0,0,1,4769.688,732.33Z",
    transform: "translate(-4500.845 -623.516)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3385",
    "data-name": "Raggruppa 3385",
    transform: "translate(16.652 274.491)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4551",
    "data-name": "Tracciato 4551",
    d: "M4772.2,738.619a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.557a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,4772.2,738.619Z",
    transform: "translate(-4503.358 -629.805)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3386",
    "data-name": "Raggruppa 3386",
    transform: "translate(18.166 278.278)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4552",
    "data-name": "Tracciato 4552",
    d: "M4774.714,744.908a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,4774.714,744.908Z",
    transform: "translate(-4505.871 -636.094)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3387",
    "data-name": "Raggruppa 3387",
    transform: "translate(19.681 282.065)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4553",
    "data-name": "Tracciato 4553",
    d: "M4777.229,751.2a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,4777.229,751.2Z",
    transform: "translate(-4508.387 -642.382)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3388",
    "data-name": "Raggruppa 3388",
    transform: "translate(21.195 285.852)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4554",
    "data-name": "Tracciato 4554",
    d: "M4779.744,757.485a54.455,54.455,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025h-1.557a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,4779.744,757.485Z",
    transform: "translate(-4510.901 -648.671)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3389",
    "data-name": "Raggruppa 3389",
    transform: "translate(22.708 289.639)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4555",
    "data-name": "Tracciato 4555",
    d: "M4782.258,763.774a54.458,54.458,0,0,1-54.384-54.406,52.835,52.835,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.673.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.673-.025A54.455,54.455,0,0,1,4782.258,763.774Z",
    transform: "translate(-4513.414 -654.96)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3390",
    "data-name": "Raggruppa 3390",
    transform: "translate(24.221 293.427)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4556",
    "data-name": "Tracciato 4556",
    d: "M4784.771,770.063a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.67-.025A54.457,54.457,0,0,1,4784.771,770.063Z",
    transform: "translate(-4515.927 -661.249)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3391",
    "data-name": "Raggruppa 3391",
    transform: "translate(25.736 297.214)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4557",
    "data-name": "Tracciato 4557",
    d: "M4787.284,776.352a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.789-.025H4520a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,4787.284,776.352Z",
    transform: "translate(-4518.443 -667.538)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3392",
    "data-name": "Raggruppa 3392",
    transform: "translate(27.251 301.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4558",
    "data-name": "Tracciato 4558",
    d: "M4789.8,782.641a54.457,54.457,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,4789.8,782.641Z",
    transform: "translate(-4520.958 -673.827)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3393",
    "data-name": "Raggruppa 3393",
    transform: "translate(28.764 304.788)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4559",
    "data-name": "Tracciato 4559",
    d: "M4792.312,788.93a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.558a52.835,52.835,0,1,0-105.671-.024A54.458,54.458,0,0,1,4792.312,788.93Z",
    transform: "translate(-4523.47 -680.116)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3394",
    "data-name": "Raggruppa 3394",
    transform: "translate(30.277 308.576)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4560",
    "data-name": "Tracciato 4560",
    d: "M4794.827,795.219a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.4,54.4,0,0,1,108.79.025H4954.9a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,4794.827,795.219Z",
    transform: "translate(-4525.983 -686.405)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3395",
    "data-name": "Raggruppa 3395",
    transform: "translate(31.791 312.363)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4561",
    "data-name": "Tracciato 4561",
    d: "M4797.34,801.508a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.673-.024A54.456,54.456,0,0,1,4797.34,801.508Z",
    transform: "translate(-4528.497 -692.694)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3482",
    "data-name": "Raggruppa 3482",
    transform: "translate(427.559)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3397",
    "data-name": "Raggruppa 3397",
    transform: "translate(31.863)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4562",
    "data-name": "Tracciato 4562",
    d: "M5507.447-261.852a54.457,54.457,0,0,1-54.384-54.408,52.9,52.9,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.85,52.823,54.458,54.458,0,0,1-54.407,54.383,54.458,54.458,0,0,1-54.383-54.408h1.56a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.848-52.825,54.456,54.456,0,0,1,54.408-54.381,54.455,54.455,0,0,1,54.379,54.406,52.9,52.9,0,0,0,52.827,52.849,52.894,52.894,0,0,0,52.846-52.824,54.458,54.458,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.382,54.406h-1.558a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,5507.447-261.852Z",
    transform: "translate(-5238.602 370.666)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3398",
    "data-name": "Raggruppa 3398",
    transform: "translate(30.5 3.438)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4563",
    "data-name": "Tracciato 4563",
    d: "M5505.181-256.143a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823,54.457,54.457,0,0,1-54.407,54.383,54.457,54.457,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.824,54.456,54.456,0,0,1,54.405-54.381,54.457,54.457,0,0,1,54.384,54.407,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.407h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,5505.181-256.143Z",
    transform: "translate(-5236.339 364.957)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3399",
    "data-name": "Raggruppa 3399",
    transform: "translate(29.136 6.875)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4564",
    "data-name": "Tracciato 4564",
    d: "M5502.915-250.436a54.456,54.456,0,0,1-54.38-54.407,52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.824,54.457,54.457,0,0,1-54.408,54.381,54.456,54.456,0,0,1-54.381-54.407h1.559a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.407-54.382,54.457,54.457,0,0,1,54.383,54.408,52.894,52.894,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.849-52.823,54.455,54.455,0,0,1,54.406-54.382,54.455,54.455,0,0,1,54.382,54.408h-1.558a52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.824A54.457,54.457,0,0,1,5502.915-250.436Z",
    transform: "translate(-5234.073 359.25)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3400",
    "data-name": "Raggruppa 3400",
    transform: "translate(27.771 10.313)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4565",
    "data-name": "Tracciato 4565",
    d: "M5500.652-244.727a54.457,54.457,0,0,1-54.384-54.406,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.824,54.457,54.457,0,0,1-54.406,54.381,54.456,54.456,0,0,1-54.382-54.407h1.558a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.407-54.382,54.457,54.457,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.825,52.847,52.9,52.9,0,0,0,52.847-52.823,54.456,54.456,0,0,1,54.407-54.382,54.457,54.457,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825A54.455,54.455,0,0,1,5500.652-244.727Z",
    transform: "translate(-5231.808 353.541)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3401",
    "data-name": "Raggruppa 3401",
    transform: "translate(26.408 13.751)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4566",
    "data-name": "Tracciato 4566",
    d: "M5498.385-239.018A54.455,54.455,0,0,1,5444-293.425a52.9,52.9,0,0,0-52.826-52.849,52.9,52.9,0,0,0-52.847,52.824,54.456,54.456,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.382-54.407h1.558a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.406-54.382,54.457,54.457,0,0,1,54.384,54.408,52.9,52.9,0,0,0,52.822,52.847,52.9,52.9,0,0,0,52.85-52.823,54.456,54.456,0,0,1,54.406-54.382,54.458,54.458,0,0,1,54.383,54.408h-1.56a52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.848,52.824A54.457,54.457,0,0,1,5498.385-239.018Z",
    transform: "translate(-5229.544 347.832)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3402",
    "data-name": "Raggruppa 3402",
    transform: "translate(25.043 17.189)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4567",
    "data-name": "Tracciato 4567",
    d: "M5496.121-233.309a54.457,54.457,0,0,1-54.382-54.408,52.9,52.9,0,0,0-52.824-52.847,52.894,52.894,0,0,0-52.847,52.823,54.458,54.458,0,0,1-54.409,54.383,54.456,54.456,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.85-52.825,54.455,54.455,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.384,54.406,52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.849-52.824,54.455,54.455,0,0,1,54.405-54.381,54.457,54.457,0,0,1,54.384,54.406H5656.2a52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823A54.458,54.458,0,0,1,5496.121-233.309Z",
    transform: "translate(-5227.278 342.123)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3403",
    "data-name": "Raggruppa 3403",
    transform: "translate(23.679 20.627)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4568",
    "data-name": "Tracciato 4568",
    d: "M5493.855-227.6a54.457,54.457,0,0,1-54.382-54.408,52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,5279.4-227.65a54.456,54.456,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.824,54.455,54.455,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.382,54.406,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.382,54.406h-1.56a52.9,52.9,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.85,52.823A54.456,54.456,0,0,1,5493.855-227.6Z",
    transform: "translate(-5225.013 336.414)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3404",
    "data-name": "Raggruppa 3404",
    transform: "translate(22.316 24.063)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4569",
    "data-name": "Tracciato 4569",
    d: "M5491.591-221.894A54.455,54.455,0,0,1,5437.21-276.3a52.9,52.9,0,0,0-52.826-52.849,52.9,52.9,0,0,0-52.847,52.824,54.456,54.456,0,0,1-54.407,54.382,54.457,54.457,0,0,1-54.382-54.406h1.559A52.9,52.9,0,0,0,5277.13-223.5a52.894,52.894,0,0,0,52.849-52.823,54.457,54.457,0,0,1,54.407-54.383,54.458,54.458,0,0,1,54.383,54.408,52.893,52.893,0,0,0,52.822,52.847,52.9,52.9,0,0,0,52.849-52.823,54.457,54.457,0,0,1,54.406-54.383,54.458,54.458,0,0,1,54.384,54.408h-1.559a52.9,52.9,0,0,0-52.826-52.849A52.9,52.9,0,0,0,5546-276.276,54.456,54.456,0,0,1,5491.591-221.894Z",
    transform: "translate(-5222.748 330.708)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3405",
    "data-name": "Raggruppa 3405",
    transform: "translate(20.951 27.501)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4570",
    "data-name": "Tracciato 4570",
    d: "M5489.327-216.185a54.456,54.456,0,0,1-54.383-54.406,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.825,54.457,54.457,0,0,1-54.407,54.381,54.457,54.457,0,0,1-54.382-54.407h1.558a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.85-52.823A54.456,54.456,0,0,1,5382.121-325a54.458,54.458,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.405-54.383,54.458,54.458,0,0,1,54.384,54.408h-1.559a52.9,52.9,0,0,0-52.826-52.849,52.9,52.9,0,0,0-52.847,52.824A54.456,54.456,0,0,1,5489.327-216.185Z",
    transform: "translate(-5220.483 324.999)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3406",
    "data-name": "Raggruppa 3406",
    transform: "translate(19.587 30.939)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4571",
    "data-name": "Tracciato 4571",
    d: "M5487.061-210.476a54.457,54.457,0,0,1-54.383-54.406,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.825,54.457,54.457,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.382-54.407h1.559a52.9,52.9,0,0,0,52.824,52.847,52.894,52.894,0,0,0,52.847-52.823,54.458,54.458,0,0,1,54.409-54.383,54.456,54.456,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.825,52.847,52.9,52.9,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.407-54.383,54.457,54.457,0,0,1,54.381,54.408h-1.558a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825A54.455,54.455,0,0,1,5487.061-210.476Z",
    transform: "translate(-5218.217 319.29)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3407",
    "data-name": "Raggruppa 3407",
    transform: "translate(18.222 34.377)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4572",
    "data-name": "Tracciato 4572",
    d: "M5484.8-204.767a54.456,54.456,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823,54.457,54.457,0,0,1-54.407,54.383,54.456,54.456,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825,54.458,54.458,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.381,54.406,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.824,54.456,54.456,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.381,54.406h-1.558a52.9,52.9,0,0,0-52.824-52.847A52.9,52.9,0,0,0,5539.2-259.15,54.457,54.457,0,0,1,5484.8-204.767Z",
    transform: "translate(-5215.952 313.581)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3408",
    "data-name": "Raggruppa 3408",
    transform: "translate(16.859 37.815)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4573",
    "data-name": "Tracciato 4573",
    d: "M5482.528-199.058a54.455,54.455,0,0,1-54.379-54.408,52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.848,52.823,54.457,54.457,0,0,1-54.407,54.383,54.457,54.457,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.824,54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.406,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.407h-1.56a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,5482.528-199.058Z",
    transform: "translate(-5213.688 307.872)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3409",
    "data-name": "Raggruppa 3409",
    transform: "translate(15.494 41.252)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4574",
    "data-name": "Tracciato 4574",
    d: "M5480.265-193.351a54.457,54.457,0,0,1-54.383-54.406,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.825A54.456,54.456,0,0,1,5265.8-193.4a54.457,54.457,0,0,1-54.383-54.406h1.558a52.9,52.9,0,0,0,52.825,52.847,52.893,52.893,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.41-54.382,54.457,54.457,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.825,52.847,52.9,52.9,0,0,0,52.847-52.823,54.456,54.456,0,0,1,54.408-54.382,54.458,54.458,0,0,1,54.381,54.408h-1.561a52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.825A54.456,54.456,0,0,1,5480.265-193.351Z",
    transform: "translate(-5211.421 302.165)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3410",
    "data-name": "Raggruppa 3410",
    transform: "translate(14.13 44.69)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4575",
    "data-name": "Tracciato 4575",
    d: "M5478-187.642a54.457,54.457,0,0,1-54.382-54.406,52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.847,52.824,54.457,54.457,0,0,1-54.407,54.381,54.455,54.455,0,0,1-54.382-54.406h1.558a52.9,52.9,0,0,0,52.825,52.847,52.894,52.894,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.408-54.382,54.457,54.457,0,0,1,54.381,54.408A52.9,52.9,0,0,0,5478-189.2a52.9,52.9,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.407-54.382A54.459,54.459,0,0,1,5639.637-242h-1.561a52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.825A54.457,54.457,0,0,1,5478-187.642Z",
    transform: "translate(-5209.156 296.456)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3411",
    "data-name": "Raggruppa 3411",
    transform: "translate(12.767 48.128)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4576",
    "data-name": "Tracciato 4576",
    d: "M5475.734-181.933a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823,54.457,54.457,0,0,1-54.408,54.382,54.456,54.456,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.85-52.825,54.456,54.456,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.382,54.406,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.384,54.406h-1.56a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,5475.734-181.933Z",
    transform: "translate(-5206.892 290.747)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3412",
    "data-name": "Raggruppa 3412",
    transform: "translate(11.402 51.566)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4577",
    "data-name": "Tracciato 4577",
    d: "M5473.47-176.224a54.457,54.457,0,0,1-54.383-54.408,52.894,52.894,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.849,52.823,54.457,54.457,0,0,1-54.406,54.382,54.458,54.458,0,0,1-54.383-54.408h1.559a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.406,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.456,54.456,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.406h-1.559a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823A54.457,54.457,0,0,1,5473.47-176.224Z",
    transform: "translate(-5204.626 285.038)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3413",
    "data-name": "Raggruppa 3413",
    transform: "translate(10.038 55.004)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4578",
    "data-name": "Tracciato 4578",
    d: "M5471.2-170.515a54.458,54.458,0,0,1-54.383-54.408A52.894,52.894,0,0,0,5364-277.771a52.9,52.9,0,0,0-52.851,52.823,54.454,54.454,0,0,1-54.405,54.382,54.456,54.456,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.824A54.455,54.455,0,0,1,5364-279.329a54.454,54.454,0,0,1,54.38,54.406,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.824,54.456,54.456,0,0,1,54.408-54.381,54.455,54.455,0,0,1,54.381,54.406h-1.557a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.458,54.458,0,0,1,5471.2-170.515Z",
    transform: "translate(-5202.361 279.329)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3414",
    "data-name": "Raggruppa 3414",
    transform: "translate(8.675 58.44)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4579",
    "data-name": "Tracciato 4579",
    d: "M5468.939-164.809a54.456,54.456,0,0,1-54.382-54.406,52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.848,52.825,54.457,54.457,0,0,1-54.407,54.381,54.455,54.455,0,0,1-54.381-54.407h1.56a52.892,52.892,0,0,0,52.822,52.847,52.9,52.9,0,0,0,52.85-52.823,54.456,54.456,0,0,1,54.406-54.383,54.457,54.457,0,0,1,54.382,54.408,52.9,52.9,0,0,0,52.824,52.847,52.894,52.894,0,0,0,52.848-52.823,54.458,54.458,0,0,1,54.406-54.383,54.457,54.457,0,0,1,54.384,54.408h-1.559a52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.824A54.456,54.456,0,0,1,5468.939-164.809Z",
    transform: "translate(-5200.097 273.623)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3415",
    "data-name": "Raggruppa 3415",
    transform: "translate(7.31 61.878)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4580",
    "data-name": "Tracciato 4580",
    d: "M5466.675-159.1a54.456,54.456,0,0,1-54.382-54.406,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.824,54.457,54.457,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.382-54.406h1.559a52.9,52.9,0,0,0,52.824,52.847,52.894,52.894,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.409-54.383,54.456,54.456,0,0,1,54.38,54.408,52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.408-54.383,54.457,54.457,0,0,1,54.381,54.408h-1.559a52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.85,52.825A54.455,54.455,0,0,1,5466.675-159.1Z",
    transform: "translate(-5197.831 267.914)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3416",
    "data-name": "Raggruppa 3416",
    transform: "translate(5.946 65.316)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4581",
    "data-name": "Tracciato 4581",
    d: "M5464.409-153.391a54.459,54.459,0,0,1-54.384-54.408,52.892,52.892,0,0,0-52.821-52.847,52.9,52.9,0,0,0-52.851,52.823,54.456,54.456,0,0,1-54.405,54.383,54.457,54.457,0,0,1-54.383-54.408h1.559A52.9,52.9,0,0,0,5249.948-155a52.9,52.9,0,0,0,52.848-52.825A54.456,54.456,0,0,1,5357.2-262.2a54.455,54.455,0,0,1,54.38,54.407,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825,54.458,54.458,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.406h-1.558a52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823A54.457,54.457,0,0,1,5464.409-153.391Z",
    transform: "translate(-5195.565 262.205)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3417",
    "data-name": "Raggruppa 3417",
    transform: "translate(4.583 68.754)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4582",
    "data-name": "Tracciato 4582",
    d: "M5462.144-147.682a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823,54.457,54.457,0,0,1-54.407,54.383,54.456,54.456,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.406,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.85-52.825,54.456,54.456,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.407h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.457,54.457,0,0,1,5462.144-147.682Z",
    transform: "translate(-5193.302 256.496)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3418",
    "data-name": "Raggruppa 3418",
    transform: "translate(3.218 72.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4583",
    "data-name": "Tracciato 4583",
    d: "M5459.878-141.973a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823,54.458,54.458,0,0,1-54.408,54.383,54.456,54.456,0,0,1-54.38-54.408h1.557a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.824,54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.407,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.824,54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.407h-1.559a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.457,54.457,0,0,1,5459.878-141.973Z",
    transform: "translate(-5191.037 250.787)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3419",
    "data-name": "Raggruppa 3419",
    transform: "translate(4.581 76.054)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4584",
    "data-name": "Tracciato 4584",
    d: "M5462.141-135.56a54.456,54.456,0,0,1-54.381-54.406,52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.847,52.824,54.456,54.456,0,0,1-54.408,54.381,54.455,54.455,0,0,1-54.381-54.406h1.558a52.9,52.9,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.848-52.823,54.458,54.458,0,0,1,54.406-54.383,54.456,54.456,0,0,1,54.383,54.408,52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.849-52.823,54.456,54.456,0,0,1,54.406-54.383,54.456,54.456,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825A54.454,54.454,0,0,1,5462.141-135.56Z",
    transform: "translate(-5193.299 244.374)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3420",
    "data-name": "Raggruppa 3420",
    transform: "translate(5.942 79.917)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4585",
    "data-name": "Tracciato 4585",
    d: "M5464.4-129.145a54.457,54.457,0,0,1-54.384-54.406A52.9,52.9,0,0,0,5357.2-236.4a52.9,52.9,0,0,0-52.849,52.825,54.457,54.457,0,0,1-54.407,54.382,54.457,54.457,0,0,1-54.382-54.406h1.558a52.9,52.9,0,0,0,52.826,52.847,52.9,52.9,0,0,0,52.847-52.823,54.456,54.456,0,0,1,54.407-54.383,54.458,54.458,0,0,1,54.382,54.408A52.894,52.894,0,0,0,5464.4-130.7a52.9,52.9,0,0,0,52.848-52.823,54.455,54.455,0,0,1,54.407-54.383A54.456,54.456,0,0,1,5626.04-183.5h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.824A54.456,54.456,0,0,1,5464.4-129.145Z",
    transform: "translate(-5195.559 237.959)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3421",
    "data-name": "Raggruppa 3421",
    transform: "translate(7.306 83.781)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4586",
    "data-name": "Tracciato 4586",
    d: "M5466.667-122.729a54.458,54.458,0,0,1-54.383-54.408,52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823,54.458,54.458,0,0,1-54.407,54.383,54.456,54.456,0,0,1-54.381-54.408h1.557a52.9,52.9,0,0,0,52.826,52.849,52.9,52.9,0,0,0,52.846-52.825,54.457,54.457,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.382,54.406,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.456,54.456,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.381,54.406h-1.559a52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,5466.667-122.729Z",
    transform: "translate(-5197.824 231.543)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3422",
    "data-name": "Raggruppa 3422",
    transform: "translate(8.668 87.644)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4587",
    "data-name": "Tracciato 4587",
    d: "M5468.928-116.314a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823,54.456,54.456,0,0,1-54.407,54.383,54.457,54.457,0,0,1-54.381-54.408h1.559a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.824,54.456,54.456,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.406,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.85-52.824,54.455,54.455,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.382,54.406h-1.56a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,5468.928-116.314Z",
    transform: "translate(-5200.086 225.128)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3423",
    "data-name": "Raggruppa 3423",
    transform: "translate(10.029 91.506)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4588",
    "data-name": "Tracciato 4588",
    d: "M5471.189-109.9a54.456,54.456,0,0,1-54.382-54.407,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825,54.458,54.458,0,0,1-54.406,54.381,54.458,54.458,0,0,1-54.383-54.407h1.56a52.9,52.9,0,0,0,52.823,52.847,52.894,52.894,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.407-54.383,54.456,54.456,0,0,1,54.38,54.408,52.9,52.9,0,0,0,52.825,52.847,52.894,52.894,0,0,0,52.847-52.823,54.458,54.458,0,0,1,54.408-54.383,54.456,54.456,0,0,1,54.382,54.408h-1.558a52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.849,52.824A54.456,54.456,0,0,1,5471.189-109.9Z",
    transform: "translate(-5202.346 218.716)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3424",
    "data-name": "Raggruppa 3424",
    transform: "translate(11.392 95.369)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4589",
    "data-name": "Tracciato 4589",
    d: "M5473.453-103.486a54.458,54.458,0,0,1-54.383-54.407,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.849,52.825,54.457,54.457,0,0,1-54.407,54.381,54.458,54.458,0,0,1-54.383-54.407h1.56a52.9,52.9,0,0,0,52.824,52.847,52.894,52.894,0,0,0,52.847-52.823,54.456,54.456,0,0,1,54.408-54.382,54.456,54.456,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.409-54.382,54.456,54.456,0,0,1,54.38,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.824A54.457,54.457,0,0,1,5473.453-103.486Z",
    transform: "translate(-5204.608 212.3)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3425",
    "data-name": "Raggruppa 3425",
    transform: "translate(12.755 99.232)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4590",
    "data-name": "Tracciato 4590",
    d: "M5475.715-97.071a54.457,54.457,0,0,1-54.382-54.408,52.9,52.9,0,0,0-52.824-52.847,52.894,52.894,0,0,0-52.848,52.823,54.456,54.456,0,0,1-54.407,54.383,54.456,54.456,0,0,1-54.382-54.408h1.559a52.9,52.9,0,0,0,52.823,52.849A52.9,52.9,0,0,0,5314.1-151.5a54.456,54.456,0,0,1,54.406-54.381,54.458,54.458,0,0,1,54.384,54.406,52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.849-52.825,54.455,54.455,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.406h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823A54.458,54.458,0,0,1,5475.715-97.071Z",
    transform: "translate(-5206.873 205.885)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3426",
    "data-name": "Raggruppa 3426",
    transform: "translate(14.116 103.096)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4591",
    "data-name": "Tracciato 4591",
    d: "M5477.976-90.656a54.457,54.457,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823,54.457,54.457,0,0,1-54.407,54.382,54.457,54.457,0,0,1-54.382-54.408h1.558a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.847-52.825,54.458,54.458,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.406,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.381,54.407h-1.56a52.894,52.894,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.85,52.823A54.455,54.455,0,0,1,5477.976-90.656Z",
    transform: "translate(-5209.132 199.47)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3427",
    "data-name": "Raggruppa 3427",
    transform: "translate(15.479 106.958)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4592",
    "data-name": "Tracciato 4592",
    d: "M5480.241-84.243a54.458,54.458,0,0,1-54.383-54.407,52.9,52.9,0,0,0-52.822-52.849,52.9,52.9,0,0,0-52.85,52.825,54.456,54.456,0,0,1-54.406,54.381A54.457,54.457,0,0,1,5211.4-138.7h1.558a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.408-54.382,54.456,54.456,0,0,1,54.381,54.408A52.9,52.9,0,0,0,5480.241-85.8a52.894,52.894,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.408-54.382,54.457,54.457,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825A54.457,54.457,0,0,1,5480.241-84.243Z",
    transform: "translate(-5211.397 193.057)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3428",
    "data-name": "Raggruppa 3428",
    transform: "translate(16.842 110.821)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4593",
    "data-name": "Tracciato 4593",
    d: "M5482.5-77.828a54.457,54.457,0,0,1-54.38-54.407,52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.847,52.825,54.458,54.458,0,0,1-54.409,54.381,54.456,54.456,0,0,1-54.381-54.406h1.56a52.893,52.893,0,0,0,52.822,52.847,52.9,52.9,0,0,0,52.848-52.823,54.458,54.458,0,0,1,54.407-54.383,54.456,54.456,0,0,1,54.382,54.408A52.894,52.894,0,0,0,5482.5-79.387a52.9,52.9,0,0,0,52.849-52.823,54.457,54.457,0,0,1,54.407-54.382,54.458,54.458,0,0,1,54.382,54.408h-1.559a52.9,52.9,0,0,0-52.824-52.849,52.9,52.9,0,0,0-52.847,52.825A54.457,54.457,0,0,1,5482.5-77.828Z",
    transform: "translate(-5213.659 186.642)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3429",
    "data-name": "Raggruppa 3429",
    transform: "translate(18.204 114.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4594",
    "data-name": "Tracciato 4594",
    d: "M5484.763-71.413a54.458,54.458,0,0,1-54.383-54.408,52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823A54.457,54.457,0,0,1,5270.3-71.463a54.457,54.457,0,0,1-54.383-54.408h1.557A52.9,52.9,0,0,0,5270.3-73.021a52.9,52.9,0,0,0,52.847-52.825,54.457,54.457,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.381,54.407h-1.558a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.85,52.823A54.455,54.455,0,0,1,5484.763-71.413Z",
    transform: "translate(-5215.92 180.227)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3430",
    "data-name": "Raggruppa 3430",
    transform: "translate(19.566 118.547)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4595",
    "data-name": "Tracciato 4595",
    d: "M5487.027-65a54.458,54.458,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.85,52.823,54.456,54.456,0,0,1-54.406,54.383,54.458,54.458,0,0,1-54.383-54.408h1.559a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.458,54.458,0,0,1,54.408-54.381,54.455,54.455,0,0,1,54.38,54.407,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.848-52.825,54.456,54.456,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.382,54.406h-1.558a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,5487.027-65Z",
    transform: "translate(-5218.183 173.812)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3431",
    "data-name": "Raggruppa 3431",
    transform: "translate(20.929 122.411)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4596",
    "data-name": "Tracciato 4596",
    d: "M5489.289-58.582a54.458,54.458,0,0,1-54.383-54.408,52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823,54.455,54.455,0,0,1-54.407,54.383,54.457,54.457,0,0,1-54.381-54.408H5222a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.849-52.824,54.455,54.455,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.406,52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.848-52.825,54.458,54.458,0,0,1,54.408-54.382,54.456,54.456,0,0,1,54.382,54.407h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823A54.458,54.458,0,0,1,5489.289-58.582Z",
    transform: "translate(-5220.446 167.396)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3432",
    "data-name": "Raggruppa 3432",
    transform: "translate(22.292 126.272)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4597",
    "data-name": "Tracciato 4597",
    d: "M5491.551-52.17a54.457,54.457,0,0,1-54.381-54.406,52.9,52.9,0,0,0-52.824-52.849A52.9,52.9,0,0,0,5331.5-106.6a54.456,54.456,0,0,1-54.408,54.381,54.457,54.457,0,0,1-54.382-54.406h1.559a52.894,52.894,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.848-52.823,54.458,54.458,0,0,1,54.407-54.383,54.457,54.457,0,0,1,54.383,54.408,52.894,52.894,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.849-52.823,54.456,54.456,0,0,1,54.406-54.383,54.458,54.458,0,0,1,54.383,54.408h-1.559a52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.824A54.456,54.456,0,0,1,5491.551-52.17Z",
    transform: "translate(-5222.709 160.984)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3433",
    "data-name": "Raggruppa 3433",
    transform: "translate(23.654 130.135)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4598",
    "data-name": "Tracciato 4598",
    d: "M5493.814-45.755a54.457,54.457,0,0,1-54.383-54.406,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.85,52.825A54.456,54.456,0,0,1,5279.353-45.8a54.458,54.458,0,0,1-54.382-54.407h1.558a52.9,52.9,0,0,0,52.824,52.847,52.9,52.9,0,0,0,52.848-52.823,54.457,54.457,0,0,1,54.408-54.383,54.458,54.458,0,0,1,54.381,54.408,52.9,52.9,0,0,0,52.824,52.847,52.893,52.893,0,0,0,52.847-52.823,54.458,54.458,0,0,1,54.409-54.383,54.457,54.457,0,0,1,54.381,54.408h-1.559a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825A54.457,54.457,0,0,1,5493.814-45.755Z",
    transform: "translate(-5224.97 154.569)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3434",
    "data-name": "Raggruppa 3434",
    transform: "translate(25.016 133.999)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4599",
    "data-name": "Tracciato 4599",
    d: "M5496.075-39.339a54.457,54.457,0,0,1-54.382-54.408,52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.849,52.823,54.456,54.456,0,0,1-54.408,54.383A54.458,54.458,0,0,1,5227.232-93.8h1.56a52.9,52.9,0,0,0,52.821,52.849,52.9,52.9,0,0,0,52.85-52.825,54.455,54.455,0,0,1,54.406-54.381,54.455,54.455,0,0,1,54.382,54.406A52.9,52.9,0,0,0,5496.075-40.9a52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.408-54.381A54.455,54.455,0,0,1,5657.712-93.7h-1.558a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823A54.457,54.457,0,0,1,5496.075-39.339Z",
    transform: "translate(-5227.232 148.153)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3435",
    "data-name": "Raggruppa 3435",
    transform: "translate(26.379 137.862)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4600",
    "data-name": "Tracciato 4600",
    d: "M5498.338-32.924a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.848,52.823,54.456,54.456,0,0,1-54.407,54.382A54.457,54.457,0,0,1,5229.5-87.381h1.558a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.456,54.456,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.383,54.406,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.406-54.381,54.454,54.454,0,0,1,54.381,54.406h-1.557a52.9,52.9,0,0,0-52.826-52.847,52.9,52.9,0,0,0-52.847,52.823A54.457,54.457,0,0,1,5498.338-32.924Z",
    transform: "translate(-5229.496 141.738)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3436",
    "data-name": "Raggruppa 3436",
    transform: "translate(27.741 141.724)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4601",
    "data-name": "Tracciato 4601",
    d: "M5500.6-26.511a54.457,54.457,0,0,1-54.383-54.406,52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825,54.457,54.457,0,0,1-54.407,54.381,54.456,54.456,0,0,1-54.382-54.406h1.56a52.894,52.894,0,0,0,52.823,52.847,52.894,52.894,0,0,0,52.847-52.823,54.457,54.457,0,0,1,54.409-54.382,54.456,54.456,0,0,1,54.381,54.408A52.9,52.9,0,0,0,5500.6-28.07a52.9,52.9,0,0,0,52.848-52.823,54.456,54.456,0,0,1,54.408-54.382,54.454,54.454,0,0,1,54.38,54.408h-1.558a52.9,52.9,0,0,0-52.823-52.849,52.9,52.9,0,0,0-52.849,52.825A54.456,54.456,0,0,1,5500.6-26.511Z",
    transform: "translate(-5231.757 135.325)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3437",
    "data-name": "Raggruppa 3437",
    transform: "translate(29.104 145.587)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4602",
    "data-name": "Tracciato 4602",
    d: "M5502.861-20.1a54.455,54.455,0,0,1-54.38-54.407,52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.847,52.825A54.457,54.457,0,0,1,5288.4-20.146a54.456,54.456,0,0,1-54.381-54.407h1.559A52.9,52.9,0,0,0,5288.4-21.7a52.9,52.9,0,0,0,52.849-52.823,54.455,54.455,0,0,1,54.406-54.382A54.457,54.457,0,0,1,5450.039-74.5a52.9,52.9,0,0,0,52.823,52.847,52.9,52.9,0,0,0,52.848-52.823,54.458,54.458,0,0,1,54.407-54.382A54.456,54.456,0,0,1,5664.5-74.453h-1.559a52.9,52.9,0,0,0-52.825-52.849,52.9,52.9,0,0,0-52.846,52.825A54.458,54.458,0,0,1,5502.861-20.1Z",
    transform: "translate(-5234.02 128.91)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3438",
    "data-name": "Raggruppa 3438",
    transform: "translate(30.467 149.451)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4603",
    "data-name": "Tracciato 4603",
    d: "M5505.125-13.681a54.457,54.457,0,0,1-54.38-54.408,52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823,54.457,54.457,0,0,1-54.408,54.382,54.457,54.457,0,0,1-54.382-54.408h1.559a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.406-54.381A54.456,54.456,0,0,1,5452.3-68.088a52.9,52.9,0,0,0,52.822,52.849,52.9,52.9,0,0,0,52.85-52.824,54.456,54.456,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.382,54.407H5665.2a52.9,52.9,0,0,0-52.824-52.847,52.9,52.9,0,0,0-52.848,52.823A54.457,54.457,0,0,1,5505.125-13.681Z",
    transform: "translate(-5236.283 122.495)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3439",
    "data-name": "Raggruppa 3439",
    transform: "translate(31.828 153.314)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4604",
    "data-name": "Tracciato 4604",
    d: "M5507.387-7.266A54.456,54.456,0,0,1,5453-61.674a52.9,52.9,0,0,0-52.823-52.847A52.9,52.9,0,0,0,5347.333-61.7a54.456,54.456,0,0,1-54.406,54.382,54.457,54.457,0,0,1-54.383-54.408h1.559a52.9,52.9,0,0,0,52.824,52.849A52.9,52.9,0,0,0,5345.774-61.7a54.457,54.457,0,0,1,54.409-54.381,54.456,54.456,0,0,1,54.38,54.407,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.824,54.457,54.457,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.407h-1.559a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823A54.456,54.456,0,0,1,5507.387-7.266Z",
    transform: "translate(-5238.543 116.08)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3440",
    "data-name": "Raggruppa 3440",
    transform: "translate(30.312 157.1)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4605",
    "data-name": "Tracciato 4605",
    d: "M5504.87-.978a54.458,54.458,0,0,1-54.383-54.408,52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,5290.41-1.028a54.456,54.456,0,0,1-54.383-54.408h1.559a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825,54.456,54.456,0,0,1,54.408-54.381,54.457,54.457,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.455,54.455,0,0,1,54.407-54.381,54.457,54.457,0,0,1,54.382,54.406h-1.559a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.85,52.823A54.455,54.455,0,0,1,5504.87-.978Z",
    transform: "translate(-5236.027 109.792)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3441",
    "data-name": "Raggruppa 3441",
    transform: "translate(28.797 160.887)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4606",
    "data-name": "Tracciato 4606",
    d: "M5502.354,5.31A54.458,54.458,0,0,1,5447.971-49.1a52.9,52.9,0,0,0-52.824-52.847A52.894,52.894,0,0,0,5342.3-49.123,54.457,54.457,0,0,1,5287.892,5.26a54.457,54.457,0,0,1-54.38-54.408h1.558A52.9,52.9,0,0,0,5287.893,3.7a52.9,52.9,0,0,0,52.85-52.825,54.454,54.454,0,0,1,54.406-54.381A54.456,54.456,0,0,1,5449.531-49.1a52.9,52.9,0,0,0,52.823,52.849A52.9,52.9,0,0,0,5555.2-49.073a54.457,54.457,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.383,54.406h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823A54.458,54.458,0,0,1,5502.354,5.31Z",
    transform: "translate(-5233.511 103.504)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3442",
    "data-name": "Raggruppa 3442",
    transform: "translate(27.282 164.673)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4607",
    "data-name": "Tracciato 4607",
    d: "M5499.837,11.6a54.456,54.456,0,0,1-54.38-54.408,52.9,52.9,0,0,0-52.825-52.847,52.893,52.893,0,0,0-52.847,52.823,54.458,54.458,0,0,1-54.408,54.383A54.457,54.457,0,0,1,5231-42.86h1.559a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.456,54.456,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.849-52.825,54.455,54.455,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.382,54.407h-1.558a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823A54.458,54.458,0,0,1,5499.837,11.6Z",
    transform: "translate(-5230.995 97.217)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3443",
    "data-name": "Raggruppa 3443",
    transform: "translate(25.767 168.46)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4608",
    "data-name": "Tracciato 4608",
    d: "M5497.322,17.885a54.456,54.456,0,0,1-54.382-54.408,52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.848,52.823,54.455,54.455,0,0,1-54.407,54.382,54.456,54.456,0,0,1-54.381-54.408h1.559a52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.85-52.825,54.456,54.456,0,0,1,54.4-54.381A54.458,54.458,0,0,1,5444.5-36.522a52.9,52.9,0,0,0,52.823,52.849A52.9,52.9,0,0,0,5550.17-36.5a54.456,54.456,0,0,1,54.405-54.381,54.456,54.456,0,0,1,54.383,54.407H5657.4a52.9,52.9,0,0,0-52.826-52.847A52.9,52.9,0,0,0,5551.729-36.5,54.457,54.457,0,0,1,5497.322,17.885Z",
    transform: "translate(-5228.479 90.929)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3444",
    "data-name": "Raggruppa 3444",
    transform: "translate(24.25 172.247)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4609",
    "data-name": "Tracciato 4609",
    d: "M5494.8,24.173a54.455,54.455,0,0,1-54.382-54.408A52.9,52.9,0,0,0,5387.6-83.082a52.9,52.9,0,0,0-52.848,52.823,54.457,54.457,0,0,1-54.406,54.382,54.457,54.457,0,0,1-54.384-54.408h1.559a52.9,52.9,0,0,0,52.825,52.849A52.9,52.9,0,0,0,5333.19-30.26,54.456,54.456,0,0,1,5387.6-84.641a54.456,54.456,0,0,1,54.381,54.407A52.9,52.9,0,0,0,5494.8,22.614a52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.407-54.381,54.455,54.455,0,0,1,54.382,54.406h-1.56a52.893,52.893,0,0,0-52.822-52.847,52.9,52.9,0,0,0-52.85,52.823A54.454,54.454,0,0,1,5494.8,24.173Z",
    transform: "translate(-5225.96 84.641)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3445",
    "data-name": "Raggruppa 3445",
    transform: "translate(22.735 176.033)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4610",
    "data-name": "Tracciato 4610",
    d: "M5492.287,30.461A54.457,54.457,0,0,1,5437.9-23.947a52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823,54.459,54.459,0,0,1-54.408,54.383A54.456,54.456,0,0,1,5223.444-24H5225a52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.825,54.456,54.456,0,0,1,54.408-54.381,54.456,54.456,0,0,1,54.381,54.406A52.9,52.9,0,0,0,5492.287,28.9a52.9,52.9,0,0,0,52.848-52.825A54.455,54.455,0,0,1,5599.542-78.3,54.456,54.456,0,0,1,5653.924-23.9h-1.558a52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.849,52.823A54.457,54.457,0,0,1,5492.287,30.461Z",
    transform: "translate(-5223.444 78.353)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3446",
    "data-name": "Raggruppa 3446",
    transform: "translate(21.219 179.819)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4611",
    "data-name": "Tracciato 4611",
    d: "M5489.769,36.748a54.457,54.457,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847,52.894,52.894,0,0,0-52.847,52.823A54.458,54.458,0,0,1,5275.309,36.7a54.458,54.458,0,0,1-54.383-54.408h1.56a52.9,52.9,0,0,0,52.824,52.849,52.9,52.9,0,0,0,52.848-52.825,54.458,54.458,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.382,54.407,52.9,52.9,0,0,0,52.823,52.849,52.9,52.9,0,0,0,52.848-52.825,54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.384,54.407h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.848,52.823A54.455,54.455,0,0,1,5489.769,36.748Z",
    transform: "translate(-5220.926 72.066)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3447",
    "data-name": "Raggruppa 3447",
    transform: "translate(19.704 183.606)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4612",
    "data-name": "Tracciato 4612",
    d: "M5487.253,43.036a54.456,54.456,0,0,1-54.381-54.408,52.9,52.9,0,0,0-52.825-52.847A52.9,52.9,0,0,0,5327.2-11.4a54.456,54.456,0,0,1-54.408,54.382,54.456,54.456,0,0,1-54.381-54.408h1.558a52.9,52.9,0,0,0,52.824,52.849A52.9,52.9,0,0,0,5325.641-11.4a54.457,54.457,0,0,1,54.406-54.381,54.456,54.456,0,0,1,54.383,54.407,52.9,52.9,0,0,0,52.823,52.849A52.9,52.9,0,0,0,5540.1-11.347a54.457,54.457,0,0,1,54.406-54.381,54.457,54.457,0,0,1,54.383,54.407h-1.559a52.9,52.9,0,0,0-52.825-52.847,52.9,52.9,0,0,0-52.847,52.823A54.456,54.456,0,0,1,5487.253,43.036Z",
    transform: "translate(-5218.411 65.778)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3448",
    "data-name": "Raggruppa 3448",
    transform: "translate(18.187 187.393)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4613",
    "data-name": "Tracciato 4613",
    d: "M5484.736,49.324a54.457,54.457,0,0,1-54.383-54.408,52.9,52.9,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.85,52.823,54.455,54.455,0,0,1-54.4,54.382,54.457,54.457,0,0,1-54.384-54.408h1.558a52.9,52.9,0,0,0,52.826,52.849,52.9,52.9,0,0,0,52.847-52.825A54.456,54.456,0,0,1,5377.53-59.49a54.455,54.455,0,0,1,54.381,54.406,52.9,52.9,0,0,0,52.825,52.849,52.9,52.9,0,0,0,52.847-52.824,54.456,54.456,0,0,1,54.407-54.381,54.456,54.456,0,0,1,54.382,54.406h-1.56a52.894,52.894,0,0,0-52.823-52.847,52.9,52.9,0,0,0-52.848,52.823A54.456,54.456,0,0,1,5484.736,49.324Z",
    transform: "translate(-5215.892 59.49)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3449",
    "data-name": "Raggruppa 3449",
    transform: "translate(16.672 191.179)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4614",
    "data-name": "Tracciato 4614",
    d: "M5482.22,55.612A54.458,54.458,0,0,1,5427.836,1.2a52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025A54.4,54.4,0,0,1,5429.4,1.2a52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025H5642.3a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5482.22,55.612Z",
    transform: "translate(-5213.375 53.202)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3450",
    "data-name": "Raggruppa 3450",
    transform: "translate(15.156 194.966)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4615",
    "data-name": "Tracciato 4615",
    d: "M5479.7,61.9A54.456,54.456,0,0,1,5425.32,7.491a52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.837,52.837,0,0,0,105.674.024,54.394,54.394,0,0,1,108.788.025,52.835,52.835,0,1,0,105.67.024,54.4,54.4,0,0,1,108.791.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5479.7,61.9Z",
    transform: "translate(-5210.859 46.915)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3451",
    "data-name": "Raggruppa 3451",
    transform: "translate(13.641 198.752)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4616",
    "data-name": "Tracciato 4616",
    d: "M5477.186,68.187A54.456,54.456,0,0,1,5422.8,13.779a52.836,52.836,0,0,0-105.672-.024,54.4,54.4,0,1,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.67.024,54.4,54.4,0,0,1,108.791.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5477.186,68.187Z",
    transform: "translate(-5208.342 40.627)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3452",
    "data-name": "Raggruppa 3452",
    transform: "translate(12.126 202.539)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4617",
    "data-name": "Tracciato 4617",
    d: "M5474.669,74.475a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5474.669,74.475Z",
    transform: "translate(-5205.828 34.339)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3453",
    "data-name": "Raggruppa 3453",
    transform: "translate(10.609 206.326)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4618",
    "data-name": "Tracciato 4618",
    d: "M5472.152,80.763a54.458,54.458,0,0,1-54.384-54.408A52.835,52.835,0,0,0,5312.1,26.33a54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.025,54.395,54.395,0,0,1,108.789.025A52.836,52.836,0,1,0,5525,26.38a54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.458,54.458,0,0,1,5472.152,80.763Z",
    transform: "translate(-5203.309 28.051)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3454",
    "data-name": "Raggruppa 3454",
    transform: "translate(9.093 210.112)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4619",
    "data-name": "Tracciato 4619",
    d: "M5469.636,87.05a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5469.636,87.05Z",
    transform: "translate(-5200.792 21.764)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3455",
    "data-name": "Raggruppa 3455",
    transform: "translate(7.578 213.898)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4620",
    "data-name": "Tracciato 4620",
    d: "M5467.12,93.338a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025H5627.2a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5467.12,93.338Z",
    transform: "translate(-5198.276 15.476)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3456",
    "data-name": "Raggruppa 3456",
    transform: "translate(6.063 217.685)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4621",
    "data-name": "Tracciato 4621",
    d: "M5464.6,99.626a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.673-.025,54.395,54.395,0,1,1-108.79-.025h1.561a52.835,52.835,0,1,0,105.67.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.458,54.458,0,0,1,5464.6,99.626Z",
    transform: "translate(-5195.759 9.188)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3457",
    "data-name": "Raggruppa 3457",
    transform: "translate(4.547 221.472)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4622",
    "data-name": "Tracciato 4622",
    d: "M5462.085,105.914A54.457,54.457,0,0,1,5407.7,51.506a52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5462.085,105.914Z",
    transform: "translate(-5193.244 2.9)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3458",
    "data-name": "Raggruppa 3458",
    transform: "translate(3.031 225.258)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4623",
    "data-name": "Tracciato 4623",
    d: "M5459.568,112.2a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,5459.568,112.2Z",
    transform: "translate(-5190.726 -3.387)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3459",
    "data-name": "Raggruppa 3459",
    transform: "translate(1.515 229.044)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4624",
    "data-name": "Tracciato 4624",
    d: "M5457.051,118.489a54.457,54.457,0,0,1-54.382-54.408A52.836,52.836,0,0,0,5297,64.057a54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5457.051,118.489Z",
    transform: "translate(-5188.208 -9.675)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3460",
    "data-name": "Raggruppa 3460",
    transform: "translate(0 232.831)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4625",
    "data-name": "Tracciato 4625",
    d: "M5454.537,124.777a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.788.025,52.837,52.837,0,1,0,105.673.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5454.537,124.777Z",
    transform: "translate(-5185.692 -15.963)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3461",
    "data-name": "Raggruppa 3461",
    transform: "translate(1.513 236.618)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4626",
    "data-name": "Tracciato 4626",
    d: "M5457.048,131.066a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.835,52.835,0,0,0-105.671-.025A54.458,54.458,0,0,1,5457.048,131.066Z",
    transform: "translate(-5188.206 -22.252)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3462",
    "data-name": "Raggruppa 3462",
    transform: "translate(3.028 240.406)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4627",
    "data-name": "Tracciato 4627",
    d: "M5459.563,137.355a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.673-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024A54.395,54.395,0,0,1,5621.2,83h-1.558a52.835,52.835,0,0,0-105.671-.024A54.458,54.458,0,0,1,5459.563,137.355Z",
    transform: "translate(-5190.719 -28.541)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3463",
    "data-name": "Raggruppa 3463",
    transform: "translate(4.542 244.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4628",
    "data-name": "Tracciato 4628",
    d: "M5462.077,143.643A54.456,54.456,0,0,1,5407.7,89.235a52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5462.077,143.643Z",
    transform: "translate(-5193.234 -34.829)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3464",
    "data-name": "Raggruppa 3464",
    transform: "translate(6.056 247.98)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4629",
    "data-name": "Tracciato 4629",
    d: "M5464.589,149.932a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558A52.836,52.836,0,0,0,5519,95.549,54.456,54.456,0,0,1,5464.589,149.932Z",
    transform: "translate(-5195.748 -41.118)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3465",
    "data-name": "Raggruppa 3465",
    transform: "translate(7.569 251.767)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4630",
    "data-name": "Tracciato 4630",
    d: "M5467.106,156.221a54.457,54.457,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.024,54.4,54.4,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.456,54.456,0,0,1,5467.106,156.221Z",
    transform: "translate(-5198.261 -47.407)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3466",
    "data-name": "Raggruppa 3466",
    transform: "translate(9.083 255.554)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4631",
    "data-name": "Tracciato 4631",
    d: "M5469.619,162.51a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.788.025H5629.7a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5469.619,162.51Z",
    transform: "translate(-5200.776 -53.696)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3467",
    "data-name": "Raggruppa 3467",
    transform: "translate(10.597 259.342)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4632",
    "data-name": "Tracciato 4632",
    d: "M5472.131,168.8a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5472.131,168.8Z",
    transform: "translate(-5203.288 -59.985)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3468",
    "data-name": "Raggruppa 3468",
    transform: "translate(12.112 263.129)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4633",
    "data-name": "Tracciato 4633",
    d: "M5474.646,175.088a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.837,52.837,0,0,0,105.673.024,54.394,54.394,0,0,1,108.788.025h-1.559a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,5474.646,175.088Z",
    transform: "translate(-5205.804 -66.274)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3469",
    "data-name": "Raggruppa 3469",
    transform: "translate(13.625 266.916)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4634",
    "data-name": "Tracciato 4634",
    d: "M5477.159,181.377a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,5477.159,181.377Z",
    transform: "translate(-5208.317 -72.563)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3470",
    "data-name": "Raggruppa 3470",
    transform: "translate(15.139 270.703)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4635",
    "data-name": "Tracciato 4635",
    d: "M5479.675,187.666a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5479.675,187.666Z",
    transform: "translate(-5210.832 -78.852)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3471",
    "data-name": "Raggruppa 3471",
    transform: "translate(16.652 274.491)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4636",
    "data-name": "Tracciato 4636",
    d: "M5482.189,193.955a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.671-.025A54.456,54.456,0,0,1,5482.189,193.955Z",
    transform: "translate(-5213.345 -85.141)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3472",
    "data-name": "Raggruppa 3472",
    transform: "translate(18.166 278.278)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4637",
    "data-name": "Tracciato 4637",
    d: "M5484.7,200.244a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,5484.7,200.244Z",
    transform: "translate(-5215.859 -91.43)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3473",
    "data-name": "Raggruppa 3473",
    transform: "translate(19.681 282.065)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4638",
    "data-name": "Tracciato 4638",
    d: "M5487.215,206.532a54.458,54.458,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5487.215,206.532Z",
    transform: "translate(-5218.373 -97.718)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3474",
    "data-name": "Raggruppa 3474",
    transform: "translate(21.195 285.852)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4639",
    "data-name": "Tracciato 4639",
    d: "M5489.729,212.821a54.455,54.455,0,0,1-54.38-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.673.025,54.394,54.394,0,1,1,108.789.025h-1.56a52.835,52.835,0,1,0-105.671-.025A54.456,54.456,0,0,1,5489.729,212.821Z",
    transform: "translate(-5220.888 -104.007)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3475",
    "data-name": "Raggruppa 3475",
    transform: "translate(22.708 289.639)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4640",
    "data-name": "Tracciato 4640",
    d: "M5492.244,219.11a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.025A54.456,54.456,0,0,1,5492.244,219.11Z",
    transform: "translate(-5223.4 -110.296)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3476",
    "data-name": "Raggruppa 3476",
    transform: "translate(24.222 293.427)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4641",
    "data-name": "Tracciato 4641",
    d: "M5494.757,225.4a54.455,54.455,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,5494.757,225.4Z",
    transform: "translate(-5225.915 -116.585)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3477",
    "data-name": "Raggruppa 3477",
    transform: "translate(25.737 297.214)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4642",
    "data-name": "Tracciato 4642",
    d: "M5497.271,231.688a54.455,54.455,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.4,54.4,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5497.271,231.688Z",
    transform: "translate(-5228.43 -122.874)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3478",
    "data-name": "Raggruppa 3478",
    transform: "translate(27.251 301.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4643",
    "data-name": "Tracciato 4643",
    d: "M5499.786,237.977A54.456,54.456,0,0,1,5445.4,183.57a52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025h-1.56a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5499.786,237.977Z",
    transform: "translate(-5230.943 -129.163)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3479",
    "data-name": "Raggruppa 3479",
    transform: "translate(28.764 304.788)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4644",
    "data-name": "Tracciato 4644",
    d: "M5502.3,244.266a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.673-.024,54.394,54.394,0,0,1-108.788-.025h1.557a52.836,52.836,0,0,0,105.673.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.788.025h-1.56a52.836,52.836,0,1,0-105.671-.024A54.455,54.455,0,0,1,5502.3,244.266Z",
    transform: "translate(-5233.456 -135.452)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3480",
    "data-name": "Raggruppa 3480",
    transform: "translate(30.278 308.576)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4645",
    "data-name": "Tracciato 4645",
    d: "M5504.813,250.555a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,5504.813,250.555Z",
    transform: "translate(-5235.971 -141.741)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3481",
    "data-name": "Raggruppa 3481",
    transform: "translate(31.791 312.363)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4646",
    "data-name": "Tracciato 4646",
    d: "M5507.327,256.844a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025H5667.4a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5507.327,256.844Z",
    transform: "translate(-5238.483 -148.03)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3568",
    "data-name": "Raggruppa 3568",
    transform: "translate(424.705 315.292)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3483",
    "data-name": "Raggruppa 3483",
    transform: "translate(31.863 0)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4647",
    "data-name": "Tracciato 4647",
    d: "M5502.706,261.707a54.457,54.457,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5502.706,261.707Z",
    transform: "translate(-5233.862 -152.893)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3484",
    "data-name": "Raggruppa 3484",
    transform: "translate(30.499 3.438)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4648",
    "data-name": "Tracciato 4648",
    d: "M5500.441,267.416a54.457,54.457,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5500.441,267.416Z",
    transform: "translate(-5231.599 -158.602)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3485",
    "data-name": "Raggruppa 3485",
    transform: "translate(29.135 6.875)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4649",
    "data-name": "Tracciato 4649",
    d: "M5498.174,273.123a54.457,54.457,0,0,1-54.381-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.4,54.4,0,1,1,108.79.025h-1.56a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,5498.174,273.123Z",
    transform: "translate(-5229.333 -164.309)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3486",
    "data-name": "Raggruppa 3486",
    transform: "translate(27.771 10.313)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4650",
    "data-name": "Tracciato 4650",
    d: "M5495.911,278.832a54.457,54.457,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,5495.911,278.832Z",
    transform: "translate(-5227.067 -170.018)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3487",
    "data-name": "Raggruppa 3487",
    transform: "translate(26.407 13.751)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4651",
    "data-name": "Tracciato 4651",
    d: "M5493.645,284.541a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.671-.024,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.671-.024A54.458,54.458,0,0,1,5493.645,284.541Z",
    transform: "translate(-5224.803 -175.727)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3488",
    "data-name": "Raggruppa 3488",
    transform: "translate(25.043 17.189)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4652",
    "data-name": "Tracciato 4652",
    d: "M5491.379,290.25A54.456,54.456,0,0,1,5437,235.842a52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.671-.024A54.458,54.458,0,0,1,5491.379,290.25Z",
    transform: "translate(-5222.538 -181.436)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3489",
    "data-name": "Raggruppa 3489",
    transform: "translate(23.678 20.627)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4653",
    "data-name": "Tracciato 4653",
    d: "M5489.116,295.959a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.025,54.394,54.394,0,0,1,108.788.025h-1.558a52.835,52.835,0,0,0-105.671-.025A54.458,54.458,0,0,1,5489.116,295.959Z",
    transform: "translate(-5220.271 -187.145)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3490",
    "data-name": "Raggruppa 3490",
    transform: "translate(22.315 24.063)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4654",
    "data-name": "Tracciato 4654",
    d: "M5486.85,301.665a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.79.025h-1.559a52.835,52.835,0,1,0-105.671-.025A54.457,54.457,0,0,1,5486.85,301.665Z",
    transform: "translate(-5218.007 -192.851)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3491",
    "data-name": "Raggruppa 3491",
    transform: "translate(20.951 27.501)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4655",
    "data-name": "Tracciato 4655",
    d: "M5484.583,307.374a54.454,54.454,0,0,1-54.379-54.406,52.837,52.837,0,1,0-105.673-.025,54.394,54.394,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,5484.583,307.374Z",
    transform: "translate(-5215.742 -198.56)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3492",
    "data-name": "Raggruppa 3492",
    transform: "translate(19.586 30.939)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4656",
    "data-name": "Tracciato 4656",
    d: "M5482.32,313.083a54.455,54.455,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.673-.025,54.394,54.394,0,0,1-108.788-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.025A54.456,54.456,0,0,1,5482.32,313.083Z",
    transform: "translate(-5213.477 -204.269)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3493",
    "data-name": "Raggruppa 3493",
    transform: "translate(18.222 34.377)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4657",
    "data-name": "Tracciato 4657",
    d: "M5480.054,318.792a54.458,54.458,0,0,1-54.383-54.408A52.836,52.836,0,0,0,5320,264.36a54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.791.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.454,54.454,0,0,1,5480.054,318.792Z",
    transform: "translate(-5211.21 -209.978)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3494",
    "data-name": "Raggruppa 3494",
    transform: "translate(16.859 37.815)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4658",
    "data-name": "Tracciato 4658",
    d: "M5477.789,324.5a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.456,54.456,0,0,1,5477.789,324.5Z",
    transform: "translate(-5208.946 -215.687)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3495",
    "data-name": "Raggruppa 3495",
    transform: "translate(15.494 41.252)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4659",
    "data-name": "Tracciato 4659",
    d: "M5475.525,330.208a54.457,54.457,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,5475.525,330.208Z",
    transform: "translate(-5206.682 -221.394)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3496",
    "data-name": "Raggruppa 3496",
    transform: "translate(14.13 44.69)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4660",
    "data-name": "Tracciato 4660",
    d: "M5473.259,335.917a54.457,54.457,0,0,1-54.383-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5473.259,335.917Z",
    transform: "translate(-5204.416 -227.103)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3497",
    "data-name": "Raggruppa 3497",
    transform: "translate(12.767 48.128)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4661",
    "data-name": "Tracciato 4661",
    d: "M5470.995,341.626a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5470.995,341.626Z",
    transform: "translate(-5202.152 -232.812)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3498",
    "data-name": "Raggruppa 3498",
    transform: "translate(11.402 51.566)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4662",
    "data-name": "Tracciato 4662",
    d: "M5468.729,347.335a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,5468.729,347.335Z",
    transform: "translate(-5199.886 -238.521)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3499",
    "data-name": "Raggruppa 3499",
    transform: "translate(10.038 55.004)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4663",
    "data-name": "Tracciato 4663",
    d: "M5466.464,353.044a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5466.464,353.044Z",
    transform: "translate(-5197.62 -244.23)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3500",
    "data-name": "Raggruppa 3500",
    transform: "translate(8.674 58.44)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4664",
    "data-name": "Tracciato 4664",
    d: "M5464.2,358.75a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.79-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.025A54.456,54.456,0,0,1,5464.2,358.75Z",
    transform: "translate(-5195.356 -249.936)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3501",
    "data-name": "Raggruppa 3501",
    transform: "translate(7.309 61.878)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4665",
    "data-name": "Tracciato 4665",
    d: "M5461.934,364.459a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.025A54.4,54.4,0,0,1,5193.09,310h1.56a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.025,54.4,54.4,0,1,1,108.79.025h-1.56a52.835,52.835,0,1,0-105.671-.025A54.456,54.456,0,0,1,5461.934,364.459Z",
    transform: "translate(-5193.09 -255.645)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3502",
    "data-name": "Raggruppa 3502",
    transform: "translate(5.946 65.316)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4666",
    "data-name": "Tracciato 4666",
    d: "M5459.668,370.168a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5459.668,370.168Z",
    transform: "translate(-5190.826 -261.354)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3503",
    "data-name": "Raggruppa 3503",
    transform: "translate(4.582 68.754)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4667",
    "data-name": "Tracciato 4667",
    d: "M5457.4,375.877a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5457.4,375.877Z",
    transform: "translate(-5188.561 -267.063)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3504",
    "data-name": "Raggruppa 3504",
    transform: "translate(3.217 72.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4668",
    "data-name": "Tracciato 4668",
    d: "M5455.137,381.586a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5455.137,381.586Z",
    transform: "translate(-5186.295 -272.772)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3505",
    "data-name": "Raggruppa 3505",
    transform: "translate(4.58 76.054)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4669",
    "data-name": "Tracciato 4669",
    d: "M5457.4,388a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025,52.835,52.835,0,1,0,105.67.024,54.395,54.395,0,1,1,108.79.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5457.4,388Z",
    transform: "translate(-5188.559 -279.185)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3506",
    "data-name": "Raggruppa 3506",
    transform: "translate(5.942 79.917)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4670",
    "data-name": "Tracciato 4670",
    d: "M5459.662,394.414a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.673-.025,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5459.662,394.414Z",
    transform: "translate(-5190.819 -285.6)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3507",
    "data-name": "Raggruppa 3507",
    transform: "translate(7.305 83.78)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4671",
    "data-name": "Tracciato 4671",
    d: "M5461.926,400.829a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.4,54.4,0,0,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025H5622a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5461.926,400.829Z",
    transform: "translate(-5193.081 -292.015)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3508",
    "data-name": "Raggruppa 3508",
    transform: "translate(8.668 87.644)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4672",
    "data-name": "Tracciato 4672",
    d: "M5464.187,407.244a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.56a52.835,52.835,0,0,0-105.67-.024A54.458,54.458,0,0,1,5464.187,407.244Z",
    transform: "translate(-5195.344 -298.43)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3509",
    "data-name": "Raggruppa 3509",
    transform: "translate(10.029 91.506)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4673",
    "data-name": "Tracciato 4673",
    d: "M5466.451,413.657a54.456,54.456,0,0,1-54.384-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.025A54.457,54.457,0,0,1,5466.451,413.657Z",
    transform: "translate(-5197.607 -304.843)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3510",
    "data-name": "Raggruppa 3510",
    transform: "translate(11.392 95.369)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4674",
    "data-name": "Tracciato 4674",
    d: "M5468.712,420.072a54.456,54.456,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.788-.025h1.559a52.835,52.835,0,0,0,105.671.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.672-.025A54.455,54.455,0,0,1,5468.712,420.072Z",
    transform: "translate(-5199.87 -311.258)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3511",
    "data-name": "Raggruppa 3511",
    transform: "translate(12.755 99.232)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4675",
    "data-name": "Tracciato 4675",
    d: "M5470.974,426.488a54.458,54.458,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.025,54.395,54.395,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5470.974,426.488Z",
    transform: "translate(-5202.132 -317.674)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3512",
    "data-name": "Raggruppa 3512",
    transform: "translate(14.116 103.096)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4676",
    "data-name": "Tracciato 4676",
    d: "M5473.237,432.9a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5473.237,432.9Z",
    transform: "translate(-5204.394 -324.089)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3513",
    "data-name": "Raggruppa 3513",
    transform: "translate(15.479 106.958)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4677",
    "data-name": "Tracciato 4677",
    d: "M5475.5,439.316a54.457,54.457,0,0,1-54.383-54.407,52.835,52.835,0,1,0-105.67-.024,54.4,54.4,0,0,1-108.79-.025h1.558a52.836,52.836,0,0,0,105.673.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,5475.5,439.316Z",
    transform: "translate(-5206.656 -330.502)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3514",
    "data-name": "Raggruppa 3514",
    transform: "translate(16.842 110.821)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4678",
    "data-name": "Tracciato 4678",
    d: "M5477.761,445.731a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5477.761,445.731Z",
    transform: "translate(-5208.919 -336.917)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3515",
    "data-name": "Raggruppa 3515",
    transform: "translate(18.204 114.684)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4679",
    "data-name": "Tracciato 4679",
    d: "M5480.024,452.146a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025H5640.1a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,5480.024,452.146Z",
    transform: "translate(-5211.181 -343.332)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3516",
    "data-name": "Raggruppa 3516",
    transform: "translate(19.566 118.547)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4680",
    "data-name": "Tracciato 4680",
    d: "M5482.286,458.561a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025H5215a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5482.286,458.561Z",
    transform: "translate(-5213.443 -349.747)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3517",
    "data-name": "Raggruppa 3517",
    transform: "translate(20.929 122.41)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4681",
    "data-name": "Tracciato 4681",
    d: "M5484.548,464.976a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5484.548,464.976Z",
    transform: "translate(-5215.706 -356.162)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3518",
    "data-name": "Raggruppa 3518",
    transform: "translate(22.292 126.272)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4682",
    "data-name": "Tracciato 4682",
    d: "M5486.812,471.389a54.457,54.457,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.788-.025h1.558a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025,52.835,52.835,0,0,0,105.671.025,54.395,54.395,0,1,1,108.789.025h-1.558a52.836,52.836,0,1,0-105.671-.024A54.457,54.457,0,0,1,5486.812,471.389Z",
    transform: "translate(-5217.97 -362.575)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3519",
    "data-name": "Raggruppa 3519",
    transform: "translate(23.653 130.135)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4683",
    "data-name": "Tracciato 4683",
    d: "M5489.073,477.8A54.456,54.456,0,0,1,5434.69,423.4a52.836,52.836,0,1,0-105.672-.025,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.788.025,52.835,52.835,0,0,0,105.671.025,54.4,54.4,0,1,1,108.79.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.455,54.455,0,0,1,5489.073,477.8Z",
    transform: "translate(-5220.229 -368.99)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3520",
    "data-name": "Raggruppa 3520",
    transform: "translate(25.016 133.999)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4684",
    "data-name": "Tracciato 4684",
    d: "M5491.335,484.219a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.458,54.458,0,0,1,5491.335,484.219Z",
    transform: "translate(-5222.494 -375.405)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3521",
    "data-name": "Raggruppa 3521",
    transform: "translate(26.379 137.862)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4685",
    "data-name": "Tracciato 4685",
    d: "M5493.6,490.635a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.56a52.835,52.835,0,1,0,105.671.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5493.6,490.635Z",
    transform: "translate(-5224.756 -381.821)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3522",
    "data-name": "Raggruppa 3522",
    transform: "translate(27.74 141.724)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4686",
    "data-name": "Tracciato 4686",
    d: "M5495.861,497.047a54.457,54.457,0,0,1-54.384-54.406,52.835,52.835,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,1,1,108.79.025,52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.456,54.456,0,0,1,5495.861,497.047Z",
    transform: "translate(-5227.017 -388.233)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3523",
    "data-name": "Raggruppa 3523",
    transform: "translate(29.103 145.587)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4687",
    "data-name": "Tracciato 4687",
    d: "M5498.122,503.463a54.456,54.456,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.56a52.835,52.835,0,1,0-105.671-.024A54.457,54.457,0,0,1,5498.122,503.463Z",
    transform: "translate(-5229.28 -394.649)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3524",
    "data-name": "Raggruppa 3524",
    transform: "translate(30.466 149.451)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4688",
    "data-name": "Tracciato 4688",
    d: "M5500.384,509.878A54.455,54.455,0,0,1,5446,455.47a52.836,52.836,0,0,0-105.673-.025,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,0,0-105.672-.025A54.457,54.457,0,0,1,5500.384,509.878Z",
    transform: "translate(-5231.543 -401.064)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3525",
    "data-name": "Raggruppa 3525",
    transform: "translate(31.827 153.314)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4689",
    "data-name": "Tracciato 4689",
    d: "M5502.647,516.293a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.56a52.835,52.835,0,0,0-105.671-.024A54.456,54.456,0,0,1,5502.647,516.293Z",
    transform: "translate(-5233.803 -407.479)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3526",
    "data-name": "Raggruppa 3526",
    transform: "translate(30.312 157.1)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4690",
    "data-name": "Tracciato 4690",
    d: "M5500.13,522.581a54.458,54.458,0,0,1-54.382-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,5500.13,522.581Z",
    transform: "translate(-5231.288 -413.767)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3527",
    "data-name": "Raggruppa 3527",
    transform: "translate(28.797 160.887)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4691",
    "data-name": "Tracciato 4691",
    d: "M5497.613,528.868a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5497.613,528.868Z",
    transform: "translate(-5228.771 -420.054)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3528",
    "data-name": "Raggruppa 3528",
    transform: "translate(27.281 164.673)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4692",
    "data-name": "Tracciato 4692",
    d: "M5495.1,535.156a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025,52.837,52.837,0,0,0,105.673.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5495.1,535.156Z",
    transform: "translate(-5226.254 -426.342)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3529",
    "data-name": "Raggruppa 3529",
    transform: "translate(25.766 168.46)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4693",
    "data-name": "Tracciato 4693",
    d: "M5492.581,541.444a54.458,54.458,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,0,1,108.789.025,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.025A54.458,54.458,0,0,1,5492.581,541.444Z",
    transform: "translate(-5223.738 -432.63)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3530",
    "data-name": "Raggruppa 3530",
    transform: "translate(24.249 172.247)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4694",
    "data-name": "Tracciato 4694",
    d: "M5490.063,547.732a54.458,54.458,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.4,54.4,0,0,1,108.791.025,52.835,52.835,0,1,0,105.67.025,54.395,54.395,0,0,1,108.789.025h-1.559a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,5490.063,547.732Z",
    transform: "translate(-5221.219 -438.918)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3531",
    "data-name": "Raggruppa 3531",
    transform: "translate(22.734 176.033)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4695",
    "data-name": "Tracciato 4695",
    d: "M5487.547,554.019a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.673-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5487.547,554.019Z",
    transform: "translate(-5218.703 -445.205)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3532",
    "data-name": "Raggruppa 3532",
    transform: "translate(21.219 179.819)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4696",
    "data-name": "Tracciato 4696",
    d: "M5485.029,560.307a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5485.029,560.307Z",
    transform: "translate(-5216.187 -451.493)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3533",
    "data-name": "Raggruppa 3533",
    transform: "translate(19.704 183.606)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4697",
    "data-name": "Tracciato 4697",
    d: "M5482.512,566.594a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.557a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5482.512,566.594Z",
    transform: "translate(-5213.671 -457.781)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3534",
    "data-name": "Raggruppa 3534",
    transform: "translate(18.187 187.393)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4698",
    "data-name": "Tracciato 4698",
    d: "M5479.995,572.883a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025h-1.558A52.836,52.836,0,0,0,5534.4,518.5,54.456,54.456,0,0,1,5479.995,572.883Z",
    transform: "translate(-5211.152 -464.069)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3535",
    "data-name": "Raggruppa 3535",
    transform: "translate(16.672 191.179)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4699",
    "data-name": "Tracciato 4699",
    d: "M5477.48,579.169a54.456,54.456,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.837,52.837,0,0,0,105.674.024,54.394,54.394,0,1,1,108.787.025,52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.791.025h-1.56a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5477.48,579.169Z",
    transform: "translate(-5208.636 -470.356)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3536",
    "data-name": "Raggruppa 3536",
    transform: "translate(15.156 194.966)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4700",
    "data-name": "Tracciato 4700",
    d: "M5474.963,585.458a54.457,54.457,0,0,1-54.383-54.408,52.836,52.836,0,0,0-105.672-.024A54.395,54.395,0,1,1,5206.119,531h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,5474.963,585.458Z",
    transform: "translate(-5206.119 -476.644)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3537",
    "data-name": "Raggruppa 3537",
    transform: "translate(13.641 198.752)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4701",
    "data-name": "Tracciato 4701",
    d: "M5472.445,591.746a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.835,52.835,0,0,0-105.671-.025A54.458,54.458,0,0,1,5472.445,591.746Z",
    transform: "translate(-5203.604 -482.932)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3538",
    "data-name": "Raggruppa 3538",
    transform: "translate(12.125 202.539)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4702",
    "data-name": "Tracciato 4702",
    d: "M5469.929,598.034a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.025,54.395,54.395,0,1,1-108.79-.025h1.557a52.837,52.837,0,1,0,105.673.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.56a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5469.929,598.034Z",
    transform: "translate(-5201.087 -489.22)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3539",
    "data-name": "Raggruppa 3539",
    transform: "translate(10.608 206.325)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4703",
    "data-name": "Tracciato 4703",
    d: "M5467.411,604.321a54.455,54.455,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.673-.024,54.395,54.395,0,1,1-108.789-.025h1.56a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,5467.411,604.321Z",
    transform: "translate(-5198.567 -495.507)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3540",
    "data-name": "Raggruppa 3540",
    transform: "translate(9.093 210.112)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4704",
    "data-name": "Tracciato 4704",
    d: "M5464.9,610.609a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5464.9,610.609Z",
    transform: "translate(-5196.051 -501.795)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3541",
    "data-name": "Raggruppa 3541",
    transform: "translate(7.578 213.898)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4705",
    "data-name": "Tracciato 4705",
    d: "M5462.378,616.9A54.457,54.457,0,0,1,5408,562.489a52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025h-1.559a52.835,52.835,0,0,0-105.67-.025A54.458,54.458,0,0,1,5462.378,616.9Z",
    transform: "translate(-5193.536 -508.083)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3542",
    "data-name": "Raggruppa 3542",
    transform: "translate(6.062 217.685)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4706",
    "data-name": "Tracciato 4706",
    d: "M5459.861,623.185a54.458,54.458,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5459.861,623.185Z",
    transform: "translate(-5191.019 -514.371)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3543",
    "data-name": "Raggruppa 3543",
    transform: "translate(4.547 221.471)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4707",
    "data-name": "Tracciato 4707",
    d: "M5457.345,629.472a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.673-.024A54.454,54.454,0,0,1,5457.345,629.472Z",
    transform: "translate(-5188.503 -520.658)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3544",
    "data-name": "Raggruppa 3544",
    transform: "translate(3.03 225.258)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4708",
    "data-name": "Tracciato 4708",
    d: "M5454.829,635.76a54.458,54.458,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.671-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.557a52.836,52.836,0,0,0-105.672-.024A54.457,54.457,0,0,1,5454.829,635.76Z",
    transform: "translate(-5185.985 -526.946)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3545",
    "data-name": "Raggruppa 3545",
    transform: "translate(1.515 229.044)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4709",
    "data-name": "Tracciato 4709",
    d: "M5452.311,642.048a54.456,54.456,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.789-.025h1.56a52.835,52.835,0,1,0,105.671.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.79.025h-1.56a52.835,52.835,0,0,0-105.671-.025A54.457,54.457,0,0,1,5452.311,642.048Z",
    transform: "translate(-5183.468 -533.234)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3546",
    "data-name": "Raggruppa 3546",
    transform: "translate(0 232.831)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4710",
    "data-name": "Tracciato 4710",
    d: "M5449.8,648.336a54.455,54.455,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.558a52.836,52.836,0,1,0,105.672.025,54.395,54.395,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.458,54.458,0,0,1,5449.8,648.336Z",
    transform: "translate(-5180.953 -539.522)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3547",
    "data-name": "Raggruppa 3547",
    transform: "translate(1.513 236.618)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4711",
    "data-name": "Tracciato 4711",
    d: "M5452.309,654.624a54.457,54.457,0,0,1-54.384-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5452.309,654.624Z",
    transform: "translate(-5183.465 -545.81)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3548",
    "data-name": "Raggruppa 3548",
    transform: "translate(3.027 240.405)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4712",
    "data-name": "Tracciato 4712",
    d: "M5454.822,660.913a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.673.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025H5614.9a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5454.822,660.913Z",
    transform: "translate(-5185.979 -552.099)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3549",
    "data-name": "Raggruppa 3549",
    transform: "translate(4.542 244.192)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4713",
    "data-name": "Tracciato 4713",
    d: "M5457.336,667.2a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5457.336,667.2Z",
    transform: "translate(-5188.494 -558.388)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3550",
    "data-name": "Raggruppa 3550",
    transform: "translate(6.056 247.98)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4714",
    "data-name": "Tracciato 4714",
    d: "M5459.85,673.491a54.456,54.456,0,0,1-54.38-54.408,52.836,52.836,0,0,0-105.672-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.837,52.837,0,0,0,105.673.024,54.394,54.394,0,0,1,108.788.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.456,54.456,0,0,1,5459.85,673.491Z",
    transform: "translate(-5191.008 -564.677)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3551",
    "data-name": "Raggruppa 3551",
    transform: "translate(7.569 251.767)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4715",
    "data-name": "Tracciato 4715",
    d: "M5462.365,679.78a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.789-.025h1.559a52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5462.365,679.78Z",
    transform: "translate(-5193.521 -570.966)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3552",
    "data-name": "Raggruppa 3552",
    transform: "translate(9.083 255.554)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4716",
    "data-name": "Tracciato 4716",
    d: "M5464.877,686.069a54.458,54.458,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.4,54.4,0,0,1,108.79.024,52.836,52.836,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025h-1.559a52.836,52.836,0,0,0-105.673-.025A54.456,54.456,0,0,1,5464.877,686.069Z",
    transform: "translate(-5196.035 -577.255)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3553",
    "data-name": "Raggruppa 3553",
    transform: "translate(10.596 259.342)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4717",
    "data-name": "Tracciato 4717",
    d: "M5467.391,692.358a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.025A54.456,54.456,0,0,1,5467.391,692.358Z",
    transform: "translate(-5198.548 -583.544)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3554",
    "data-name": "Raggruppa 3554",
    transform: "translate(12.112 263.129)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4718",
    "data-name": "Tracciato 4718",
    d: "M5469.906,698.647a54.456,54.456,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.788-.025h1.559a52.836,52.836,0,1,0,105.671.025,54.394,54.394,0,0,1,108.788.025,52.836,52.836,0,1,0,105.673.025,54.395,54.395,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.025A54.458,54.458,0,0,1,5469.906,698.647Z",
    transform: "translate(-5201.064 -589.833)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3555",
    "data-name": "Raggruppa 3555",
    transform: "translate(13.625 266.916)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4719",
    "data-name": "Tracciato 4719",
    d: "M5472.419,704.936a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.672-.025,54.394,54.394,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.673.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.025,54.394,54.394,0,0,1,108.788.025H5632.5a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5472.419,704.936Z",
    transform: "translate(-5203.577 -596.122)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3556",
    "data-name": "Raggruppa 3556",
    transform: "translate(15.138 270.703)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4720",
    "data-name": "Tracciato 4720",
    d: "M5474.934,711.224a54.458,54.458,0,0,1-54.383-54.408,52.835,52.835,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.79-.025h1.559a52.835,52.835,0,1,0,105.671.025,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.671-.024A54.457,54.457,0,0,1,5474.934,711.224Z",
    transform: "translate(-5206.09 -602.41)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3557",
    "data-name": "Raggruppa 3557",
    transform: "translate(16.652 274.49)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4721",
    "data-name": "Tracciato 4721",
    d: "M5477.448,717.513a54.457,54.457,0,0,1-54.384-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.557a52.836,52.836,0,1,0,105.672.024,54.4,54.4,0,0,1,108.79.025,52.836,52.836,0,1,0,105.671.024,54.394,54.394,0,0,1,108.789.025h-1.558a52.836,52.836,0,0,0-105.672-.024A54.456,54.456,0,0,1,5477.448,717.513Z",
    transform: "translate(-5208.605 -608.699)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3558",
    "data-name": "Raggruppa 3558",
    transform: "translate(18.166 278.277)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4722",
    "data-name": "Tracciato 4722",
    d: "M5479.96,723.8a54.457,54.457,0,0,1-54.382-54.408,52.836,52.836,0,0,0-105.672-.024,54.394,54.394,0,1,1-108.788-.025h1.558a52.836,52.836,0,1,0,105.671.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,1,1,108.787.025h-1.557a52.836,52.836,0,0,0-105.673-.024A54.455,54.455,0,0,1,5479.96,723.8Z",
    transform: "translate(-5211.118 -614.988)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3559",
    "data-name": "Raggruppa 3559",
    transform: "translate(19.681 282.065)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4723",
    "data-name": "Tracciato 4723",
    d: "M5482.475,730.091a54.457,54.457,0,0,1-54.381-54.408,52.836,52.836,0,0,0-105.671-.024,54.395,54.395,0,1,1-108.789-.025h1.558a52.836,52.836,0,1,0,105.672.024,54.395,54.395,0,0,1,108.79.025,52.836,52.836,0,1,0,105.672.024,54.394,54.394,0,0,1,108.789.025h-1.559a52.836,52.836,0,0,0-105.672-.024A54.455,54.455,0,0,1,5482.475,730.091Z",
    transform: "translate(-5213.633 -621.277)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3560",
    "data-name": "Raggruppa 3560",
    transform: "translate(21.194 285.852)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4724",
    "data-name": "Tracciato 4724",
    d: "M5484.988,736.38a54.457,54.457,0,0,1-54.382-54.406,52.836,52.836,0,1,0-105.671-.025,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.79.025,52.835,52.835,0,1,0,105.67.025,54.395,54.395,0,1,1,108.79.025h-1.559A52.836,52.836,0,1,0,5539.4,682,54.457,54.457,0,0,1,5484.988,736.38Z",
    transform: "translate(-5216.146 -627.566)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3561",
    "data-name": "Raggruppa 3561",
    transform: "translate(22.708 289.639)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4725",
    "data-name": "Tracciato 4725",
    d: "M5487.5,742.669a54.456,54.456,0,0,1-54.382-54.407,52.836,52.836,0,1,0-105.671-.024,54.4,54.4,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.672.025,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.455,54.455,0,0,1,5487.5,742.669Z",
    transform: "translate(-5218.66 -633.855)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3562",
    "data-name": "Raggruppa 3562",
    transform: "translate(24.221 293.427)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4726",
    "data-name": "Tracciato 4726",
    d: "M5490.017,748.958a54.458,54.458,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.56a52.835,52.835,0,1,0,105.67.024,54.4,54.4,0,0,1,108.791.025,52.836,52.836,0,0,0,105.671.024,54.394,54.394,0,1,1,108.788.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5490.017,748.958Z",
    transform: "translate(-5221.173 -640.144)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3563",
    "data-name": "Raggruppa 3563",
    transform: "translate(25.736 297.214)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4727",
    "data-name": "Tracciato 4727",
    d: "M5492.532,755.247a54.457,54.457,0,0,1-54.383-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,5492.532,755.247Z",
    transform: "translate(-5223.688 -646.433)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3564",
    "data-name": "Raggruppa 3564",
    transform: "translate(27.25 301.001)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4728",
    "data-name": "Tracciato 4728",
    d: "M5495.044,761.536a54.457,54.457,0,0,1-54.381-54.406,52.836,52.836,0,1,0-105.671-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.671.024,54.395,54.395,0,1,1,108.79.025,52.836,52.836,0,0,0,105.671.024,54.4,54.4,0,0,1,108.79.025h-1.56a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5495.044,761.536Z",
    transform: "translate(-5226.202 -652.722)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3565",
    "data-name": "Raggruppa 3565",
    transform: "translate(28.764 304.788)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4729",
    "data-name": "Tracciato 4729",
    d: "M5497.558,767.825a54.456,54.456,0,0,1-54.381-54.407,52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.789-.025h1.558a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.673.024,54.394,54.394,0,1,1,108.787.025h-1.558a52.836,52.836,0,1,0-105.672-.024A54.456,54.456,0,0,1,5497.558,767.825Z",
    transform: "translate(-5228.716 -659.011)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3566",
    "data-name": "Raggruppa 3566",
    transform: "translate(30.277 308.575)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4730",
    "data-name": "Tracciato 4730",
    d: "M5500.072,774.113a54.458,54.458,0,0,1-54.383-54.406,52.836,52.836,0,1,0-105.672-.024,54.394,54.394,0,0,1-108.789-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.394,54.394,0,1,1,108.788.025,52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.024A54.457,54.457,0,0,1,5500.072,774.113Z",
    transform: "translate(-5231.228 -665.299)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3567",
    "data-name": "Raggruppa 3567",
    transform: "translate(31.791 312.362)",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4731",
    "data-name": "Tracciato 4731",
    d: "M5502.586,780.4A54.455,54.455,0,0,1,5448.2,726a52.836,52.836,0,1,0-105.672-.024,54.395,54.395,0,0,1-108.79-.025h1.559a52.836,52.836,0,0,0,105.672.024,54.395,54.395,0,1,1,108.789.025,52.836,52.836,0,0,0,105.672.025,54.394,54.394,0,1,1,108.789.025h-1.559a52.836,52.836,0,1,0-105.672-.025A54.455,54.455,0,0,1,5502.586,780.4Z",
    transform: "translate(-5233.743 -671.588)",
    fill: "#940000",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#588157",
      strokeOpacity: 1
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexture);
export default __webpack_public_path__ + "static/media/texture.012ad68ec0218f0103cefa73783e104b.svg";
export { ForwardRef as ReactComponent };